/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
!(function (e) {
  "use strict";
  function t(e) {
    var t = e.length,
      o = i.type(e);
    return (
      "function" !== o &&
      !i.isWindow(e) &&
      (!(1 !== e.nodeType || !t) ||
        "array" === o ||
        0 === t ||
        ("number" == typeof t && t > 0 && t - 1 in e))
    );
  }
  if (!e.jQuery) {
    var i = function (e, t) {
      return new i.fn.init(e, t);
    };
    (i.isWindow = function (e) {
      return e && e === e.window;
    }),
      (i.type = function (e) {
        return e
          ? "object" == typeof e || "function" == typeof e
            ? n[a.call(e)] || "object"
            : typeof e
          : e + "";
      }),
      (i.isArray =
        Array.isArray ||
        function (e) {
          return "array" === i.type(e);
        }),
      (i.isPlainObject = function (e) {
        var t;
        if (!e || "object" !== i.type(e) || e.nodeType || i.isWindow(e))
          return !1;
        try {
          if (
            e.constructor &&
            !r.call(e, "constructor") &&
            !r.call(e.constructor.prototype, "isPrototypeOf")
          )
            return !1;
        } catch (e) {
          return !1;
        }
        for (t in e);
        return void 0 === t || r.call(e, t);
      }),
      (i.each = function (e, i, o) {
        var n = 0,
          r = e.length,
          a = t(e);
        if (o) {
          if (a) for (; n < r && !1 !== i.apply(e[n], o); n++);
          else
            for (n in e)
              if (e.hasOwnProperty(n) && !1 === i.apply(e[n], o)) break;
        } else if (a) for (; n < r && !1 !== i.call(e[n], n, e[n]); n++);
        else
          for (n in e)
            if (e.hasOwnProperty(n) && !1 === i.call(e[n], n, e[n])) break;
        return e;
      }),
      (i.data = function (e, t, n) {
        if (void 0 === n) {
          var r = e[i.expando],
            a = r && o[r];
          if (void 0 === t) return a;
          if (a && t in a) return a[t];
        } else if (void 0 !== t) {
          var s = e[i.expando] || (e[i.expando] = ++i.uuid);
          return (o[s] = o[s] || {}), (o[s][t] = n), n;
        }
      }),
      (i.removeData = function (e, t) {
        var n = e[i.expando],
          r = n && o[n];
        r &&
          (t
            ? i.each(t, function (e, t) {
                delete r[t];
              })
            : delete o[n]);
      }),
      (i.extend = function () {
        var e,
          t,
          o,
          n,
          r,
          a,
          s = arguments[0] || {},
          l = 1,
          c = arguments.length,
          u = !1;
        for (
          "boolean" == typeof s && ((u = s), (s = arguments[l] || {}), l++),
            "object" != typeof s && "function" !== i.type(s) && (s = {}),
            l === c && ((s = this), l--);
          l < c;
          l++
        )
          if ((r = arguments[l]))
            for (n in r)
              r.hasOwnProperty(n) &&
                ((e = s[n]),
                (o = r[n]),
                s !== o &&
                  (u && o && (i.isPlainObject(o) || (t = i.isArray(o)))
                    ? (t
                        ? ((t = !1), (a = e && i.isArray(e) ? e : []))
                        : (a = e && i.isPlainObject(e) ? e : {}),
                      (s[n] = i.extend(u, a, o)))
                    : void 0 !== o && (s[n] = o)));
        return s;
      }),
      (i.queue = function (e, o, n) {
        if (e) {
          o = (o || "fx") + "queue";
          var r = i.data(e, o);
          return n
            ? (!r || i.isArray(n)
                ? (r = i.data(
                    e,
                    o,
                    (function (e, i) {
                      var o = [];
                      return (
                        e &&
                          (t(Object(e))
                            ? (function (e, t) {
                                for (
                                  var i = +t.length, o = 0, n = e.length;
                                  o < i;

                                )
                                  e[n++] = t[o++];
                                if (i !== i)
                                  for (; void 0 !== t[o]; ) e[n++] = t[o++];
                                e.length = n;
                              })(o, "string" == typeof e ? [e] : e)
                            : [].push.call(o, e)),
                        o
                      );
                    })(n)
                  ))
                : r.push(n),
              r)
            : r || [];
        }
      }),
      (i.dequeue = function (e, t) {
        i.each(e.nodeType ? [e] : e, function (e, o) {
          t = t || "fx";
          var n = i.queue(o, t),
            r = n.shift();
          "inprogress" === r && (r = n.shift()),
            r &&
              ("fx" === t && n.unshift("inprogress"),
              r.call(o, function () {
                i.dequeue(o, t);
              }));
        });
      }),
      (i.fn = i.prototype =
        {
          init: function (e) {
            if (e.nodeType) return (this[0] = e), this;
            throw new Error("Not a DOM node.");
          },
          offset: function () {
            var t = this[0].getBoundingClientRect
              ? this[0].getBoundingClientRect()
              : { top: 0, left: 0 };
            return {
              top:
                t.top +
                (e.pageYOffset || document.scrollTop || 0) -
                (document.clientTop || 0),
              left:
                t.left +
                (e.pageXOffset || document.scrollLeft || 0) -
                (document.clientLeft || 0),
            };
          },
          position: function () {
            var e = this[0],
              t = (function (e) {
                for (
                  var t = e.offsetParent;
                  t &&
                  "html" !== t.nodeName.toLowerCase() &&
                  t.style &&
                  "static" === t.style.position;

                )
                  t = t.offsetParent;
                return t || document;
              })(e),
              o = this.offset(),
              n = /^(?:body|html)$/i.test(t.nodeName)
                ? { top: 0, left: 0 }
                : i(t).offset();
            return (
              (o.top -= parseFloat(e.style.marginTop) || 0),
              (o.left -= parseFloat(e.style.marginLeft) || 0),
              t.style &&
                ((n.top += parseFloat(t.style.borderTopWidth) || 0),
                (n.left += parseFloat(t.style.borderLeftWidth) || 0)),
              { top: o.top - n.top, left: o.left - n.left }
            );
          },
        });
    var o = {};
    (i.expando = "velocity" + new Date().getTime()), (i.uuid = 0);
    for (
      var n = {},
        r = n.hasOwnProperty,
        a = n.toString,
        s =
          "Boolean Number String Function Array Date RegExp Object Error".split(
            " "
          ),
        l = 0;
      l < s.length;
      l++
    )
      n["[object " + s[l] + "]"] = s[l].toLowerCase();
    (i.fn.init.prototype = i.fn), (e.Velocity = { Utilities: i });
  }
})(window),
  (function (e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : e();
  })(function () {
    "use strict";
    return (function (e, t, i, o) {
      /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */ function n(
        e
      ) {
        for (var t = -1, i = e ? e.length : 0, o = []; ++t < i; ) {
          var n = e[t];
          n && o.push(n);
        }
        return o;
      }
      function r(e) {
        return b.isWrapped(e) ? (e = y.call(e)) : b.isNode(e) && (e = [e]), e;
      }
      function a(e) {
        var t = f.data(e, "velocity");
        return null === t ? o : t;
      }
      function s(e, t) {
        var i = a(e);
        i &&
          i.delayTimer &&
          !i.delayPaused &&
          ((i.delayRemaining = i.delay - t + i.delayBegin),
          (i.delayPaused = !0),
          clearTimeout(i.delayTimer.setTimeout));
      }
      function l(e, t) {
        var i = a(e);
        i &&
          i.delayTimer &&
          i.delayPaused &&
          ((i.delayPaused = !1),
          (i.delayTimer.setTimeout = setTimeout(
            i.delayTimer.next,
            i.delayRemaining
          )));
      }
      function c(e) {
        return function (t) {
          return Math.round(t * e) * (1 / e);
        };
      } /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
      function u(e, i, o, n) {
        function r(e, t) {
          return 1 - 3 * t + 3 * e;
        }
        function a(e, t) {
          return 3 * t - 6 * e;
        }
        function s(e) {
          return 3 * e;
        }
        function l(e, t, i) {
          return ((r(t, i) * e + a(t, i)) * e + s(t)) * e;
        }
        function c(e, t, i) {
          return 3 * r(t, i) * e * e + 2 * a(t, i) * e + s(t);
        }
        function u(t, i) {
          for (var n = 0; n < m; ++n) {
            var r = c(i, e, o);
            if (0 === r) return i;
            i -= (l(i, e, o) - t) / r;
          }
          return i;
        }
        function d() {
          for (var t = 0; t < w; ++t) x[t] = l(t * b, e, o);
        }
        function p(t, i, n) {
          var r,
            a,
            s = 0;
          do {
            (a = i + (n - i) / 2),
              (r = l(a, e, o) - t),
              r > 0 ? (n = a) : (i = a);
          } while (Math.abs(r) > v && ++s < y);
          return a;
        }
        function h(t) {
          for (var i = 0, n = 1, r = w - 1; n !== r && x[n] <= t; ++n) i += b;
          --n;
          var a = (t - x[n]) / (x[n + 1] - x[n]),
            s = i + a * b,
            l = c(s, e, o);
          return l >= g ? u(t, s) : 0 === l ? s : p(t, i, i + b);
        }
        function f() {
          (C = !0), (e === i && o === n) || d();
        }
        var m = 4,
          g = 0.001,
          v = 1e-7,
          y = 10,
          w = 11,
          b = 1 / (w - 1),
          _ = "Float32Array" in t;
        if (4 !== arguments.length) return !1;
        for (var k = 0; k < 4; ++k)
          if (
            "number" != typeof arguments[k] ||
            isNaN(arguments[k]) ||
            !isFinite(arguments[k])
          )
            return !1;
        (e = Math.min(e, 1)),
          (o = Math.min(o, 1)),
          (e = Math.max(e, 0)),
          (o = Math.max(o, 0));
        var x = _ ? new Float32Array(w) : new Array(w),
          C = !1,
          S = function (t) {
            return (
              C || f(),
              e === i && o === n ? t : 0 === t ? 0 : 1 === t ? 1 : l(h(t), i, n)
            );
          };
        S.getControlPoints = function () {
          return [
            { x: e, y: i },
            { x: o, y: n },
          ];
        };
        var $ = "generateBezier(" + [e, i, o, n] + ")";
        return (
          (S.toString = function () {
            return $;
          }),
          S
        );
      }
      function d(e, t) {
        var i = e;
        return (
          b.isString(e)
            ? C.Easings[e] || (i = !1)
            : (i =
                b.isArray(e) && 1 === e.length
                  ? c.apply(null, e)
                  : b.isArray(e) && 2 === e.length
                  ? S.apply(null, e.concat([t]))
                  : !(!b.isArray(e) || 4 !== e.length) && u.apply(null, e)),
          !1 === i &&
            (i = C.Easings[C.defaults.easing] ? C.defaults.easing : x),
          i
        );
      }
      function p(e) {
        if (e) {
          var t = C.timestamp && !0 !== e ? e : v.now(),
            i = C.State.calls.length;
          i > 1e4 &&
            ((C.State.calls = n(C.State.calls)), (i = C.State.calls.length));
          for (var r = 0; r < i; r++)
            if (C.State.calls[r]) {
              var s = C.State.calls[r],
                l = s[0],
                c = s[2],
                u = s[3],
                d = !!u,
                g = null,
                y = s[5],
                w = s[6];
              if ((u || (u = C.State.calls[r][3] = t - 16), y)) {
                if (!0 !== y.resume) continue;
                (u = s[3] = Math.round(t - w - 16)), (s[5] = null);
              }
              w = s[6] = t - u;
              for (
                var _ = Math.min(w / c.duration, 1), k = 0, x = l.length;
                k < x;
                k++
              ) {
                var S = l[k],
                  T = S.element;
                if (a(T)) {
                  var P = !1;
                  if (
                    c.display !== o &&
                    null !== c.display &&
                    "none" !== c.display
                  ) {
                    if ("flex" === c.display) {
                      var L = [
                        "-webkit-box",
                        "-moz-box",
                        "-ms-flexbox",
                        "-webkit-flex",
                      ];
                      f.each(L, function (e, t) {
                        $.setPropertyValue(T, "display", t);
                      });
                    }
                    $.setPropertyValue(T, "display", c.display);
                  }
                  c.visibility !== o &&
                    "hidden" !== c.visibility &&
                    $.setPropertyValue(T, "visibility", c.visibility);
                  for (var z in S)
                    if (S.hasOwnProperty(z) && "element" !== z) {
                      var V,
                        A = S[z],
                        M = b.isString(A.easing)
                          ? C.Easings[A.easing]
                          : A.easing;
                      if (b.isString(A.pattern)) {
                        var H =
                          1 === _
                            ? function (e, t, i) {
                                var o = A.endValue[t];
                                return i ? Math.round(o) : o;
                              }
                            : function (e, t, i) {
                                var o = A.startValue[t],
                                  n = A.endValue[t] - o,
                                  r = o + n * M(_, c, n);
                                return i ? Math.round(r) : r;
                              };
                        V = A.pattern.replace(/{(\d+)(!)?}/g, H);
                      } else if (1 === _) V = A.endValue;
                      else {
                        var F = A.endValue - A.startValue;
                        V = A.startValue + F * M(_, c, F);
                      }
                      if (!d && V === A.currentValue) continue;
                      if (((A.currentValue = V), "tween" === z)) g = V;
                      else {
                        var O;
                        if ($.Hooks.registered[z]) {
                          O = $.Hooks.getRoot(z);
                          var j = a(T).rootPropertyValueCache[O];
                          j && (A.rootPropertyValue = j);
                        }
                        var N = $.setPropertyValue(
                          T,
                          z,
                          A.currentValue +
                            (m < 9 && 0 === parseFloat(V) ? "" : A.unitType),
                          A.rootPropertyValue,
                          A.scrollData
                        );
                        $.Hooks.registered[z] &&
                          ($.Normalizations.registered[O]
                            ? (a(T).rootPropertyValueCache[O] =
                                $.Normalizations.registered[O](
                                  "extract",
                                  null,
                                  N[1]
                                ))
                            : (a(T).rootPropertyValueCache[O] = N[1])),
                          "transform" === N[0] && (P = !0);
                      }
                    }
                  c.mobileHA &&
                    a(T).transformCache.translate3d === o &&
                    ((a(T).transformCache.translate3d = "(0px, 0px, 0px)"),
                    (P = !0)),
                    P && $.flushTransformCache(T);
                }
              }
              c.display !== o &&
                "none" !== c.display &&
                (C.State.calls[r][2].display = !1),
                c.visibility !== o &&
                  "hidden" !== c.visibility &&
                  (C.State.calls[r][2].visibility = !1),
                c.progress &&
                  c.progress.call(
                    s[1],
                    s[1],
                    _,
                    Math.max(0, u + c.duration - t),
                    u,
                    g
                  ),
                1 === _ && h(r);
            }
        }
        C.State.isTicking && I(p);
      }
      function h(e, t) {
        if (!C.State.calls[e]) return !1;
        for (
          var i = C.State.calls[e][0],
            n = C.State.calls[e][1],
            r = C.State.calls[e][2],
            s = C.State.calls[e][4],
            l = !1,
            c = 0,
            u = i.length;
          c < u;
          c++
        ) {
          var d = i[c].element;
          t ||
            r.loop ||
            ("none" === r.display &&
              $.setPropertyValue(d, "display", r.display),
            "hidden" === r.visibility &&
              $.setPropertyValue(d, "visibility", r.visibility));
          var p = a(d);
          if (
            !0 !== r.loop &&
            (f.queue(d)[1] === o ||
              !/\.velocityQueueEntryFlag/i.test(f.queue(d)[1])) &&
            p
          ) {
            (p.isAnimating = !1), (p.rootPropertyValueCache = {});
            var h = !1;
            f.each($.Lists.transforms3D, function (e, t) {
              var i = /^scale/.test(t) ? 1 : 0,
                n = p.transformCache[t];
              p.transformCache[t] !== o &&
                new RegExp("^\\(" + i + "[^.]").test(n) &&
                ((h = !0), delete p.transformCache[t]);
            }),
              r.mobileHA && ((h = !0), delete p.transformCache.translate3d),
              h && $.flushTransformCache(d),
              $.Values.removeClass(d, "velocity-animating");
          }
          if (!t && r.complete && !r.loop && c === u - 1)
            try {
              r.complete.call(n, n);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 1);
            }
          s && !0 !== r.loop && s(n),
            p &&
              !0 === r.loop &&
              !t &&
              (f.each(p.tweensContainer, function (e, t) {
                if (
                  /^rotate/.test(e) &&
                  (parseFloat(t.startValue) - parseFloat(t.endValue)) % 360 == 0
                ) {
                  var i = t.startValue;
                  (t.startValue = t.endValue), (t.endValue = i);
                }
                /^backgroundPosition/.test(e) &&
                  100 === parseFloat(t.endValue) &&
                  "%" === t.unitType &&
                  ((t.endValue = 0), (t.startValue = 100));
              }),
              C(d, "reverse", { loop: !0, delay: r.delay })),
            !1 !== r.queue && f.dequeue(d, r.queue);
        }
        C.State.calls[e] = !1;
        for (var m = 0, g = C.State.calls.length; m < g; m++)
          if (!1 !== C.State.calls[m]) {
            l = !0;
            break;
          }
        !1 === l &&
          ((C.State.isTicking = !1),
          delete C.State.calls,
          (C.State.calls = []));
      }
      var f,
        m = (function () {
          if (i.documentMode) return i.documentMode;
          for (var e = 7; e > 4; e--) {
            var t = i.createElement("div");
            if (
              ((t.innerHTML =
                "\x3c!--[if IE " + e + "]><span></span><![endif]--\x3e"),
              t.getElementsByTagName("span").length)
            )
              return (t = null), e;
          }
          return o;
        })(),
        g = (function () {
          var e = 0;
          return (
            t.webkitRequestAnimationFrame ||
            t.mozRequestAnimationFrame ||
            function (t) {
              var i,
                o =
                  new Date().getTime(); /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
              return (
                (i = Math.max(0, 16 - (o - e))),
                (e = o + i),
                setTimeout(function () {
                  t(o + i);
                }, i)
              );
            }
          );
        })(),
        v = (function () {
          var e = t.performance || {};
          if ("function" != typeof e.now) {
            var i =
              e.timing && e.timing.navigationStart
                ? e.timing.navigationStart
                : new Date().getTime();
            e.now = function () {
              return new Date().getTime() - i;
            };
          }
          return e;
        })(),
        y = (function () {
          var e = Array.prototype.slice;
          try {
            return e.call(i.documentElement), e;
          } catch (t) {
            return function (t, i) {
              var o = this.length;
              if (
                ("number" != typeof t && (t = 0),
                "number" != typeof i && (i = o),
                this.slice)
              )
                return e.call(this, t, i);
              var n,
                r = [],
                a = t >= 0 ? t : Math.max(0, o + t),
                s = i < 0 ? o + i : Math.min(i, o),
                l = s - a;
              if (l > 0)
                if (((r = new Array(l)), this.charAt))
                  for (n = 0; n < l; n++) r[n] = this.charAt(a + n);
                else for (n = 0; n < l; n++) r[n] = this[a + n];
              return r;
            };
          }
        })(),
        w = function () {
          return Array.prototype.includes
            ? function (e, t) {
                return e.includes(t);
              }
            : Array.prototype.indexOf
            ? function (e, t) {
                return e.indexOf(t) >= 0;
              }
            : function (e, t) {
                for (var i = 0; i < e.length; i++) if (e[i] === t) return !0;
                return !1;
              };
        },
        b = {
          isNumber: function (e) {
            return "number" == typeof e;
          },
          isString: function (e) {
            return "string" == typeof e;
          },
          isArray:
            Array.isArray ||
            function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            },
          isFunction: function (e) {
            return "[object Function]" === Object.prototype.toString.call(e);
          },
          isNode: function (e) {
            return e && e.nodeType;
          },
          isWrapped: function (e) {
            return (
              e &&
              e !== t &&
              b.isNumber(e.length) &&
              !b.isString(e) &&
              !b.isFunction(e) &&
              !b.isNode(e) &&
              (0 === e.length || b.isNode(e[0]))
            );
          },
          isSVG: function (e) {
            return t.SVGElement && e instanceof t.SVGElement;
          },
          isEmptyObject: function (e) {
            for (var t in e) if (e.hasOwnProperty(t)) return !1;
            return !0;
          },
        },
        _ = !1;
      if (
        (e.fn && e.fn.jquery ? ((f = e), (_ = !0)) : (f = t.Velocity.Utilities),
        m <= 8 && !_)
      )
        throw new Error(
          "Velocity: IE8 and below require jQuery to be loaded before Velocity."
        );
      if (m <= 7) return void (jQuery.fn.velocity = jQuery.fn.animate);
      var k = 400,
        x = "swing",
        C = {
          State: {
            isMobile:
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
              ),
            isAndroid: /Android/i.test(navigator.userAgent),
            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
            isChrome: t.chrome,
            isFirefox: /Firefox/i.test(navigator.userAgent),
            prefixElement: i.createElement("div"),
            prefixMatches: {},
            scrollAnchor: null,
            scrollPropertyLeft: null,
            scrollPropertyTop: null,
            isTicking: !1,
            calls: [],
            delayedElements: { count: 0 },
          },
          CSS: {},
          Utilities: f,
          Redirects: {},
          Easings: {},
          Promise: t.Promise,
          defaults: {
            queue: "",
            duration: k,
            easing: x,
            begin: o,
            complete: o,
            progress: o,
            display: o,
            visibility: o,
            loop: !1,
            delay: !1,
            mobileHA: !0,
            _cacheValues: !0,
            promiseRejectEmpty: !0,
          },
          init: function (e) {
            f.data(e, "velocity", {
              isSVG: b.isSVG(e),
              isAnimating: !1,
              computedStyle: null,
              tweensContainer: null,
              rootPropertyValueCache: {},
              transformCache: {},
            });
          },
          hook: null,
          mock: !1,
          version: { major: 1, minor: 5, patch: 0 },
          debug: !1,
          timestamp: !0,
          pauseAll: function (e) {
            var t = new Date().getTime();
            f.each(C.State.calls, function (t, i) {
              if (i) {
                if (e !== o && (i[2].queue !== e || !1 === i[2].queue))
                  return !0;
                i[5] = { resume: !1 };
              }
            }),
              f.each(C.State.delayedElements, function (e, i) {
                i && s(i, t);
              });
          },
          resumeAll: function (e) {
            var t = new Date().getTime();
            f.each(C.State.calls, function (t, i) {
              if (i) {
                if (e !== o && (i[2].queue !== e || !1 === i[2].queue))
                  return !0;
                i[5] && (i[5].resume = !0);
              }
            }),
              f.each(C.State.delayedElements, function (e, i) {
                i && l(i, t);
              });
          },
        };
      t.pageYOffset !== o
        ? ((C.State.scrollAnchor = t),
          (C.State.scrollPropertyLeft = "pageXOffset"),
          (C.State.scrollPropertyTop = "pageYOffset"))
        : ((C.State.scrollAnchor =
            i.documentElement || i.body.parentNode || i.body),
          (C.State.scrollPropertyLeft = "scrollLeft"),
          (C.State.scrollPropertyTop =
            "scrollTop")); /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
      /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
		 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
      var S = (function () {
        function e(e) {
          return -e.tension * e.x - e.friction * e.v;
        }
        function t(t, i, o) {
          var n = {
            x: t.x + o.dx * i,
            v: t.v + o.dv * i,
            tension: t.tension,
            friction: t.friction,
          };
          return { dx: n.v, dv: e(n) };
        }
        function i(i, o) {
          var n = { dx: i.v, dv: e(i) },
            r = t(i, 0.5 * o, n),
            a = t(i, 0.5 * o, r),
            s = t(i, o, a),
            l = (1 / 6) * (n.dx + 2 * (r.dx + a.dx) + s.dx),
            c = (1 / 6) * (n.dv + 2 * (r.dv + a.dv) + s.dv);
          return (i.x = i.x + l * o), (i.v = i.v + c * o), i;
        }
        return function e(t, o, n) {
          var r,
            a,
            s,
            l = { x: -1, v: 0, tension: null, friction: null },
            c = [0],
            u = 0;
          for (
            t = parseFloat(t) || 500,
              o = parseFloat(o) || 20,
              n = n || null,
              l.tension = t,
              l.friction = o,
              r = null !== n,
              r ? ((u = e(t, o)), (a = (u / n) * 0.016)) : (a = 0.016);
            (s = i(s || l, a)),
              c.push(1 + s.x),
              (u += 16),
              Math.abs(s.x) > 1e-4 && Math.abs(s.v) > 1e-4;

          );
          return r
            ? function (e) {
                return c[(e * (c.length - 1)) | 0];
              }
            : u;
        };
      })();
      (C.Easings = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        spring: function (e) {
          return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e);
        },
      }),
        f.each(
          [
            ["ease", [0.25, 0.1, 0.25, 1]],
            ["ease-in", [0.42, 0, 1, 1]],
            ["ease-out", [0, 0, 0.58, 1]],
            ["ease-in-out", [0.42, 0, 0.58, 1]],
            ["easeInSine", [0.47, 0, 0.745, 0.715]],
            ["easeOutSine", [0.39, 0.575, 0.565, 1]],
            ["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
            ["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
            ["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
            ["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
            ["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
            ["easeOutCubic", [0.215, 0.61, 0.355, 1]],
            ["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
            ["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
            ["easeOutQuart", [0.165, 0.84, 0.44, 1]],
            ["easeInOutQuart", [0.77, 0, 0.175, 1]],
            ["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
            ["easeOutQuint", [0.23, 1, 0.32, 1]],
            ["easeInOutQuint", [0.86, 0, 0.07, 1]],
            ["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
            ["easeOutExpo", [0.19, 1, 0.22, 1]],
            ["easeInOutExpo", [1, 0, 0, 1]],
            ["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
            ["easeOutCirc", [0.075, 0.82, 0.165, 1]],
            ["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]],
          ],
          function (e, t) {
            C.Easings[t[0]] = u.apply(null, t[1]);
          }
        );
      var $ = (C.CSS = {
        RegEx: {
          isHex: /^#([A-f\d]{3}){1,2}$/i,
          valueUnwrap: /^[A-z]+\((.*)\)$/i,
          wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
          valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi,
        },
        Lists: {
          colors: [
            "fill",
            "stroke",
            "stopColor",
            "color",
            "backgroundColor",
            "borderColor",
            "borderTopColor",
            "borderRightColor",
            "borderBottomColor",
            "borderLeftColor",
            "outlineColor",
          ],
          transformsBase: [
            "translateX",
            "translateY",
            "scale",
            "scaleX",
            "scaleY",
            "skewX",
            "skewY",
            "rotateZ",
          ],
          transforms3D: [
            "transformPerspective",
            "translateZ",
            "scaleZ",
            "rotateX",
            "rotateY",
          ],
          units: [
            "%",
            "em",
            "ex",
            "ch",
            "rem",
            "vw",
            "vh",
            "vmin",
            "vmax",
            "cm",
            "mm",
            "Q",
            "in",
            "pc",
            "pt",
            "px",
            "deg",
            "grad",
            "rad",
            "turn",
            "s",
            "ms",
          ],
          colorNames: {
            aliceblue: "240,248,255",
            antiquewhite: "250,235,215",
            aquamarine: "127,255,212",
            aqua: "0,255,255",
            azure: "240,255,255",
            beige: "245,245,220",
            bisque: "255,228,196",
            black: "0,0,0",
            blanchedalmond: "255,235,205",
            blueviolet: "138,43,226",
            blue: "0,0,255",
            brown: "165,42,42",
            burlywood: "222,184,135",
            cadetblue: "95,158,160",
            chartreuse: "127,255,0",
            chocolate: "210,105,30",
            coral: "255,127,80",
            cornflowerblue: "100,149,237",
            cornsilk: "255,248,220",
            crimson: "220,20,60",
            cyan: "0,255,255",
            darkblue: "0,0,139",
            darkcyan: "0,139,139",
            darkgoldenrod: "184,134,11",
            darkgray: "169,169,169",
            darkgrey: "169,169,169",
            darkgreen: "0,100,0",
            darkkhaki: "189,183,107",
            darkmagenta: "139,0,139",
            darkolivegreen: "85,107,47",
            darkorange: "255,140,0",
            darkorchid: "153,50,204",
            darkred: "139,0,0",
            darksalmon: "233,150,122",
            darkseagreen: "143,188,143",
            darkslateblue: "72,61,139",
            darkslategray: "47,79,79",
            darkturquoise: "0,206,209",
            darkviolet: "148,0,211",
            deeppink: "255,20,147",
            deepskyblue: "0,191,255",
            dimgray: "105,105,105",
            dimgrey: "105,105,105",
            dodgerblue: "30,144,255",
            firebrick: "178,34,34",
            floralwhite: "255,250,240",
            forestgreen: "34,139,34",
            fuchsia: "255,0,255",
            gainsboro: "220,220,220",
            ghostwhite: "248,248,255",
            gold: "255,215,0",
            goldenrod: "218,165,32",
            gray: "128,128,128",
            grey: "128,128,128",
            greenyellow: "173,255,47",
            green: "0,128,0",
            honeydew: "240,255,240",
            hotpink: "255,105,180",
            indianred: "205,92,92",
            indigo: "75,0,130",
            ivory: "255,255,240",
            khaki: "240,230,140",
            lavenderblush: "255,240,245",
            lavender: "230,230,250",
            lawngreen: "124,252,0",
            lemonchiffon: "255,250,205",
            lightblue: "173,216,230",
            lightcoral: "240,128,128",
            lightcyan: "224,255,255",
            lightgoldenrodyellow: "250,250,210",
            lightgray: "211,211,211",
            lightgrey: "211,211,211",
            lightgreen: "144,238,144",
            lightpink: "255,182,193",
            lightsalmon: "255,160,122",
            lightseagreen: "32,178,170",
            lightskyblue: "135,206,250",
            lightslategray: "119,136,153",
            lightsteelblue: "176,196,222",
            lightyellow: "255,255,224",
            limegreen: "50,205,50",
            lime: "0,255,0",
            linen: "250,240,230",
            magenta: "255,0,255",
            maroon: "128,0,0",
            mediumaquamarine: "102,205,170",
            mediumblue: "0,0,205",
            mediumorchid: "186,85,211",
            mediumpurple: "147,112,219",
            mediumseagreen: "60,179,113",
            mediumslateblue: "123,104,238",
            mediumspringgreen: "0,250,154",
            mediumturquoise: "72,209,204",
            mediumvioletred: "199,21,133",
            midnightblue: "25,25,112",
            mintcream: "245,255,250",
            mistyrose: "255,228,225",
            moccasin: "255,228,181",
            navajowhite: "255,222,173",
            navy: "0,0,128",
            oldlace: "253,245,230",
            olivedrab: "107,142,35",
            olive: "128,128,0",
            orangered: "255,69,0",
            orange: "255,165,0",
            orchid: "218,112,214",
            palegoldenrod: "238,232,170",
            palegreen: "152,251,152",
            paleturquoise: "175,238,238",
            palevioletred: "219,112,147",
            papayawhip: "255,239,213",
            peachpuff: "255,218,185",
            peru: "205,133,63",
            pink: "255,192,203",
            plum: "221,160,221",
            powderblue: "176,224,230",
            purple: "128,0,128",
            red: "255,0,0",
            rosybrown: "188,143,143",
            royalblue: "65,105,225",
            saddlebrown: "139,69,19",
            salmon: "250,128,114",
            sandybrown: "244,164,96",
            seagreen: "46,139,87",
            seashell: "255,245,238",
            sienna: "160,82,45",
            silver: "192,192,192",
            skyblue: "135,206,235",
            slateblue: "106,90,205",
            slategray: "112,128,144",
            snow: "255,250,250",
            springgreen: "0,255,127",
            steelblue: "70,130,180",
            tan: "210,180,140",
            teal: "0,128,128",
            thistle: "216,191,216",
            tomato: "255,99,71",
            turquoise: "64,224,208",
            violet: "238,130,238",
            wheat: "245,222,179",
            whitesmoke: "245,245,245",
            white: "255,255,255",
            yellowgreen: "154,205,50",
            yellow: "255,255,0",
          },
        },
        Hooks: {
          templates: {
            textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
            boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
            clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
            backgroundPosition: ["X Y", "0% 0%"],
            transformOrigin: ["X Y Z", "50% 50% 0px"],
            perspectiveOrigin: ["X Y", "50% 50%"],
          },
          registered: {},
          register: function () {
            for (var e = 0; e < $.Lists.colors.length; e++) {
              var t =
                "color" === $.Lists.colors[e] ? "0 0 0 1" : "255 255 255 1";
              $.Hooks.templates[$.Lists.colors[e]] = [
                "Red Green Blue Alpha",
                t,
              ];
            }
            var i, o, n;
            if (m)
              for (i in $.Hooks.templates)
                if ($.Hooks.templates.hasOwnProperty(i)) {
                  (o = $.Hooks.templates[i]), (n = o[0].split(" "));
                  var r = o[1].match($.RegEx.valueSplit);
                  "Color" === n[0] &&
                    (n.push(n.shift()),
                    r.push(r.shift()),
                    ($.Hooks.templates[i] = [n.join(" "), r.join(" ")]));
                }
            for (i in $.Hooks.templates)
              if ($.Hooks.templates.hasOwnProperty(i)) {
                (o = $.Hooks.templates[i]), (n = o[0].split(" "));
                for (var a in n)
                  if (n.hasOwnProperty(a)) {
                    var s = i + n[a],
                      l = a;
                    $.Hooks.registered[s] = [i, l];
                  }
              }
          },
          getRoot: function (e) {
            var t = $.Hooks.registered[e];
            return t ? t[0] : e;
          },
          getUnit: function (e, t) {
            var i = (e.substr(t || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
            return i && w($.Lists.units, i) ? i : "";
          },
          fixColors: function (e) {
            return e.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function (e, t, i) {
              return $.Lists.colorNames.hasOwnProperty(i)
                ? (t || "rgba(") + $.Lists.colorNames[i] + (t ? "" : ",1)")
                : t + i;
            });
          },
          cleanRootPropertyValue: function (e, t) {
            return (
              $.RegEx.valueUnwrap.test(t) &&
                (t = t.match($.RegEx.valueUnwrap)[1]),
              $.Values.isCSSNullValue(t) && (t = $.Hooks.templates[e][1]),
              t
            );
          },
          extractValue: function (e, t) {
            var i = $.Hooks.registered[e];
            if (i) {
              var o = i[0],
                n = i[1];
              return (
                (t = $.Hooks.cleanRootPropertyValue(o, t)),
                t.toString().match($.RegEx.valueSplit)[n]
              );
            }
            return t;
          },
          injectValue: function (e, t, i) {
            var o = $.Hooks.registered[e];
            if (o) {
              var n,
                r = o[0],
                a = o[1];
              return (
                (i = $.Hooks.cleanRootPropertyValue(r, i)),
                (n = i.toString().match($.RegEx.valueSplit)),
                (n[a] = t),
                n.join(" ")
              );
            }
            return i;
          },
        },
        Normalizations: {
          registered: {
            clip: function (e, t, i) {
              switch (e) {
                case "name":
                  return "clip";
                case "extract":
                  var o;
                  return (
                    $.RegEx.wrappedValueAlreadyExtracted.test(i)
                      ? (o = i)
                      : ((o = i.toString().match($.RegEx.valueUnwrap)),
                        (o = o ? o[1].replace(/,(\s+)?/g, " ") : i)),
                    o
                  );
                case "inject":
                  return "rect(" + i + ")";
              }
            },
            blur: function (e, t, i) {
              switch (e) {
                case "name":
                  return C.State.isFirefox ? "filter" : "-webkit-filter";
                case "extract":
                  var o = parseFloat(i);
                  if (!o && 0 !== o) {
                    var n = i.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                    o = n ? n[1] : 0;
                  }
                  return o;
                case "inject":
                  return parseFloat(i) ? "blur(" + i + ")" : "none";
              }
            },
            opacity: function (e, t, i) {
              if (m <= 8)
                switch (e) {
                  case "name":
                    return "filter";
                  case "extract":
                    var o = i.toString().match(/alpha\(opacity=(.*)\)/i);
                    return (i = o ? o[1] / 100 : 1);
                  case "inject":
                    return (
                      (t.style.zoom = 1),
                      parseFloat(i) >= 1
                        ? ""
                        : "alpha(opacity=" +
                          parseInt(100 * parseFloat(i), 10) +
                          ")"
                    );
                }
              else
                switch (e) {
                  case "name":
                    return "opacity";
                  case "extract":
                  case "inject":
                    return i;
                }
            },
          },
          register: function () {
            function e(e, t, i) {
              if (
                ("border-box" ===
                  $.getPropertyValue(t, "boxSizing")
                    .toString()
                    .toLowerCase()) ===
                (i || !1)
              ) {
                var o,
                  n,
                  r = 0,
                  a = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"],
                  s = [
                    "padding" + a[0],
                    "padding" + a[1],
                    "border" + a[0] + "Width",
                    "border" + a[1] + "Width",
                  ];
                for (o = 0; o < s.length; o++)
                  (n = parseFloat($.getPropertyValue(t, s[o]))),
                    isNaN(n) || (r += n);
                return i ? -r : r;
              }
              return 0;
            }
            function t(t, i) {
              return function (o, n, r) {
                switch (o) {
                  case "name":
                    return t;
                  case "extract":
                    return parseFloat(r) + e(t, n, i);
                  case "inject":
                    return parseFloat(r) - e(t, n, i) + "px";
                }
              };
            }
            (m && !(m > 9)) ||
              C.State.isGingerbread ||
              ($.Lists.transformsBase = $.Lists.transformsBase.concat(
                $.Lists.transforms3D
              ));
            for (var i = 0; i < $.Lists.transformsBase.length; i++)
              !(function () {
                var e = $.Lists.transformsBase[i];
                $.Normalizations.registered[e] = function (t, i, n) {
                  switch (t) {
                    case "name":
                      return "transform";
                    case "extract":
                      return a(i) === o || a(i).transformCache[e] === o
                        ? /^scale/i.test(e)
                          ? 1
                          : 0
                        : a(i).transformCache[e].replace(/[()]/g, "");
                    case "inject":
                      var r = !1;
                      switch (e.substr(0, e.length - 1)) {
                        case "translate":
                          r = !/(%|px|em|rem|vw|vh|\d)$/i.test(n);
                          break;
                        case "scal":
                        case "scale":
                          C.State.isAndroid &&
                            a(i).transformCache[e] === o &&
                            n < 1 &&
                            (n = 1),
                            (r = !/(\d)$/i.test(n));
                          break;
                        case "skew":
                        case "rotate":
                          r = !/(deg|\d)$/i.test(n);
                      }
                      return (
                        r || (a(i).transformCache[e] = "(" + n + ")"),
                        a(i).transformCache[e]
                      );
                  }
                };
              })();
            for (var n = 0; n < $.Lists.colors.length; n++)
              !(function () {
                var e = $.Lists.colors[n];
                $.Normalizations.registered[e] = function (t, i, n) {
                  switch (t) {
                    case "name":
                      return e;
                    case "extract":
                      var r;
                      if ($.RegEx.wrappedValueAlreadyExtracted.test(n)) r = n;
                      else {
                        var a,
                          s = {
                            black: "rgb(0, 0, 0)",
                            blue: "rgb(0, 0, 255)",
                            gray: "rgb(128, 128, 128)",
                            green: "rgb(0, 128, 0)",
                            red: "rgb(255, 0, 0)",
                            white: "rgb(255, 255, 255)",
                          };
                        /^[A-z]+$/i.test(n)
                          ? (a = s[n] !== o ? s[n] : s.black)
                          : $.RegEx.isHex.test(n)
                          ? (a = "rgb(" + $.Values.hexToRgb(n).join(" ") + ")")
                          : /^rgba?\(/i.test(n) || (a = s.black),
                          (r = (a || n)
                            .toString()
                            .match($.RegEx.valueUnwrap)[1]
                            .replace(/,(\s+)?/g, " "));
                      }
                      return (
                        (!m || m > 8) &&
                          3 === r.split(" ").length &&
                          (r += " 1"),
                        r
                      );
                    case "inject":
                      return /^rgb/.test(n)
                        ? n
                        : (m <= 8
                            ? 4 === n.split(" ").length &&
                              (n = n.split(/\s+/).slice(0, 3).join(" "))
                            : 3 === n.split(" ").length && (n += " 1"),
                          (m <= 8 ? "rgb" : "rgba") +
                            "(" +
                            n
                              .replace(/\s+/g, ",")
                              .replace(/\.(\d)+(?=,)/g, "") +
                            ")");
                  }
                };
              })();
            ($.Normalizations.registered.innerWidth = t("width", !0)),
              ($.Normalizations.registered.innerHeight = t("height", !0)),
              ($.Normalizations.registered.outerWidth = t("width")),
              ($.Normalizations.registered.outerHeight = t("height"));
          },
        },
        Names: {
          camelCase: function (e) {
            return e.replace(/-(\w)/g, function (e, t) {
              return t.toUpperCase();
            });
          },
          SVGAttribute: function (e) {
            var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
            return (
              (m || (C.State.isAndroid && !C.State.isChrome)) &&
                (t += "|transform"),
              new RegExp("^(" + t + ")$", "i").test(e)
            );
          },
          prefixCheck: function (e) {
            if (C.State.prefixMatches[e]) return [C.State.prefixMatches[e], !0];
            for (
              var t = ["", "Webkit", "Moz", "ms", "O"], i = 0, o = t.length;
              i < o;
              i++
            ) {
              var n;
              if (
                ((n =
                  0 === i
                    ? e
                    : t[i] +
                      e.replace(/^\w/, function (e) {
                        return e.toUpperCase();
                      })),
                b.isString(C.State.prefixElement.style[n]))
              )
                return (C.State.prefixMatches[e] = n), [n, !0];
            }
            return [e, !1];
          },
        },
        Values: {
          /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
          hexToRgb: function (e) {
            var t,
              i = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
              o = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
            return (
              (e = e.replace(i, function (e, t, i, o) {
                return t + t + i + i + o + o;
              })),
              (t = o.exec(e)),
              t
                ? [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)]
                : [0, 0, 0]
            );
          },
          isCSSNullValue: function (e) {
            return (
              !e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
            );
          },
          getUnitType: function (e) {
            return /^(rotate|skew)/i.test(e)
              ? "deg"
              : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(
                  e
                )
              ? ""
              : "px";
          },
          getDisplayType: function (e) {
            var t = e && e.tagName.toString().toLowerCase();
            return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(
              t
            )
              ? "inline"
              : /^(li)$/i.test(t)
              ? "list-item"
              : /^(tr)$/i.test(t)
              ? "table-row"
              : /^(table)$/i.test(t)
              ? "table"
              : /^(tbody)$/i.test(t)
              ? "table-row-group"
              : "block";
          },
          addClass: function (e, t) {
            if (e)
              if (e.classList) e.classList.add(t);
              else if (b.isString(e.className))
                e.className += (e.className.length ? " " : "") + t;
              else {
                var i = e.getAttribute(m <= 7 ? "className" : "class") || "";
                e.setAttribute("class", i + (i ? " " : "") + t);
              }
          },
          removeClass: function (e, t) {
            if (e)
              if (e.classList) e.classList.remove(t);
              else if (b.isString(e.className))
                e.className = e.className
                  .toString()
                  .replace(
                    new RegExp(
                      "(^|\\s)" + t.split(" ").join("|") + "(\\s|$)",
                      "gi"
                    ),
                    " "
                  );
              else {
                var i = e.getAttribute(m <= 7 ? "className" : "class") || "";
                e.setAttribute(
                  "class",
                  i.replace(
                    new RegExp(
                      "(^|s)" + t.split(" ").join("|") + "(s|$)",
                      "gi"
                    ),
                    " "
                  )
                );
              }
          },
        },
        getPropertyValue: function (e, i, n, r) {
          function s(e, i) {
            var n = 0;
            if (m <= 8) n = f.css(e, i);
            else {
              var l = !1;
              /^(width|height)$/.test(i) &&
                0 === $.getPropertyValue(e, "display") &&
                ((l = !0),
                $.setPropertyValue(e, "display", $.Values.getDisplayType(e)));
              var c = function () {
                l && $.setPropertyValue(e, "display", "none");
              };
              if (!r) {
                if (
                  "height" === i &&
                  "border-box" !==
                    $.getPropertyValue(e, "boxSizing").toString().toLowerCase()
                ) {
                  var u =
                    e.offsetHeight -
                    (parseFloat($.getPropertyValue(e, "borderTopWidth")) || 0) -
                    (parseFloat($.getPropertyValue(e, "borderBottomWidth")) ||
                      0) -
                    (parseFloat($.getPropertyValue(e, "paddingTop")) || 0) -
                    (parseFloat($.getPropertyValue(e, "paddingBottom")) || 0);
                  return c(), u;
                }
                if (
                  "width" === i &&
                  "border-box" !==
                    $.getPropertyValue(e, "boxSizing").toString().toLowerCase()
                ) {
                  var d =
                    e.offsetWidth -
                    (parseFloat($.getPropertyValue(e, "borderLeftWidth")) ||
                      0) -
                    (parseFloat($.getPropertyValue(e, "borderRightWidth")) ||
                      0) -
                    (parseFloat($.getPropertyValue(e, "paddingLeft")) || 0) -
                    (parseFloat($.getPropertyValue(e, "paddingRight")) || 0);
                  return c(), d;
                }
              }
              var p;
              (p =
                a(e) === o
                  ? t.getComputedStyle(e, null)
                  : a(e).computedStyle
                  ? a(e).computedStyle
                  : (a(e).computedStyle = t.getComputedStyle(e, null))),
                "borderColor" === i && (i = "borderTopColor"),
                (n = 9 === m && "filter" === i ? p.getPropertyValue(i) : p[i]),
                ("" !== n && null !== n) || (n = e.style[i]),
                c();
            }
            if ("auto" === n && /^(top|right|bottom|left)$/i.test(i)) {
              var h = s(e, "position");
              ("fixed" === h || ("absolute" === h && /top|left/i.test(i))) &&
                (n = f(e).position()[i] + "px");
            }
            return n;
          }
          var l;
          if ($.Hooks.registered[i]) {
            var c = i,
              u = $.Hooks.getRoot(c);
            n === o && (n = $.getPropertyValue(e, $.Names.prefixCheck(u)[0])),
              $.Normalizations.registered[u] &&
                (n = $.Normalizations.registered[u]("extract", e, n)),
              (l = $.Hooks.extractValue(c, n));
          } else if ($.Normalizations.registered[i]) {
            var d, p;
            (d = $.Normalizations.registered[i]("name", e)),
              "transform" !== d &&
                ((p = s(e, $.Names.prefixCheck(d)[0])),
                $.Values.isCSSNullValue(p) &&
                  $.Hooks.templates[i] &&
                  (p = $.Hooks.templates[i][1])),
              (l = $.Normalizations.registered[i]("extract", e, p));
          }
          if (!/^[\d-]/.test(l)) {
            var h = a(e);
            if (h && h.isSVG && $.Names.SVGAttribute(i))
              if (/^(height|width)$/i.test(i))
                try {
                  l = e.getBBox()[i];
                } catch (e) {
                  l = 0;
                }
              else l = e.getAttribute(i);
            else l = s(e, $.Names.prefixCheck(i)[0]);
          }
          return (
            $.Values.isCSSNullValue(l) && (l = 0),
            C.debug >= 2 && console.log("Get " + i + ": " + l),
            l
          );
        },
        setPropertyValue: function (e, i, o, n, r) {
          var s = i;
          if ("scroll" === i)
            r.container
              ? (r.container["scroll" + r.direction] = o)
              : "Left" === r.direction
              ? t.scrollTo(o, r.alternateValue)
              : t.scrollTo(r.alternateValue, o);
          else if (
            $.Normalizations.registered[i] &&
            "transform" === $.Normalizations.registered[i]("name", e)
          )
            $.Normalizations.registered[i]("inject", e, o),
              (s = "transform"),
              (o = a(e).transformCache[i]);
          else {
            if ($.Hooks.registered[i]) {
              var l = i,
                c = $.Hooks.getRoot(i);
              (n = n || $.getPropertyValue(e, c)),
                (o = $.Hooks.injectValue(l, o, n)),
                (i = c);
            }
            if (
              ($.Normalizations.registered[i] &&
                ((o = $.Normalizations.registered[i]("inject", e, o)),
                (i = $.Normalizations.registered[i]("name", e))),
              (s = $.Names.prefixCheck(i)[0]),
              m <= 8)
            )
              try {
                e.style[s] = o;
              } catch (e) {
                C.debug &&
                  console.log(
                    "Browser does not support [" + o + "] for [" + s + "]"
                  );
              }
            else {
              var u = a(e);
              u && u.isSVG && $.Names.SVGAttribute(i)
                ? e.setAttribute(i, o)
                : (e.style[s] = o);
            }
            C.debug >= 2 && console.log("Set " + i + " (" + s + "): " + o);
          }
          return [s, o];
        },
        flushTransformCache: function (e) {
          var t = "",
            i = a(e);
          if ((m || (C.State.isAndroid && !C.State.isChrome)) && i && i.isSVG) {
            var o = function (t) {
                return parseFloat($.getPropertyValue(e, t));
              },
              n = {
                translate: [o("translateX"), o("translateY")],
                skewX: [o("skewX")],
                skewY: [o("skewY")],
                scale:
                  1 !== o("scale")
                    ? [o("scale"), o("scale")]
                    : [o("scaleX"), o("scaleY")],
                rotate: [o("rotateZ"), 0, 0],
              };
            f.each(a(e).transformCache, function (e) {
              /^translate/i.test(e)
                ? (e = "translate")
                : /^scale/i.test(e)
                ? (e = "scale")
                : /^rotate/i.test(e) && (e = "rotate"),
                n[e] && ((t += e + "(" + n[e].join(" ") + ") "), delete n[e]);
            });
          } else {
            var r, s;
            f.each(a(e).transformCache, function (i) {
              if (((r = a(e).transformCache[i]), "transformPerspective" === i))
                return (s = r), !0;
              9 === m && "rotateZ" === i && (i = "rotate"), (t += i + r + " ");
            }),
              s && (t = "perspective" + s + " " + t);
          }
          $.setPropertyValue(e, "transform", t);
        },
      });
      $.Hooks.register(),
        $.Normalizations.register(),
        (C.hook = function (e, t, i) {
          var n;
          return (
            (e = r(e)),
            f.each(e, function (e, r) {
              if ((a(r) === o && C.init(r), i === o))
                n === o && (n = $.getPropertyValue(r, t));
              else {
                var s = $.setPropertyValue(r, t, i);
                "transform" === s[0] && C.CSS.flushTransformCache(r), (n = s);
              }
            }),
            n
          );
        });
      var T = function () {
        function e() {
          return u ? S.promise || null : m;
        }
        function n(e, n) {
          function r(r) {
            var u, h;
            if (l.begin && 0 === P)
              try {
                l.begin.call(v, v);
              } catch (e) {
                setTimeout(function () {
                  throw e;
                }, 1);
              }
            if ("scroll" === V) {
              var m,
                g,
                k,
                x = /^x$/i.test(l.axis) ? "Left" : "Top",
                T = parseFloat(l.offset) || 0;
              l.container
                ? b.isWrapped(l.container) || b.isNode(l.container)
                  ? ((l.container = l.container[0] || l.container),
                    (m = l.container["scroll" + x]),
                    (k = m + f(e).position()[x.toLowerCase()] + T))
                  : (l.container = null)
                : ((m = C.State.scrollAnchor[C.State["scrollProperty" + x]]),
                  (g =
                    C.State.scrollAnchor[
                      C.State[
                        "scrollProperty" + ("Left" === x ? "Top" : "Left")
                      ]
                    ]),
                  (k = f(e).offset()[x.toLowerCase()] + T)),
                (c = {
                  scroll: {
                    rootPropertyValue: !1,
                    startValue: m,
                    currentValue: m,
                    endValue: k,
                    unitType: "",
                    easing: l.easing,
                    scrollData: {
                      container: l.container,
                      direction: x,
                      alternateValue: g,
                    },
                  },
                  element: e,
                }),
                C.debug &&
                  console.log("tweensContainer (scroll): ", c.scroll, e);
            } else if ("reverse" === V) {
              if (!(u = a(e))) return;
              if (!u.tweensContainer) return void f.dequeue(e, l.queue);
              "none" === u.opts.display && (u.opts.display = "auto"),
                "hidden" === u.opts.visibility &&
                  (u.opts.visibility = "visible"),
                (u.opts.loop = !1),
                (u.opts.begin = null),
                (u.opts.complete = null),
                _.easing || delete l.easing,
                _.duration || delete l.duration,
                (l = f.extend({}, u.opts, l)),
                (h = f.extend(!0, {}, u ? u.tweensContainer : null));
              for (var L in h)
                if (h.hasOwnProperty(L) && "element" !== L) {
                  var z = h[L].startValue;
                  (h[L].startValue = h[L].currentValue = h[L].endValue),
                    (h[L].endValue = z),
                    b.isEmptyObject(_) || (h[L].easing = l.easing),
                    C.debug &&
                      console.log(
                        "reverse tweensContainer (" +
                          L +
                          "): " +
                          JSON.stringify(h[L]),
                        e
                      );
                }
              c = h;
            } else if ("start" === V) {
              (u = a(e)) &&
                u.tweensContainer &&
                !0 === u.isAnimating &&
                (h = u.tweensContainer);
              var A = function (n, r) {
                var a,
                  d = $.Hooks.getRoot(n),
                  p = !1,
                  m = r[0],
                  g = r[1],
                  v = r[2];
                if (
                  !(
                    (u && u.isSVG) ||
                    "tween" === d ||
                    !1 !== $.Names.prefixCheck(d)[1] ||
                    $.Normalizations.registered[d] !== o
                  )
                )
                  return void (
                    C.debug &&
                    console.log(
                      "Skipping [" + d + "] due to a lack of browser support."
                    )
                  );
                ((l.display !== o &&
                  null !== l.display &&
                  "none" !== l.display) ||
                  (l.visibility !== o && "hidden" !== l.visibility)) &&
                  /opacity|filter/.test(n) &&
                  !v &&
                  0 !== m &&
                  (v = 0),
                  l._cacheValues && h && h[n]
                    ? (v === o && (v = h[n].endValue + h[n].unitType),
                      (p = u.rootPropertyValueCache[d]))
                    : $.Hooks.registered[n]
                    ? v === o
                      ? ((p = $.getPropertyValue(e, d)),
                        (v = $.getPropertyValue(e, n, p)))
                      : (p = $.Hooks.templates[d][1])
                    : v === o && (v = $.getPropertyValue(e, n));
                var y,
                  w,
                  _,
                  k = !1,
                  x = function (e, t) {
                    var i, o;
                    return (
                      (o = (t || "0")
                        .toString()
                        .toLowerCase()
                        .replace(/[%A-z]+$/, function (e) {
                          return (i = e), "";
                        })),
                      i || (i = $.Values.getUnitType(e)),
                      [o, i]
                    );
                  };
                if (v !== m && b.isString(v) && b.isString(m)) {
                  a = "";
                  var S = 0,
                    T = 0,
                    I = [],
                    P = [],
                    L = 0,
                    z = 0,
                    V = 0;
                  for (
                    v = $.Hooks.fixColors(v), m = $.Hooks.fixColors(m);
                    S < v.length && T < m.length;

                  ) {
                    var A = v[S],
                      M = m[T];
                    if (/[\d\.-]/.test(A) && /[\d\.-]/.test(M)) {
                      for (
                        var H = A, F = M, O = ".", N = ".";
                        ++S < v.length;

                      ) {
                        if ((A = v[S]) === O) O = "..";
                        else if (!/\d/.test(A)) break;
                        H += A;
                      }
                      for (; ++T < m.length; ) {
                        if ((M = m[T]) === N) N = "..";
                        else if (!/\d/.test(M)) break;
                        F += M;
                      }
                      var q = $.Hooks.getUnit(v, S),
                        E = $.Hooks.getUnit(m, T);
                      if (((S += q.length), (T += E.length), q === E))
                        H === F
                          ? (a += H + q)
                          : ((a += "{" + I.length + (z ? "!" : "") + "}" + q),
                            I.push(parseFloat(H)),
                            P.push(parseFloat(F)));
                      else {
                        var D = parseFloat(H),
                          W = parseFloat(F);
                        (a +=
                          (L < 5 ? "calc" : "") +
                          "(" +
                          (D ? "{" + I.length + (z ? "!" : "") + "}" : "0") +
                          q +
                          " + " +
                          (W
                            ? "{" +
                              (I.length + (D ? 1 : 0)) +
                              (z ? "!" : "") +
                              "}"
                            : "0") +
                          E +
                          ")"),
                          D && (I.push(D), P.push(0)),
                          W && (I.push(0), P.push(W));
                      }
                    } else {
                      if (A !== M) {
                        L = 0;
                        break;
                      }
                      (a += A),
                        S++,
                        T++,
                        (0 === L && "c" === A) ||
                        (1 === L && "a" === A) ||
                        (2 === L && "l" === A) ||
                        (3 === L && "c" === A) ||
                        (L >= 4 && "(" === A)
                          ? L++
                          : ((L && L < 5) ||
                              (L >= 4 && ")" === A && --L < 5)) &&
                            (L = 0),
                        (0 === z && "r" === A) ||
                        (1 === z && "g" === A) ||
                        (2 === z && "b" === A) ||
                        (3 === z && "a" === A) ||
                        (z >= 3 && "(" === A)
                          ? (3 === z && "a" === A && (V = 1), z++)
                          : V && "," === A
                          ? ++V > 3 && (z = V = 0)
                          : ((V && z < (V ? 5 : 4)) ||
                              (z >= (V ? 4 : 3) &&
                                ")" === A &&
                                --z < (V ? 5 : 4))) &&
                            (z = V = 0);
                    }
                  }
                  (S === v.length && T === m.length) ||
                    (C.debug &&
                      console.error(
                        'Trying to pattern match mis-matched strings ["' +
                          m +
                          '", "' +
                          v +
                          '"]'
                      ),
                    (a = o)),
                    a &&
                      (I.length
                        ? (C.debug &&
                            console.log(
                              'Pattern found "' + a + '" -> ',
                              I,
                              P,
                              "[" + v + "," + m + "]"
                            ),
                          (v = I),
                          (m = P),
                          (w = _ = ""))
                        : (a = o));
                }
                if (
                  (a ||
                    ((y = x(n, v)),
                    (v = y[0]),
                    (_ = y[1]),
                    (y = x(n, m)),
                    (m = y[0].replace(/^([+-\/*])=/, function (e, t) {
                      return (k = t), "";
                    })),
                    (w = y[1]),
                    (v = parseFloat(v) || 0),
                    (m = parseFloat(m) || 0),
                    "%" === w &&
                      (/^(fontSize|lineHeight)$/.test(n)
                        ? ((m /= 100), (w = "em"))
                        : /^scale/.test(n)
                        ? ((m /= 100), (w = ""))
                        : /(Red|Green|Blue)$/i.test(n) &&
                          ((m = (m / 100) * 255), (w = "")))),
                  /[\/*]/.test(k))
                )
                  w = _;
                else if (_ !== w && 0 !== v)
                  if (0 === m) w = _;
                  else {
                    s =
                      s ||
                      (function () {
                        var o = {
                            myParent: e.parentNode || i.body,
                            position: $.getPropertyValue(e, "position"),
                            fontSize: $.getPropertyValue(e, "fontSize"),
                          },
                          n =
                            o.position === j.lastPosition &&
                            o.myParent === j.lastParent,
                          r = o.fontSize === j.lastFontSize;
                        (j.lastParent = o.myParent),
                          (j.lastPosition = o.position),
                          (j.lastFontSize = o.fontSize);
                        var a = {};
                        if (r && n)
                          (a.emToPx = j.lastEmToPx),
                            (a.percentToPxWidth = j.lastPercentToPxWidth),
                            (a.percentToPxHeight = j.lastPercentToPxHeight);
                        else {
                          var s =
                            u && u.isSVG
                              ? i.createElementNS(
                                  "http://www.w3.org/2000/svg",
                                  "rect"
                                )
                              : i.createElement("div");
                          C.init(s),
                            o.myParent.appendChild(s),
                            f.each(
                              ["overflow", "overflowX", "overflowY"],
                              function (e, t) {
                                C.CSS.setPropertyValue(s, t, "hidden");
                              }
                            ),
                            C.CSS.setPropertyValue(s, "position", o.position),
                            C.CSS.setPropertyValue(s, "fontSize", o.fontSize),
                            C.CSS.setPropertyValue(
                              s,
                              "boxSizing",
                              "content-box"
                            ),
                            f.each(
                              [
                                "minWidth",
                                "maxWidth",
                                "width",
                                "minHeight",
                                "maxHeight",
                                "height",
                              ],
                              function (e, t) {
                                C.CSS.setPropertyValue(s, t, "100%");
                              }
                            ),
                            C.CSS.setPropertyValue(s, "paddingLeft", "100em"),
                            (a.percentToPxWidth = j.lastPercentToPxWidth =
                              (parseFloat(
                                $.getPropertyValue(s, "width", null, !0)
                              ) || 1) / 100),
                            (a.percentToPxHeight = j.lastPercentToPxHeight =
                              (parseFloat(
                                $.getPropertyValue(s, "height", null, !0)
                              ) || 1) / 100),
                            (a.emToPx = j.lastEmToPx =
                              (parseFloat(
                                $.getPropertyValue(s, "paddingLeft")
                              ) || 1) / 100),
                            o.myParent.removeChild(s);
                        }
                        return (
                          null === j.remToPx &&
                            (j.remToPx =
                              parseFloat(
                                $.getPropertyValue(i.body, "fontSize")
                              ) || 16),
                          null === j.vwToPx &&
                            ((j.vwToPx = parseFloat(t.innerWidth) / 100),
                            (j.vhToPx = parseFloat(t.innerHeight) / 100)),
                          (a.remToPx = j.remToPx),
                          (a.vwToPx = j.vwToPx),
                          (a.vhToPx = j.vhToPx),
                          C.debug >= 1 &&
                            console.log("Unit ratios: " + JSON.stringify(a), e),
                          a
                        );
                      })();
                    var R =
                      /margin|padding|left|right|width|text|word|letter/i.test(
                        n
                      ) ||
                      /X$/.test(n) ||
                      "x" === n
                        ? "x"
                        : "y";
                    switch (_) {
                      case "%":
                        v *=
                          "x" === R ? s.percentToPxWidth : s.percentToPxHeight;
                        break;
                      case "px":
                        break;
                      default:
                        v *= s[_ + "ToPx"];
                    }
                    switch (w) {
                      case "%":
                        v *=
                          1 /
                          ("x" === R
                            ? s.percentToPxWidth
                            : s.percentToPxHeight);
                        break;
                      case "px":
                        break;
                      default:
                        v *= 1 / s[w + "ToPx"];
                    }
                  }
                switch (k) {
                  case "+":
                    m = v + m;
                    break;
                  case "-":
                    m = v - m;
                    break;
                  case "*":
                    m *= v;
                    break;
                  case "/":
                    m = v / m;
                }
                (c[n] = {
                  rootPropertyValue: p,
                  startValue: v,
                  currentValue: v,
                  endValue: m,
                  unitType: w,
                  easing: g,
                }),
                  a && (c[n].pattern = a),
                  C.debug &&
                    console.log(
                      "tweensContainer (" + n + "): " + JSON.stringify(c[n]),
                      e
                    );
              };
              for (var M in y)
                if (y.hasOwnProperty(M)) {
                  var H = $.Names.camelCase(M),
                    F = (function (t, i) {
                      var o, r, a;
                      return (
                        b.isFunction(t) && (t = t.call(e, n, I)),
                        b.isArray(t)
                          ? ((o = t[0]),
                            (!b.isArray(t[1]) && /^[\d-]/.test(t[1])) ||
                            b.isFunction(t[1]) ||
                            $.RegEx.isHex.test(t[1])
                              ? (a = t[1])
                              : (b.isString(t[1]) &&
                                  !$.RegEx.isHex.test(t[1]) &&
                                  C.Easings[t[1]]) ||
                                b.isArray(t[1])
                              ? ((r = d(t[1], l.duration)), (a = t[2]))
                              : (a = t[1] || t[2]))
                          : (o = t),
                        (r = r || l.easing),
                        b.isFunction(o) && (o = o.call(e, n, I)),
                        b.isFunction(a) && (a = a.call(e, n, I)),
                        [o || 0, r, a]
                      );
                    })(y[M]);
                  if (w($.Lists.colors, H)) {
                    var O = F[0],
                      q = F[1],
                      E = F[2];
                    if ($.RegEx.isHex.test(O)) {
                      for (
                        var D = ["Red", "Green", "Blue"],
                          W = $.Values.hexToRgb(O),
                          R = E ? $.Values.hexToRgb(E) : o,
                          B = 0;
                        B < D.length;
                        B++
                      ) {
                        var U = [W[B]];
                        q && U.push(q), R !== o && U.push(R[B]), A(H + D[B], U);
                      }
                      continue;
                    }
                  }
                  A(H, F);
                }
              c.element = e;
            }
            c.element &&
              ($.Values.addClass(e, "velocity-animating"),
              N.push(c),
              (u = a(e)),
              u &&
                ("" === l.queue && ((u.tweensContainer = c), (u.opts = l)),
                (u.isAnimating = !0)),
              P === I - 1
                ? (C.State.calls.push([N, v, l, null, S.resolver, null, 0]),
                  !1 === C.State.isTicking && ((C.State.isTicking = !0), p()))
                : P++);
          }
          var s,
            l = f.extend({}, C.defaults, _),
            c = {};
          switch (
            (a(e) === o && C.init(e),
            parseFloat(l.delay) &&
              !1 !== l.queue &&
              f.queue(e, l.queue, function (t) {
                C.velocityQueueEntryFlag = !0;
                var i = C.State.delayedElements.count++;
                C.State.delayedElements[i] = e;
                var o = (function (e) {
                  return function () {
                    (C.State.delayedElements[e] = !1), t();
                  };
                })(i);
                (a(e).delayBegin = new Date().getTime()),
                  (a(e).delay = parseFloat(l.delay)),
                  (a(e).delayTimer = {
                    setTimeout: setTimeout(t, parseFloat(l.delay)),
                    next: o,
                  });
              }),
            l.duration.toString().toLowerCase())
          ) {
            case "fast":
              l.duration = 200;
              break;
            case "normal":
              l.duration = k;
              break;
            case "slow":
              l.duration = 600;
              break;
            default:
              l.duration = parseFloat(l.duration) || 1;
          }
          if (
            (!1 !== C.mock &&
              (!0 === C.mock
                ? (l.duration = l.delay = 1)
                : ((l.duration *= parseFloat(C.mock) || 1),
                  (l.delay *= parseFloat(C.mock) || 1))),
            (l.easing = d(l.easing, l.duration)),
            l.begin && !b.isFunction(l.begin) && (l.begin = null),
            l.progress && !b.isFunction(l.progress) && (l.progress = null),
            l.complete && !b.isFunction(l.complete) && (l.complete = null),
            l.display !== o &&
              null !== l.display &&
              ((l.display = l.display.toString().toLowerCase()),
              "auto" === l.display &&
                (l.display = C.CSS.Values.getDisplayType(e))),
            l.visibility !== o &&
              null !== l.visibility &&
              (l.visibility = l.visibility.toString().toLowerCase()),
            (l.mobileHA =
              l.mobileHA && C.State.isMobile && !C.State.isGingerbread),
            !1 === l.queue)
          )
            if (l.delay) {
              var u = C.State.delayedElements.count++;
              C.State.delayedElements[u] = e;
              var h = (function (e) {
                return function () {
                  (C.State.delayedElements[e] = !1), r();
                };
              })(u);
              (a(e).delayBegin = new Date().getTime()),
                (a(e).delay = parseFloat(l.delay)),
                (a(e).delayTimer = {
                  setTimeout: setTimeout(r, parseFloat(l.delay)),
                  next: h,
                });
            } else r();
          else
            f.queue(e, l.queue, function (e, t) {
              if (!0 === t) return S.promise && S.resolver(v), !0;
              (C.velocityQueueEntryFlag = !0), r(e);
            });
          ("" !== l.queue && "fx" !== l.queue) ||
            "inprogress" === f.queue(e)[0] ||
            f.dequeue(e);
        }
        var c,
          u,
          m,
          g,
          v,
          y,
          _,
          x =
            arguments[0] &&
            (arguments[0].p ||
              (f.isPlainObject(arguments[0].properties) &&
                !arguments[0].properties.names) ||
              b.isString(arguments[0].properties));
        b.isWrapped(this)
          ? ((u = !1), (g = 0), (v = this), (m = this))
          : ((u = !0),
            (g = 1),
            (v = x ? arguments[0].elements || arguments[0].e : arguments[0]));
        var S = { promise: null, resolver: null, rejecter: null };
        if (
          (u &&
            C.Promise &&
            (S.promise = new C.Promise(function (e, t) {
              (S.resolver = e), (S.rejecter = t);
            })),
          x
            ? ((y = arguments[0].properties || arguments[0].p),
              (_ = arguments[0].options || arguments[0].o))
            : ((y = arguments[g]), (_ = arguments[g + 1])),
          !(v = r(v)))
        )
          return void (
            S.promise &&
            (y && _ && !1 === _.promiseRejectEmpty
              ? S.resolver()
              : S.rejecter())
          );
        var I = v.length,
          P = 0;
        if (
          !/^(stop|finish|finishAll|pause|resume)$/i.test(y) &&
          !f.isPlainObject(_)
        ) {
          var L = g + 1;
          _ = {};
          for (var z = L; z < arguments.length; z++)
            b.isArray(arguments[z]) ||
            (!/^(fast|normal|slow)$/i.test(arguments[z]) &&
              !/^\d/.test(arguments[z]))
              ? b.isString(arguments[z]) || b.isArray(arguments[z])
                ? (_.easing = arguments[z])
                : b.isFunction(arguments[z]) && (_.complete = arguments[z])
              : (_.duration = arguments[z]);
        }
        var V;
        switch (y) {
          case "scroll":
            V = "scroll";
            break;
          case "reverse":
            V = "reverse";
            break;
          case "pause":
            var A = new Date().getTime();
            return (
              f.each(v, function (e, t) {
                s(t, A);
              }),
              f.each(C.State.calls, function (e, t) {
                var i = !1;
                t &&
                  f.each(t[1], function (e, n) {
                    var r = _ === o ? "" : _;
                    return (
                      (!0 !== r &&
                        t[2].queue !== r &&
                        (_ !== o || !1 !== t[2].queue)) ||
                      (f.each(v, function (e, o) {
                        if (o === n)
                          return (t[5] = { resume: !1 }), (i = !0), !1;
                      }),
                      !i && void 0)
                    );
                  });
              }),
              e()
            );
          case "resume":
            return (
              f.each(v, function (e, t) {
                l(t, A);
              }),
              f.each(C.State.calls, function (e, t) {
                var i = !1;
                t &&
                  f.each(t[1], function (e, n) {
                    var r = _ === o ? "" : _;
                    return (
                      (!0 !== r &&
                        t[2].queue !== r &&
                        (_ !== o || !1 !== t[2].queue)) ||
                      !t[5] ||
                      (f.each(v, function (e, o) {
                        if (o === n) return (t[5].resume = !0), (i = !0), !1;
                      }),
                      !i && void 0)
                    );
                  });
              }),
              e()
            );
          case "finish":
          case "finishAll":
          case "stop":
            f.each(v, function (e, t) {
              a(t) &&
                a(t).delayTimer &&
                (clearTimeout(a(t).delayTimer.setTimeout),
                a(t).delayTimer.next && a(t).delayTimer.next(),
                delete a(t).delayTimer),
                "finishAll" !== y ||
                  (!0 !== _ && !b.isString(_)) ||
                  (f.each(f.queue(t, b.isString(_) ? _ : ""), function (e, t) {
                    b.isFunction(t) && t();
                  }),
                  f.queue(t, b.isString(_) ? _ : "", []));
            });
            var M = [];
            return (
              f.each(C.State.calls, function (e, t) {
                t &&
                  f.each(t[1], function (i, n) {
                    var r = _ === o ? "" : _;
                    if (
                      !0 !== r &&
                      t[2].queue !== r &&
                      (_ !== o || !1 !== t[2].queue)
                    )
                      return !0;
                    f.each(v, function (i, o) {
                      if (o === n)
                        if (
                          ((!0 === _ || b.isString(_)) &&
                            (f.each(
                              f.queue(o, b.isString(_) ? _ : ""),
                              function (e, t) {
                                b.isFunction(t) && t(null, !0);
                              }
                            ),
                            f.queue(o, b.isString(_) ? _ : "", [])),
                          "stop" === y)
                        ) {
                          var s = a(o);
                          s &&
                            s.tweensContainer &&
                            !1 !== r &&
                            f.each(s.tweensContainer, function (e, t) {
                              t.endValue = t.currentValue;
                            }),
                            M.push(e);
                        } else
                          ("finish" !== y && "finishAll" !== y) ||
                            (t[2].duration = 1);
                    });
                  });
              }),
              "stop" === y &&
                (f.each(M, function (e, t) {
                  h(t, !0);
                }),
                S.promise && S.resolver(v)),
              e()
            );
          default:
            if (!f.isPlainObject(y) || b.isEmptyObject(y)) {
              if (b.isString(y) && C.Redirects[y]) {
                c = f.extend({}, _);
                var H = c.duration,
                  F = c.delay || 0;
                return (
                  !0 === c.backwards && (v = f.extend(!0, [], v).reverse()),
                  f.each(v, function (e, t) {
                    parseFloat(c.stagger)
                      ? (c.delay = F + parseFloat(c.stagger) * e)
                      : b.isFunction(c.stagger) &&
                        (c.delay = F + c.stagger.call(t, e, I)),
                      c.drag &&
                        ((c.duration =
                          parseFloat(H) ||
                          (/^(callout|transition)/.test(y) ? 1e3 : k)),
                        (c.duration = Math.max(
                          c.duration * (c.backwards ? 1 - e / I : (e + 1) / I),
                          0.75 * c.duration,
                          200
                        ))),
                      C.Redirects[y].call(
                        t,
                        t,
                        c || {},
                        e,
                        I,
                        v,
                        S.promise ? S : o
                      );
                  }),
                  e()
                );
              }
              var O =
                "Velocity: First argument (" +
                y +
                ") was not a property map, a known action, or a registered redirect. Aborting.";
              return (
                S.promise
                  ? S.rejecter(new Error(O))
                  : t.console && console.log(O),
                e()
              );
            }
            V = "start";
        }
        var j = {
            lastParent: null,
            lastPosition: null,
            lastFontSize: null,
            lastPercentToPxWidth: null,
            lastPercentToPxHeight: null,
            lastEmToPx: null,
            remToPx: null,
            vwToPx: null,
            vhToPx: null,
          },
          N = [];
        f.each(v, function (e, t) {
          b.isNode(t) && n(t, e);
        }),
          (c = f.extend({}, C.defaults, _)),
          (c.loop = parseInt(c.loop, 10));
        var q = 2 * c.loop - 1;
        if (c.loop)
          for (var E = 0; E < q; E++) {
            var D = { delay: c.delay, progress: c.progress };
            E === q - 1 &&
              ((D.display = c.display),
              (D.visibility = c.visibility),
              (D.complete = c.complete)),
              T(v, "reverse", D);
          }
        return e();
      };
      (C = f.extend(T, C)), (C.animate = T);
      var I = t.requestAnimationFrame || g;
      if (!C.State.isMobile && i.hidden !== o) {
        var P = function () {
          i.hidden
            ? ((I = function (e) {
                return setTimeout(function () {
                  e(!0);
                }, 16);
              }),
              p())
            : (I = t.requestAnimationFrame || g);
        };
        P(), i.addEventListener("visibilitychange", P);
      }
      return (
        (e.Velocity = C),
        e !== t && ((e.fn.velocity = T), (e.fn.velocity.defaults = C.defaults)),
        f.each(["Down", "Up"], function (e, t) {
          C.Redirects["slide" + t] = function (e, i, n, r, a, s) {
            var l = f.extend({}, i),
              c = l.begin,
              u = l.complete,
              d = {},
              p = {
                height: "",
                marginTop: "",
                marginBottom: "",
                paddingTop: "",
                paddingBottom: "",
              };
            l.display === o &&
              (l.display =
                "Down" === t
                  ? "inline" === C.CSS.Values.getDisplayType(e)
                    ? "inline-block"
                    : "block"
                  : "none"),
              (l.begin = function () {
                0 === n && c && c.call(a, a);
                for (var i in p)
                  if (p.hasOwnProperty(i)) {
                    d[i] = e.style[i];
                    var o = $.getPropertyValue(e, i);
                    p[i] = "Down" === t ? [o, 0] : [0, o];
                  }
                (d.overflow = e.style.overflow), (e.style.overflow = "hidden");
              }),
              (l.complete = function () {
                for (var t in d) d.hasOwnProperty(t) && (e.style[t] = d[t]);
                n === r - 1 && (u && u.call(a, a), s && s.resolver(a));
              }),
              C(e, p, l);
          };
        }),
        f.each(["In", "Out"], function (e, t) {
          C.Redirects["fade" + t] = function (e, i, n, r, a, s) {
            var l = f.extend({}, i),
              c = l.complete,
              u = { opacity: "In" === t ? 1 : 0 };
            0 !== n && (l.begin = null),
              (l.complete =
                n !== r - 1
                  ? null
                  : function () {
                      c && c.call(a, a), s && s.resolver(a);
                    }),
              l.display === o && (l.display = "In" === t ? "auto" : "none"),
              C(this, u, l);
          };
        }),
        C
      );
    })(
      window.jQuery || window.Zepto || window,
      window,
      window ? window.document : void 0
    );
  }),
  (function (e) {
    "use strict";
    (e.fn.fitVids = function (t) {
      var i = { customSelector: null, ignore: null };
      if (!document.getElementById("fit-vids-style")) {
        var o = document.head || document.getElementsByTagName("head")[0],
          n = document.createElement("div");
        (n.innerHTML =
          '<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>'),
          o.appendChild(n.childNodes[1]);
      }
      return (
        t && e.extend(i, t),
        this.each(function () {
          var t = [
            'iframe[src*="player.vimeo.com"]',
            'iframe[src*="youtube.com"]',
            'iframe[src*="youtube-nocookie.com"]',
            'iframe[src*="kickstarter.com"][src*="video.html"]',
            "object",
            "embed",
          ];
          i.customSelector && t.push(i.customSelector);
          var o = ".fitvidsignore";
          i.ignore && (o = o + ", " + i.ignore);
          var n = e(this).find(t.join(","));
          (n = n.not("object object")),
            (n = n.not(o)),
            n.each(function () {
              var t = e(this);
              if (
                !(
                  t.parents(o).length > 0 ||
                  ("embed" === this.tagName.toLowerCase() &&
                    t.parent("object").length) ||
                  t.parent(".fluid-width-video-wrapper").length
                )
              ) {
                t.css("height") ||
                  t.css("width") ||
                  (!isNaN(t.attr("height")) && !isNaN(t.attr("width"))) ||
                  (t.attr("height", 9), t.attr("width", 16));
                var i =
                    "object" === this.tagName.toLowerCase() ||
                    (t.attr("height") && !isNaN(parseInt(t.attr("height"), 10)))
                      ? parseInt(t.attr("height"), 10)
                      : t.height(),
                  n = isNaN(parseInt(t.attr("width"), 10))
                    ? t.width()
                    : parseInt(t.attr("width"), 10),
                  r = i / n;
                if (!t.attr("name")) {
                  var a = "fitvid" + e.fn.fitVids._count;
                  t.attr("name", a), e.fn.fitVids._count++;
                }
                t
                  .wrap('<div class="fluid-width-video-wrapper"></div>')
                  .parent(".fluid-width-video-wrapper")
                  .css("padding-top", 100 * r + "%"),
                  t.removeAttr("height").removeAttr("width");
              }
            });
        })
      );
    }),
      (e.fn.fitVids._count = 0);
  })(window.jQuery || window.Zepto) /*!

 matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license

*/,
  window.matchMedia ||
    (window.matchMedia = (function () {
      "use strict";
      var e = window.styleMedia || window.media;
      if (!e) {
        var t = document.createElement("style"),
          i = document.getElementsByTagName("script")[0],
          o = null;
        (t.type = "text/css"),
          (t.id = "matchmediajs-test"),
          i.parentNode.insertBefore(t, i),
          (o =
            ("getComputedStyle" in window &&
              window.getComputedStyle(t, null)) ||
            t.currentStyle),
          (e = {
            matchMedium: function (e) {
              var i = "@media " + e + "{ #matchmediajs-test { width: 1px; } }";
              return (
                t.styleSheet ? (t.styleSheet.cssText = i) : (t.textContent = i),
                "1px" === o.width
              );
            },
          });
      }
      return function (t) {
        return { matches: e.matchMedium(t || "all"), media: t || "all" };
      };
    })()),
  (function (e, t, i) {
    function o(e, t) {
      return typeof e === t;
    }
    function n(e) {
      return e
        .replace(/([a-z])-([a-z])/g, function (e, t, i) {
          return t + i.toUpperCase();
        })
        .replace(/^-/, "");
    }
    function r() {
      return "function" != typeof t.createElement
        ? t.createElement(arguments[0])
        : k
        ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
        : t.createElement.apply(t, arguments);
    }
    function a() {
      var e = t.body;
      return e || ((e = r(k ? "svg" : "body")), (e.fake = !0)), e;
    }
    function s(e, i, o, n) {
      var s,
        l,
        c,
        u,
        d = "modernizr",
        p = r("div"),
        h = a();
      if (parseInt(o, 10))
        for (; o--; )
          (c = r("div")), (c.id = n ? n[o] : d + (o + 1)), p.appendChild(c);
      return (
        (s = r("style")),
        (s.type = "text/css"),
        (s.id = "s" + d),
        (h.fake ? h : p).appendChild(s),
        h.appendChild(p),
        s.styleSheet
          ? (s.styleSheet.cssText = e)
          : s.appendChild(t.createTextNode(e)),
        (p.id = d),
        h.fake &&
          ((h.style.background = ""),
          (h.style.overflow = "hidden"),
          (u = _.style.overflow),
          (_.style.overflow = "hidden"),
          _.appendChild(h)),
        (l = i(p, e)),
        h.fake
          ? (h.parentNode.removeChild(h),
            (_.style.overflow = u),
            _.offsetHeight)
          : p.parentNode.removeChild(p),
        !!l
      );
    }
    function l(e, t) {
      return !!~("" + e).indexOf(t);
    }
    function c(e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    }
    function u(e, t, i) {
      var n;
      for (var r in e)
        if (e[r] in t)
          return !1 === i
            ? e[r]
            : ((n = t[e[r]]), o(n, "function") ? c(n, i || t) : n);
      return !1;
    }
    function d(e) {
      return e
        .replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        })
        .replace(/^ms-/, "-ms-");
    }
    function p(t, i, o) {
      var n;
      if ("getComputedStyle" in e) {
        n = getComputedStyle.call(e, t, i);
        var r = e.console;
        if (null !== n) o && (n = n.getPropertyValue(o));
        else if (r) {
          var a = r.error ? "error" : "log";
          r[a].call(
            r,
            "getComputedStyle returning null, its possible modernizr test results are inaccurate"
          );
        }
      } else n = !i && t.currentStyle && t.currentStyle[o];
      return n;
    }
    function h(t, o) {
      var n = t.length;
      if ("CSS" in e && "supports" in e.CSS) {
        for (; n--; ) if (e.CSS.supports(d(t[n]), o)) return !0;
        return !1;
      }
      if ("CSSSupportsRule" in e) {
        for (var r = []; n--; ) r.push("(" + d(t[n]) + ":" + o + ")");
        return (
          (r = r.join(" or ")),
          s(
            "@supports (" + r + ") { #modernizr { position: absolute; } }",
            function (e) {
              return "absolute" == p(e, null, "position");
            }
          )
        );
      }
      return i;
    }
    function f(e, t, a, s) {
      function c() {
        d && (delete L.style, delete L.modElem);
      }
      if (((s = !o(s, "undefined") && s), !o(a, "undefined"))) {
        var u = h(e, a);
        if (!o(u, "undefined")) return u;
      }
      for (
        var d, p, f, m, g, v = ["modernizr", "tspan", "samp"];
        !L.style && v.length;

      )
        (d = !0), (L.modElem = r(v.shift())), (L.style = L.modElem.style);
      for (f = e.length, p = 0; f > p; p++)
        if (
          ((m = e[p]),
          (g = L.style[m]),
          l(m, "-") && (m = n(m)),
          L.style[m] !== i)
        ) {
          if (s || o(a, "undefined")) return c(), "pfx" != t || m;
          try {
            L.style[m] = a;
          } catch (e) {}
          if (L.style[m] != g) return c(), "pfx" != t || m;
        }
      return c(), !1;
    }
    function m(e, t, i, n, r) {
      var a = e.charAt(0).toUpperCase() + e.slice(1),
        s = (e + " " + $.join(a + " ") + a).split(" ");
      return o(t, "string") || o(t, "undefined")
        ? f(s, t, n, r)
        : ((s = (e + " " + I.join(a + " ") + a).split(" ")), u(s, t, i));
    }
    function g(e, t, o) {
      return m(e, i, i, t, o);
    }
    var v = [],
      y = [],
      w = {
        _version: "3.6.0",
        _config: {
          classPrefix: "",
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function (e, t) {
          var i = this;
          setTimeout(function () {
            t(i[e]);
          }, 0);
        },
        addTest: function (e, t, i) {
          y.push({ name: e, fn: t, options: i });
        },
        addAsyncTest: function (e) {
          y.push({ name: null, fn: e });
        },
      },
      b = function () {};
    (b.prototype = w),
      (b = new b()),
      b.addTest("localstorage", function () {
        var e = "modernizr";
        try {
          return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
        } catch (e) {
          return !1;
        }
      });
    var _ = t.documentElement,
      k = "svg" === _.nodeName.toLowerCase(),
      x = w._config.usePrefixes
        ? " -webkit- -moz- -o- -ms- ".split(" ")
        : ["", ""];
    w._prefixes = x;
    var C = (w.testStyles = s);
    b.addTest("touchevents", function () {
      var i;
      if (
        "ontouchstart" in e ||
        (e.DocumentTouch && t instanceof DocumentTouch)
      )
        i = !0;
      else {
        var o = [
          "@media (",
          x.join("touch-enabled),("),
          "heartz",
          ")",
          "{#modernizr{top:9px;position:absolute}}",
        ].join("");
        C(o, function (e) {
          i = 9 === e.offsetTop;
        });
      }
      return i;
    });
    var S = "Moz O ms Webkit",
      $ = w._config.usePrefixes ? S.split(" ") : [];
    w._cssomPrefixes = $;
    var T = function (t) {
      var o,
        n = x.length,
        r = e.CSSRule;
      if (void 0 === r) return i;
      if (!t) return !1;
      if (
        ((t = t.replace(/^@/, "")),
        (o = t.replace(/-/g, "_").toUpperCase() + "_RULE") in r)
      )
        return "@" + t;
      for (var a = 0; n > a; a++) {
        var s = x[a];
        if (s.toUpperCase() + "_" + o in r)
          return "@-" + s.toLowerCase() + "-" + t;
      }
      return !1;
    };
    w.atRule = T;
    var I = w._config.usePrefixes ? S.toLowerCase().split(" ") : [];
    w._domPrefixes = I;
    var P = { elem: r("modernizr") };
    b._q.push(function () {
      delete P.elem;
    });
    var L = { style: P.elem.style };
    b._q.unshift(function () {
      delete L.style;
    }),
      (w.testAllProps = m),
      (w.testAllProps = g),
      b.addTest("cssgridlegacy", g("grid-columns", "10px", !0)),
      b.addTest("cssgrid", g("grid-template-rows", "none", !0));
    var z = (w.prefixed = function (e, t, i) {
      return 0 === e.indexOf("@")
        ? T(e)
        : (-1 != e.indexOf("-") && (e = n(e)), t ? m(e, t, i) : m(e, "pfx"));
    });
    b.addTest("objectfit", !!z("objectFit"), { aliases: ["object-fit"] }),
      (function () {
        var e, t, i, n, r, a, s;
        for (var l in y)
          if (y.hasOwnProperty(l)) {
            if (
              ((e = []),
              (t = y[l]),
              t.name &&
                (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
            )
              for (i = 0; i < t.options.aliases.length; i++)
                e.push(t.options.aliases[i].toLowerCase());
            for (
              n = o(t.fn, "function") ? t.fn() : t.fn, r = 0;
              r < e.length;
              r++
            )
              (a = e[r]),
                (s = a.split(".")),
                1 === s.length
                  ? (b[s[0]] = n)
                  : (!b[s[0]] ||
                      b[s[0]] instanceof Boolean ||
                      (b[s[0]] = new Boolean(b[s[0]])),
                    (b[s[0]][s[1]] = n)),
                v.push((n ? "" : "no-") + s.join("-"));
          }
      })(),
      (function (e) {
        var t = _.className,
          i = b._config.classPrefix || "";
        if ((k && (t = t.baseVal), b._config.enableJSClass)) {
          var o = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
          t = t.replace(o, "$1" + i + "js$2");
        }
        b._config.enableClasses &&
          ((t += " " + i + e.join(" " + i)),
          k ? (_.className.baseVal = t) : (_.className = t));
      })(v),
      delete w.addTest,
      delete w.addAsyncTest;
    for (var V = 0; V < b._q.length; V++) b._q[V]();
    e.Modernizr = b;
  })(window, document)
  /*!
   *	jQuery OwlCarousel v1.31
   *
   *	Copyright (c) 2013 Bartosz Wojciechowski
   *	http://www.owlgraphic.com/owlcarousel/
   *
   *	Licensed under MIT
   *
   */,
  "function" != typeof Object.create &&
    (Object.create = function (e) {
      function t() {}
      return (t.prototype = e), new t();
    }),
  (function (e, t, i, o) {
    var n = {
      init: function (t, i) {
        var o = this;
        (o.$elem = e(i)),
          (o.options = e.extend(
            {},
            e.fn.owlCarousel.options,
            o.$elem.data(),
            t
          )),
          (o.userOptions = t),
          o.loadContent();
      },
      loadContent: function () {
        function t(e) {
          if ("function" == typeof i.options.jsonSuccess)
            i.options.jsonSuccess.apply(this, [e]);
          else {
            var t = "";
            for (var o in e.owl) t += e.owl[o].item;
            i.$elem.html(t);
          }
          i.logIn();
        }
        var i = this;
        if (
          ("function" == typeof i.options.beforeInit &&
            i.options.beforeInit.apply(this, [i.$elem]),
          "string" == typeof i.options.jsonPath)
        ) {
          var o = i.options.jsonPath;
          e.getJSON(o, t);
        } else i.logIn();
      },
      logIn: function (e) {
        var t = this;
        t.$elem
          .data("owl-originalStyles", t.$elem.attr("style"))
          .data("owl-originalClasses", t.$elem.attr("class")),
          t.$elem.css({ opacity: 0 }),
          (t.orignalItems = t.options.items),
          t.checkBrowser(),
          (t.wrapperWidth = 0),
          t.checkVisible,
          t.setVars();
      },
      setVars: function () {
        var e = this;
        if (0 === e.$elem.children().length) return !1;
        e.baseClass(),
          e.eventTypes(),
          (e.$userItems = e.$elem.children()),
          (e.itemsAmount = e.$userItems.length),
          e.wrapItems(),
          (e.$owlItems = e.$elem.find(".owl-item")),
          (e.$owlWrapper = e.$elem.find(".owl-wrapper")),
          (e.playDirection = "next"),
          (e.prevItem = 0),
          (e.prevArr = [0]),
          (e.currentItem = 0),
          e.customEvents(),
          e.onStartup();
      },
      onStartup: function () {
        var e = this;
        e.updateItems(),
          e.calculateAll(),
          e.buildControls(),
          e.updateControls(),
          e.response(),
          e.moveEvents(),
          e.stopOnHover(),
          e.owlStatus(),
          !1 !== e.options.transitionStyle &&
            e.transitionTypes(e.options.transitionStyle),
          !0 === e.options.autoPlay && (e.options.autoPlay = 5e3),
          e.play(),
          e.$elem.find(".owl-wrapper").css("display", "block"),
          e.$elem.is(":visible")
            ? e.$elem.css("opacity", 1)
            : e.watchVisibility(),
          (e.onstartup = !1),
          e.eachMoveUpdate(),
          "function" == typeof e.options.afterInit &&
            e.options.afterInit.apply(this, [e.$elem]);
      },
      eachMoveUpdate: function () {
        var e = this;
        !0 === e.options.lazyLoad && e.lazyLoad(),
          !0 === e.options.autoHeight && e.autoHeight(),
          e.onVisibleItems(),
          "function" == typeof e.options.afterAction &&
            e.options.afterAction.apply(this, [e.$elem]);
      },
      updateVars: function () {
        var e = this;
        "function" == typeof e.options.beforeUpdate &&
          e.options.beforeUpdate.apply(this, [e.$elem]),
          e.watchVisibility(),
          e.updateItems(),
          e.calculateAll(),
          e.updatePosition(),
          e.updateControls(),
          e.eachMoveUpdate(),
          "function" == typeof e.options.afterUpdate &&
            e.options.afterUpdate.apply(this, [e.$elem]);
      },
      reload: function (e) {
        var t = this;
        setTimeout(function () {
          t.updateVars();
        }, 0);
      },
      watchVisibility: function () {
        var e = this;
        if (!1 !== e.$elem.is(":visible")) return !1;
        e.$elem.css({ opacity: 0 }),
          clearInterval(e.autoPlayInterval),
          clearInterval(e.checkVisible),
          (e.checkVisible = setInterval(function () {
            e.$elem.is(":visible") &&
              (e.reload(),
              e.$elem.animate({ opacity: 1 }, 200),
              clearInterval(e.checkVisible));
          }, 500));
      },
      wrapItems: function () {
        var e = this;
        e.$userItems
          .wrapAll('<div class="owl-wrapper">')
          .wrap('<div class="owl-item"></div>'),
          e.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),
          (e.wrapperOuter = e.$elem.find(".owl-wrapper-outer")),
          e.$elem.css("display", "block");
      },
      baseClass: function () {
        var e = this,
          t = e.$elem.hasClass(e.options.baseClass),
          i = e.$elem.hasClass(e.options.theme);
        t || e.$elem.addClass(e.options.baseClass),
          i || e.$elem.addClass(e.options.theme);
      },
      updateItems: function () {
        var t = this;
        if (!1 === t.options.responsive) return !1;
        if (!0 === t.options.singleItem)
          return (
            (t.options.items = t.orignalItems = 1),
            (t.options.itemsCustom = !1),
            (t.options.itemsDesktop = !1),
            (t.options.itemsDesktopSmall = !1),
            (t.options.itemsTablet = !1),
            (t.options.itemsTabletSmall = !1),
            (t.options.itemsMobile = !1),
            !1
          );
        var i = e(t.options.responsiveBaseWidth).width();
        if (
          (i > (t.options.itemsDesktop[0] || t.orignalItems) &&
            (t.options.items = t.orignalItems),
          void 0 !== t.options.itemsCustom && !1 !== t.options.itemsCustom)
        ) {
          t.options.itemsCustom.sort(function (e, t) {
            return e[0] - t[0];
          });
          for (var o in t.options.itemsCustom)
            void 0 !== t.options.itemsCustom[o] &&
              t.options.itemsCustom[o][0] <= i &&
              (t.options.items = t.options.itemsCustom[o][1]);
        } else
          i <= t.options.itemsDesktop[0] &&
            !1 !== t.options.itemsDesktop &&
            (t.options.items = t.options.itemsDesktop[1]),
            i <= t.options.itemsDesktopSmall[0] &&
              !1 !== t.options.itemsDesktopSmall &&
              (t.options.items = t.options.itemsDesktopSmall[1]),
            i <= t.options.itemsTablet[0] &&
              !1 !== t.options.itemsTablet &&
              (t.options.items = t.options.itemsTablet[1]),
            i <= t.options.itemsTabletSmall[0] &&
              !1 !== t.options.itemsTabletSmall &&
              (t.options.items = t.options.itemsTabletSmall[1]),
            i <= t.options.itemsMobile[0] &&
              !1 !== t.options.itemsMobile &&
              (t.options.items = t.options.itemsMobile[1]);
        t.options.items > t.itemsAmount &&
          !0 === t.options.itemsScaleUp &&
          (t.options.items = t.itemsAmount);
      },
      response: function () {
        var i,
          o = this;
        if (!0 !== o.options.responsive) return !1;
        var n = e(t).width();
        (o.resizer = function () {
          e(t).width() !== n &&
            (!1 !== o.options.autoPlay && clearInterval(o.autoPlayInterval),
            clearTimeout(i),
            (i = setTimeout(function () {
              (n = e(t).width()), o.updateVars();
            }, o.options.responsiveRefreshRate)));
        }),
          e(t).resize(o.resizer);
      },
      updatePosition: function () {
        var e = this;
        e.jumpTo(e.currentItem), !1 !== e.options.autoPlay && e.checkAp();
      },
      appendItemsSizes: function () {
        var t = this,
          i = 0,
          o = t.itemsAmount - t.options.items;
        t.$owlItems.each(function (n) {
          var r = e(this);
          r.css({ width: t.itemWidth }).data("owl-item", Number(n)),
            (n % t.options.items != 0 && n !== o) || n > o || (i += 1),
            r.data("owl-roundPages", i);
        });
      },
      appendWrapperSizes: function () {
        var e = this,
          t = 0,
          t = e.$owlItems.length * e.itemWidth;
        e.$owlWrapper.css({ width: 2 * t, left: 0 }), e.appendItemsSizes();
      },
      calculateAll: function () {
        var e = this;
        e.calculateWidth(), e.appendWrapperSizes(), e.loops(), e.max();
      },
      calculateWidth: function () {
        var e = this;
        e.itemWidth = Math.floor(e.$elem.width() / e.options.items);
      },
      max: function () {
        var e = this,
          t =
            -1 * (e.itemsAmount * e.itemWidth - e.options.items * e.itemWidth);
        return (
          e.options.items > e.itemsAmount
            ? ((e.maximumItem = 0), (t = 0), (e.maximumPixels = 0))
            : ((e.maximumItem = e.itemsAmount - e.options.items),
              (e.maximumPixels = t)),
          t
        );
      },
      min: function () {
        return 0;
      },
      loops: function () {
        var t = this;
        (t.positionsInArray = [0]), (t.pagesInArray = []);
        for (var i = 0, o = 0, n = 0; n < t.itemsAmount; n++)
          if (
            ((o += t.itemWidth),
            t.positionsInArray.push(-o),
            !0 === t.options.scrollPerPage)
          ) {
            var r = e(t.$owlItems[n]),
              a = r.data("owl-roundPages");
            a !== i && ((t.pagesInArray[i] = t.positionsInArray[n]), (i = a));
          }
      },
      buildControls: function () {
        var t = this;
        (!0 !== t.options.navigation && !0 !== t.options.pagination) ||
          (t.owlControls = e('<div class="owl-controls"/>')
            .toggleClass("clickable", !t.browser.isTouch)
            .appendTo(t.$elem)),
          !0 === t.options.pagination && t.buildPagination(),
          !0 === t.options.navigation && t.buildButtons();
      },
      buildButtons: function () {
        var t = this,
          i = e('<div class="owl-buttons"/>');
        t.owlControls.append(i),
          (t.buttonPrev = e("<div/>", {
            class: "owl-prev",
            html: t.options.navigationText[0] || "",
          })),
          (t.buttonNext = e("<div/>", {
            class: "owl-next",
            html: t.options.navigationText[1] || "",
          })),
          i.append(t.buttonPrev).append(t.buttonNext),
          i.on(
            "touchstart.owlControls mousedown.owlControls",
            'div[class^="owl"]',
            function (e) {
              e.preventDefault();
            }
          ),
          i.on(
            "touchend.owlControls mouseup.owlControls",
            'div[class^="owl"]',
            function (i) {
              i.preventDefault(),
                e(this).hasClass("owl-next") ? t.next() : t.prev();
            }
          );
      },
      buildPagination: function () {
        var t = this;
        (t.paginationWrapper = e('<div class="owl-pagination"/>')),
          t.owlControls.append(t.paginationWrapper),
          t.paginationWrapper.on(
            "touchend.owlControls mouseup.owlControls",
            ".owl-page",
            function (i) {
              i.preventDefault(),
                Number(e(this).data("owl-page")) !== t.currentItem &&
                  t.goTo(Number(e(this).data("owl-page")), !0);
            }
          );
      },
      updatePagination: function () {
        var t = this;
        if (!1 === t.options.pagination) return !1;
        t.paginationWrapper.html("");
        for (
          var i = 0,
            o = t.itemsAmount - (t.itemsAmount % t.options.items),
            n = 0;
          n < t.itemsAmount;
          n++
        )
          if (n % t.options.items == 0) {
            if (((i += 1), o === n)) var r = t.itemsAmount - t.options.items;
            var a = e("<div/>", { class: "owl-page" }),
              s = e("<span></span>", {
                text: !0 === t.options.paginationNumbers ? i : "",
                class: !0 === t.options.paginationNumbers ? "owl-numbers" : "",
              });
            a.append(s),
              a.data("owl-page", o === n ? r : n),
              a.data("owl-roundPages", i),
              t.paginationWrapper.append(a);
          }
        t.checkPagination();
      },
      checkPagination: function () {
        var t = this;
        if (!1 === t.options.pagination) return !1;
        t.paginationWrapper.find(".owl-page").each(function (i, o) {
          e(this).data("owl-roundPages") ===
            e(t.$owlItems[t.currentItem]).data("owl-roundPages") &&
            (t.paginationWrapper.find(".owl-page").removeClass("active"),
            e(this).addClass("active"));
        });
      },
      checkNavigation: function () {
        var e = this;
        if (!1 === e.options.navigation) return !1;
        !1 === e.options.rewindNav &&
          (0 === e.currentItem && 0 === e.maximumItem
            ? (e.buttonPrev.addClass("disabled"),
              e.buttonNext.addClass("disabled"))
            : 0 === e.currentItem && 0 !== e.maximumItem
            ? (e.buttonPrev.addClass("disabled"),
              e.buttonNext.removeClass("disabled"))
            : e.currentItem === e.maximumItem
            ? (e.buttonPrev.removeClass("disabled"),
              e.buttonNext.addClass("disabled"))
            : 0 !== e.currentItem &&
              e.currentItem !== e.maximumItem &&
              (e.buttonPrev.removeClass("disabled"),
              e.buttonNext.removeClass("disabled")));
      },
      updateControls: function () {
        var e = this;
        e.updatePagination(),
          e.checkNavigation(),
          e.owlControls &&
            (e.options.items >= e.itemsAmount
              ? e.owlControls.hide()
              : e.owlControls.show());
      },
      destroyControls: function () {
        var e = this;
        e.owlControls && e.owlControls.remove();
      },
      next: function (e) {
        var t = this;
        if (t.isTransition) return !1;
        if (
          ((t.currentItem +=
            !0 === t.options.scrollPerPage ? t.options.items : 1),
          t.currentItem >
            t.maximumItem +
              (1 == t.options.scrollPerPage ? t.options.items - 1 : 0))
        ) {
          if (!0 !== t.options.rewindNav)
            return (t.currentItem = t.maximumItem), !1;
          (t.currentItem = 0), (e = "rewind");
        }
        t.goTo(t.currentItem, e);
      },
      prev: function (e) {
        var t = this;
        if (t.isTransition) return !1;
        if (
          (!0 === t.options.scrollPerPage &&
          t.currentItem > 0 &&
          t.currentItem < t.options.items
            ? (t.currentItem = 0)
            : (t.currentItem -=
                !0 === t.options.scrollPerPage ? t.options.items : 1),
          t.currentItem < 0)
        ) {
          if (!0 !== t.options.rewindNav) return (t.currentItem = 0), !1;
          (t.currentItem = t.maximumItem), (e = "rewind");
        }
        t.goTo(t.currentItem, e);
      },
      goTo: function (e, t, i) {
        var o = this;
        if (o.isTransition) return !1;
        if (
          ("function" == typeof o.options.beforeMove &&
            o.options.beforeMove.apply(this, [o.$elem]),
          e >= o.maximumItem ? (e = o.maximumItem) : e <= 0 && (e = 0),
          (o.currentItem = o.owl.currentItem = e),
          !1 !== o.options.transitionStyle &&
            "drag" !== i &&
            1 === o.options.items &&
            !0 === o.browser.support3d)
        )
          return (
            o.swapSpeed(0),
            !0 === o.browser.support3d
              ? o.transition3d(o.positionsInArray[e])
              : o.css2slide(o.positionsInArray[e], 1),
            o.afterGo(),
            o.singleItemTransition(),
            !1
          );
        var n = o.positionsInArray[e];
        !0 === o.browser.support3d
          ? ((o.isCss3Finish = !1),
            !0 === t
              ? (o.swapSpeed("paginationSpeed"),
                setTimeout(function () {
                  o.isCss3Finish = !0;
                }, o.options.paginationSpeed))
              : "rewind" === t
              ? (o.swapSpeed(o.options.rewindSpeed),
                setTimeout(function () {
                  o.isCss3Finish = !0;
                }, o.options.rewindSpeed))
              : (o.swapSpeed("slideSpeed"),
                setTimeout(function () {
                  o.isCss3Finish = !0;
                }, o.options.slideSpeed)),
            o.transition3d(n))
          : !0 === t
          ? o.css2slide(n, o.options.paginationSpeed)
          : "rewind" === t
          ? o.css2slide(n, o.options.rewindSpeed)
          : o.css2slide(n, o.options.slideSpeed),
          o.afterGo();
      },
      jumpTo: function (e) {
        var t = this;
        "function" == typeof t.options.beforeMove &&
          t.options.beforeMove.apply(this, [t.$elem]),
          e >= t.maximumItem || -1 === e
            ? (e = t.maximumItem)
            : e <= 0 && (e = 0),
          t.swapSpeed(0),
          !0 === t.browser.support3d
            ? t.transition3d(t.positionsInArray[e])
            : t.css2slide(t.positionsInArray[e], 1),
          (t.currentItem = t.owl.currentItem = e),
          t.afterGo();
      },
      afterGo: function () {
        var e = this;
        e.prevArr.push(e.currentItem),
          (e.prevItem = e.owl.prevItem = e.prevArr[e.prevArr.length - 2]),
          e.prevArr.shift(0),
          e.prevItem !== e.currentItem &&
            (e.checkPagination(),
            e.checkNavigation(),
            e.eachMoveUpdate(),
            !1 !== e.options.autoPlay && e.checkAp()),
          "function" == typeof e.options.afterMove &&
            e.prevItem !== e.currentItem &&
            e.options.afterMove.apply(this, [e.$elem]);
      },
      stop: function () {
        var e = this;
        (e.apStatus = "stop"), clearInterval(e.autoPlayInterval);
      },
      checkAp: function () {
        var e = this;
        "stop" !== e.apStatus && e.play();
      },
      play: function () {
        var e = this;
        if (((e.apStatus = "play"), !1 === e.options.autoPlay)) return !1;
        clearInterval(e.autoPlayInterval),
          (e.autoPlayInterval = setInterval(function () {
            e.next(!0);
          }, e.options.autoPlay));
      },
      swapSpeed: function (e) {
        var t = this;
        "slideSpeed" === e
          ? t.$owlWrapper.css(t.addCssSpeed(t.options.slideSpeed))
          : "paginationSpeed" === e
          ? t.$owlWrapper.css(t.addCssSpeed(t.options.paginationSpeed))
          : "string" != typeof e && t.$owlWrapper.css(t.addCssSpeed(e));
      },
      addCssSpeed: function (e) {
        return {
          "-webkit-transition": "all " + e + "ms ease",
          "-moz-transition": "all " + e + "ms ease",
          "-o-transition": "all " + e + "ms ease",
          transition: "all " + e + "ms ease",
        };
      },
      removeTransition: function () {
        return {
          "-webkit-transition": "",
          "-moz-transition": "",
          "-o-transition": "",
          transition: "",
        };
      },
      doTranslate: function (e) {
        return {
          "-webkit-transform": "translate3d(" + e + "px, 0px, 0px)",
          "-moz-transform": "translate3d(" + e + "px, 0px, 0px)",
          "-o-transform": "translate3d(" + e + "px, 0px, 0px)",
          "-ms-transform": "translate3d(" + e + "px, 0px, 0px)",
          transform: "translate3d(" + e + "px, 0px,0px)",
        };
      },
      transition3d: function (e) {
        var t = this;
        t.$owlWrapper.css(t.doTranslate(e));
      },
      css2move: function (e) {
        this.$owlWrapper.css({ left: e });
      },
      css2slide: function (e, t) {
        var i = this;
        (i.isCssFinish = !1),
          i.$owlWrapper.stop(!0, !0).animate(
            { left: e },
            {
              duration: t || i.options.slideSpeed,
              complete: function () {
                i.isCssFinish = !0;
              },
            }
          );
      },
      checkBrowser: function () {
        var e = this,
          o = "translate3d(0px, 0px, 0px)",
          n = i.createElement("div");
        n.style.cssText =
          "  -moz-transform:" +
          o +
          "; -ms-transform:" +
          o +
          "; -o-transform:" +
          o +
          "; -webkit-transform:" +
          o +
          "; transform:" +
          o;
        var r = /translate3d\(0px, 0px, 0px\)/g,
          a = n.style.cssText.match(r),
          s = null !== a && 1 === a.length,
          l = "ontouchstart" in t || navigator.msMaxTouchPoints;
        e.browser = { support3d: s, isTouch: l };
      },
      moveEvents: function () {
        var e = this;
        (!1 === e.options.mouseDrag && !1 === e.options.touchDrag) ||
          (e.gestures(), e.disabledEvents());
      },
      eventTypes: function () {
        var e = this,
          t = ["s", "e", "x"];
        (e.ev_types = {}),
          !0 === e.options.mouseDrag && !0 === e.options.touchDrag
            ? (t = [
                "touchstart.owl mousedown.owl",
                "touchmove.owl mousemove.owl",
                "touchend.owl touchcancel.owl mouseup.owl",
              ])
            : !1 === e.options.mouseDrag && !0 === e.options.touchDrag
            ? (t = [
                "touchstart.owl",
                "touchmove.owl",
                "touchend.owl touchcancel.owl",
              ])
            : !0 === e.options.mouseDrag &&
              !1 === e.options.touchDrag &&
              (t = ["mousedown.owl", "mousemove.owl", "mouseup.owl"]),
          (e.ev_types.start = t[0]),
          (e.ev_types.move = t[1]),
          (e.ev_types.end = t[2]);
      },
      disabledEvents: function () {
        var t = this;
        t.$elem.on("dragstart.owl", function (e) {
          e.preventDefault();
        }),
          t.$elem.on("mousedown.disableTextSelect", function (t) {
            return e(t.target).is("input, textarea, select, option");
          });
      },
      gestures: function () {
        function n(e) {
          return e.touches
            ? { x: e.touches[0].pageX, y: e.touches[0].pageY }
            : e.pageX !== o
            ? { x: e.pageX, y: e.pageY }
            : { x: e.clientX, y: e.clientY };
        }
        function r(t) {
          "on" === t
            ? (e(i).on(c.ev_types.move, s), e(i).on(c.ev_types.end, l))
            : "off" === t &&
              (e(i).off(c.ev_types.move), e(i).off(c.ev_types.end));
        }
        function a(i) {
          var i = i.originalEvent || i || t.event;
          if (3 === i.which) return !1;
          if (!(c.itemsAmount <= c.options.items)) {
            if (!1 === c.isCssFinish && !c.options.dragBeforeAnimFinish)
              return !1;
            if (!1 === c.isCss3Finish && !c.options.dragBeforeAnimFinish)
              return !1;
            !1 !== c.options.autoPlay && clearInterval(c.autoPlayInterval),
              !0 === c.browser.isTouch ||
                c.$owlWrapper.hasClass("grabbing") ||
                c.$owlWrapper.addClass("grabbing"),
              (c.newPosX = 0),
              (c.newRelativeX = 0),
              e(this).css(c.removeTransition());
            var o = e(this).position();
            (u.relativePos = o.left),
              (u.offsetX = n(i).x - o.left),
              (u.offsetY = n(i).y - o.top),
              r("on"),
              (u.sliding = !1),
              (u.targetElement = i.target || i.srcElement);
          }
        }
        function s(o) {
          var o = o.originalEvent || o || t.event;
          (c.newPosX = n(o).x - u.offsetX),
            (c.newPosY = n(o).y - u.offsetY),
            (c.newRelativeX = c.newPosX - u.relativePos),
            "function" == typeof c.options.startDragging &&
              !0 !== u.dragging &&
              0 !== c.newRelativeX &&
              ((u.dragging = !0), c.options.startDragging.apply(c, [c.$elem])),
            (c.newRelativeX > 8 ||
              (c.newRelativeX < -8 && !0 === c.browser.isTouch)) &&
              (o.preventDefault ? o.preventDefault() : (o.returnValue = !1),
              (u.sliding = !0)),
            (c.newPosY > 10 || c.newPosY < -10) &&
              !1 === u.sliding &&
              e(i).off("touchmove.owl"),
            (c.newPosX = Math.max(
              Math.min(
                c.newPosX,
                (function () {
                  return c.newRelativeX / 5;
                })()
              ),
              (function () {
                return c.maximumPixels + c.newRelativeX / 5;
              })()
            )),
            !0 === c.browser.support3d
              ? c.transition3d(c.newPosX)
              : c.css2move(c.newPosX);
        }
        function l(i) {
          var i = i.originalEvent || i || t.event;
          if (
            ((i.target = i.target || i.srcElement),
            (u.dragging = !1),
            !0 !== c.browser.isTouch && c.$owlWrapper.removeClass("grabbing"),
            c.newRelativeX < 0
              ? (c.dragDirection = c.owl.dragDirection = "left")
              : (c.dragDirection = c.owl.dragDirection = "right"),
            0 !== c.newRelativeX)
          ) {
            var o = c.getNewPosition();
            if (
              (c.goTo(o, !1, "drag"),
              u.targetElement === i.target && !0 !== c.browser.isTouch)
            ) {
              e(i.target).on("click.disable", function (t) {
                t.stopImmediatePropagation(),
                  t.stopPropagation(),
                  t.preventDefault(),
                  e(i.target).off("click.disable");
              });
              var n = e._data(i.target, "events").click,
                a = n.pop();
              n.splice(0, 0, a);
            }
          }
          r("off");
        }
        var c = this,
          u = {
            offsetX: 0,
            offsetY: 0,
            baseElWidth: 0,
            relativePos: 0,
            position: null,
            minSwipe: null,
            maxSwipe: null,
            sliding: null,
            dargging: null,
            targetElement: null,
          };
        (c.isCssFinish = !0), c.$elem.on(c.ev_types.start, ".owl-wrapper", a);
      },
      getNewPosition: function () {
        var e,
          t = this;
        return (
          (e = t.closestItem()),
          e > t.maximumItem
            ? ((t.currentItem = t.maximumItem), (e = t.maximumItem))
            : t.newPosX >= 0 && ((e = 0), (t.currentItem = 0)),
          e
        );
      },
      closestItem: function () {
        var t = this,
          i =
            !0 === t.options.scrollPerPage
              ? t.pagesInArray
              : t.positionsInArray,
          o = t.newPosX,
          n = null;
        return (
          e.each(i, function (r, a) {
            o - t.itemWidth / 20 > i[r + 1] &&
            o - t.itemWidth / 20 < a &&
            "left" === t.moveDirection()
              ? ((n = a),
                !0 === t.options.scrollPerPage
                  ? (t.currentItem = e.inArray(n, t.positionsInArray))
                  : (t.currentItem = r))
              : o + t.itemWidth / 20 < a &&
                o + t.itemWidth / 20 > (i[r + 1] || i[r] - t.itemWidth) &&
                "right" === t.moveDirection() &&
                (!0 === t.options.scrollPerPage
                  ? ((n = i[r + 1] || i[i.length - 1]),
                    (t.currentItem = e.inArray(n, t.positionsInArray)))
                  : ((n = i[r + 1]), (t.currentItem = r + 1)));
          }),
          t.currentItem
        );
      },
      moveDirection: function () {
        var e,
          t = this;
        return (
          t.newRelativeX < 0
            ? ((e = "right"), (t.playDirection = "next"))
            : ((e = "left"), (t.playDirection = "prev")),
          e
        );
      },
      customEvents: function () {
        var e = this;
        e.$elem.on("owl.next", function () {
          e.next();
        }),
          e.$elem.on("owl.prev", function () {
            e.prev();
          }),
          e.$elem.on("owl.play", function (t, i) {
            (e.options.autoPlay = i), e.play(), (e.hoverStatus = "play");
          }),
          e.$elem.on("owl.stop", function () {
            e.stop(), (e.hoverStatus = "stop");
          }),
          e.$elem.on("owl.goTo", function (t, i) {
            e.goTo(i);
          }),
          e.$elem.on("owl.jumpTo", function (t, i) {
            e.jumpTo(i);
          });
      },
      stopOnHover: function () {
        var e = this;
        !0 === e.options.stopOnHover &&
          !0 !== e.browser.isTouch &&
          !1 !== e.options.autoPlay &&
          (e.$elem.on("mouseover", function () {
            e.stop();
          }),
          e.$elem.on("mouseout", function () {
            "stop" !== e.hoverStatus && e.play();
          }));
      },
      lazyLoad: function () {
        var t = this;
        if (!1 === t.options.lazyLoad) return !1;
        for (var i = 0; i < t.itemsAmount; i++) {
          var n = e(t.$owlItems[i]);
          if ("loaded" !== n.data("owl-loaded")) {
            var r = n.data("owl-item"),
              a = n.find(".lazyOwl");
            "string" == typeof a.data("src")
              ? (n.data("owl-loaded") === o &&
                  (a.hide(),
                  n.addClass("loading").data("owl-loaded", "checked")),
                (!0 !== t.options.lazyFollow || r >= t.currentItem) &&
                  r < t.currentItem + t.options.items &&
                  a.length &&
                  t.lazyPreload(n, a))
              : n.data("owl-loaded", "loaded");
          }
        }
      },
      lazyPreload: function (e, t) {
        function i() {
          (r += 1),
            n.completeImg(t.get(0)) || !0 === a
              ? o()
              : r <= 100
              ? setTimeout(i, 100)
              : o();
        }
        function o() {
          e.data("owl-loaded", "loaded").removeClass("loading"),
            t.removeAttr("data-src"),
            "fade" === n.options.lazyEffect ? t.fadeIn(400) : t.show(),
            "function" == typeof n.options.afterLazyLoad &&
              n.options.afterLazyLoad.apply(this, [n.$elem]);
        }
        var n = this,
          r = 0;
        if ("DIV" === t.prop("tagName")) {
          t.css("background-image", "url(" + t.data("src") + ")");
          var a = !0;
        } else t[0].src = t.data("src");
        i();
      },
      autoHeight: function () {
        function t() {
          (a += 1),
            n.completeImg(r.get(0))
              ? i()
              : a <= 100
              ? setTimeout(t, 100)
              : n.wrapperOuter.css("height", "");
        }
        function i() {
          var t = e(n.$owlItems[n.currentItem]).height();
          n.wrapperOuter.css("height", t + "px"),
            n.wrapperOuter.hasClass("autoHeight") ||
              setTimeout(function () {
                n.wrapperOuter.addClass("autoHeight");
              }, 0);
        }
        var n = this,
          r = e(n.$owlItems[n.currentItem]).find("img");
        if (r.get(0) !== o) {
          var a = 0;
          t();
        } else i();
      },
      completeImg: function (e) {
        return (
          !!e.complete && (void 0 === e.naturalWidth || 0 != e.naturalWidth)
        );
      },
      onVisibleItems: function () {
        var t = this;
        !0 === t.options.addClassActive && t.$owlItems.removeClass("active"),
          (t.visibleItems = []);
        for (var i = t.currentItem; i < t.currentItem + t.options.items; i++)
          t.visibleItems.push(i),
            !0 === t.options.addClassActive &&
              e(t.$owlItems[i]).addClass("active");
        t.owl.visibleItems = t.visibleItems;
      },
      transitionTypes: function (e) {
        var t = this;
        (t.outClass = "owl-" + e + "-out"), (t.inClass = "owl-" + e + "-in");
      },
      singleItemTransition: function () {
        var e = this;
        e.isTransition = !0;
        var t = e.outClass,
          i = e.inClass,
          o = e.$owlItems.eq(e.currentItem),
          n = e.$owlItems.eq(e.prevItem),
          r =
            Math.abs(e.positionsInArray[e.currentItem]) +
            e.positionsInArray[e.prevItem],
          a = Math.abs(e.positionsInArray[e.currentItem]) + e.itemWidth / 2;
        e.$owlWrapper
          .addClass("owl-origin")
          .css({
            "-webkit-transform-origin": a + "px",
            "-moz-perspective-origin": a + "px",
            "perspective-origin": a + "px",
          });
        var s = "webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";
        n
          .css(
            (function (e, t) {
              return { position: "relative", left: e + "px" };
            })(r)
          )
          .addClass(t)
          .on(s, function () {
            (e.endPrev = !0), n.off(s), e.clearTransStyle(n, t);
          }),
          o.addClass(i).on(s, function () {
            (e.endCurrent = !0), o.off(s), e.clearTransStyle(o, i);
          });
      },
      clearTransStyle: function (e, t) {
        var i = this;
        e.css({ position: "", left: "" }).removeClass(t),
          i.endPrev &&
            i.endCurrent &&
            (i.$owlWrapper.removeClass("owl-origin"),
            (i.endPrev = !1),
            (i.endCurrent = !1),
            (i.isTransition = !1));
      },
      owlStatus: function () {
        var e = this;
        e.owl = {
          userOptions: e.userOptions,
          baseElement: e.$elem,
          userItems: e.$userItems,
          owlItems: e.$owlItems,
          currentItem: e.currentItem,
          prevItem: e.prevItem,
          visibleItems: e.visibleItems,
          isTouch: e.browser.isTouch,
          browser: e.browser,
          dragDirection: e.dragDirection,
        };
      },
      clearEvents: function () {
        var o = this;
        o.$elem.off(".owl owl mousedown.disableTextSelect"),
          e(i).off(".owl owl"),
          e(t).off("resize", o.resizer);
      },
      unWrap: function () {
        var e = this;
        0 !== e.$elem.children().length &&
          (e.$owlWrapper.unwrap(),
          e.$userItems.unwrap().unwrap(),
          e.owlControls && e.owlControls.remove()),
          e.clearEvents(),
          e.$elem
            .attr("style", e.$elem.data("owl-originalStyles") || "")
            .attr("class", e.$elem.data("owl-originalClasses"));
      },
      destroy: function () {
        var e = this;
        e.stop(),
          clearInterval(e.checkVisible),
          e.unWrap(),
          e.$elem.removeData();
      },
      reinit: function (t) {
        var i = this,
          o = e.extend({}, i.userOptions, t);
        i.unWrap(), i.init(o, i.$elem);
      },
      addItem: function (e, t) {
        var i,
          n = this;
        return (
          !!e &&
          (0 === n.$elem.children().length
            ? (n.$elem.append(e), n.setVars(), !1)
            : (n.unWrap(),
              (i = t === o || -1 === t ? -1 : t),
              i >= n.$userItems.length || -1 === i
                ? n.$userItems.eq(-1).after(e)
                : n.$userItems.eq(i).before(e),
              void n.setVars()))
        );
      },
      removeItem: function (e) {
        var t,
          i = this;
        if (0 === i.$elem.children().length) return !1;
        (t = e === o || -1 === e ? -1 : e),
          i.unWrap(),
          i.$userItems.eq(t).remove(),
          i.setVars();
      },
    };
    (e.fn.owlCarousel = function (t) {
      return this.each(function () {
        if (!0 === e(this).data("owl-init")) return !1;
        e(this).data("owl-init", !0);
        var i = Object.create(n);
        i.init(t, this), e.data(this, "owlCarousel", i);
      });
    }),
      (e.fn.owlCarousel.options = {
        items: 5,
        itemsCustom: !1,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 2],
        itemsTabletSmall: !1,
        itemsMobile: [479, 1],
        singleItem: !1,
        itemsScaleUp: !1,
        slideSpeed: 200,
        paginationSpeed: 800,
        rewindSpeed: 1e3,
        autoPlay: !1,
        stopOnHover: !1,
        navigation: !1,
        navigationText: ["prev", "next"],
        rewindNav: !0,
        scrollPerPage: !1,
        pagination: !0,
        paginationNumbers: !1,
        responsive: !0,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: t,
        baseClass: "owl-carousel",
        theme: "owl-theme",
        lazyLoad: !1,
        lazyFollow: !0,
        lazyEffect: "fade",
        autoHeight: !1,
        jsonPath: !1,
        jsonSuccess: !1,
        dragBeforeAnimFinish: !0,
        mouseDrag: !0,
        touchDrag: !0,
        addClassActive: !1,
        transitionStyle: !1,
        beforeUpdate: !1,
        afterUpdate: !1,
        beforeInit: !1,
        afterInit: !1,
        beforeMove: !1,
        afterMove: !1,
        afterAction: !1,
        startDragging: !1,
        afterLazyLoad: !1,
      });
  })(jQuery, window, document)
  /*!
   *
   * Spin.js
   * Copyright (c) 2011-2013 Felix Gnass
   * Licensed under the MIT license
   */,
  (function (e, t) {
    "object" == typeof exports
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define(t)
      : (e.Spinner = t());
  })(this, function () {
    "use strict";
    function e(e, t) {
      var i,
        o = document.createElement(e || "div");
      for (i in t) o[i] = t[i];
      return o;
    }
    function t(e) {
      for (var t = 1, i = arguments.length; t < i; t++)
        e.appendChild(arguments[t]);
      return e;
    }
    function i(e, t, i, o) {
      var n = ["opacity", t, ~~(100 * e), i, o].join("-"),
        r = 0.01 + (i / o) * 100,
        a = Math.max(1 - ((1 - e) / t) * (100 - r), e),
        s = c.substring(0, c.indexOf("Animation")).toLowerCase(),
        l = (s && "-" + s + "-") || "";
      return (
        d[n] ||
          (p.insertRule(
            "@" +
              l +
              "keyframes " +
              n +
              "{0%{opacity:" +
              a +
              "}" +
              r +
              "%{opacity:" +
              e +
              "}" +
              (r + 0.01) +
              "%{opacity:1}" +
              ((r + t) % 100) +
              "%{opacity:" +
              e +
              "}100%{opacity:" +
              a +
              "}}",
            p.cssRules.length
          ),
          (d[n] = 1)),
        n
      );
    }
    function o(e, t) {
      var i,
        o,
        n = e.style;
      for (t = t.charAt(0).toUpperCase() + t.slice(1), o = 0; o < u.length; o++)
        if (((i = u[o] + t), void 0 !== n[i])) return i;
      if (void 0 !== n[t]) return t;
    }
    function n(e, t) {
      for (var i in t) e.style[o(e, i) || i] = t[i];
      return e;
    }
    function r(e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = arguments[t];
        for (var o in i) void 0 === e[o] && (e[o] = i[o]);
      }
      return e;
    }
    function a(e) {
      for (var t = { x: e.offsetLeft, y: e.offsetTop }; (e = e.offsetParent); )
        (t.x += e.offsetLeft), (t.y += e.offsetTop);
      return t;
    }
    function s(e, t) {
      return "string" == typeof e ? e : e[t % e.length];
    }
    function l(e) {
      if (void 0 === this) return new l(e);
      this.opts = r(e || {}, l.defaults, h);
    }
    var c,
      u = ["webkit", "Moz", "ms", "O"],
      d = {},
      p = (function () {
        var i = e("style", { type: "text/css" });
        return (
          t(document.getElementsByTagName("head")[0], i),
          i.sheet || i.styleSheet
        );
      })(),
      h = {
        lines: 12,
        length: 7,
        width: 5,
        radius: 10,
        rotate: 0,
        corners: 1,
        color: "#000",
        direction: 1,
        speed: 1,
        trail: 100,
        opacity: 0.25,
        fps: 20,
        zIndex: 2e9,
        className: "spinner",
        top: "auto",
        left: "auto",
        position: "relative",
      };
    (l.defaults = {}),
      r(l.prototype, {
        spin: function (t) {
          this.stop();
          var i,
            o,
            r = this,
            s = r.opts,
            l = (r.el = n(e(0, { className: s.className }), {
              position: s.position,
              width: 0,
              zIndex: s.zIndex,
            })),
            u = s.radius + s.length + s.width;
          if (
            (t &&
              (t.insertBefore(l, t.firstChild || null),
              (o = a(t)),
              (i = a(l)),
              n(l, {
                left:
                  ("auto" == s.left
                    ? o.x - i.x + (t.offsetWidth >> 1)
                    : parseInt(s.left, 10) + u) + "px",
                top:
                  ("auto" == s.top
                    ? o.y - i.y + (t.offsetHeight >> 1)
                    : parseInt(s.top, 10) + u) + "px",
              })),
            l.setAttribute("role", "progressbar"),
            r.lines(l, r.opts),
            !c)
          ) {
            var d,
              p = 0,
              h = ((s.lines - 1) * (1 - s.direction)) / 2,
              f = s.fps,
              m = f / s.speed,
              g = (1 - s.opacity) / ((m * s.trail) / 100),
              v = m / s.lines;
            !(function e() {
              p++;
              for (var t = 0; t < s.lines; t++)
                (d = Math.max(
                  1 - ((p + (s.lines - t) * v) % m) * g,
                  s.opacity
                )),
                  r.opacity(l, t * s.direction + h, d, s);
              r.timeout = r.el && setTimeout(e, ~~(1e3 / f));
            })();
          }
          return r;
        },
        stop: function () {
          var e = this.el;
          return (
            e &&
              (clearTimeout(this.timeout),
              e.parentNode && e.parentNode.removeChild(e),
              (this.el = void 0)),
            this
          );
        },
        lines: function (o, r) {
          function a(t, i) {
            return n(e(), {
              position: "absolute",
              width: r.length + r.width + "px",
              height: r.width + "px",
              background: t,
              boxShadow: i,
              transformOrigin: "left",
              transform:
                "rotate(" +
                ~~((360 / r.lines) * u + r.rotate) +
                "deg) translate(" +
                r.radius +
                "px,0)",
              borderRadius: ((r.corners * r.width) >> 1) + "px",
            });
          }
          for (
            var l, u = 0, d = ((r.lines - 1) * (1 - r.direction)) / 2;
            u < r.lines;
            u++
          )
            (l = n(e(), {
              position: "absolute",
              top: 1 + ~(r.width / 2) + "px",
              transform: r.hwaccel ? "translate3d(0,0,0)" : "",
              opacity: r.opacity,
              animation:
                c &&
                i(r.opacity, r.trail, d + u * r.direction, r.lines) +
                  " " +
                  1 / r.speed +
                  "s linear infinite",
            })),
              r.shadow && t(l, n(a("#000", "0 0 4px #000"), { top: "2px" })),
              t(o, t(l, a(s(r.color, u), "0 0 1px rgba(0,0,0,.1)")));
          return o;
        },
        opacity: function (e, t, i) {
          t < e.childNodes.length && (e.childNodes[t].style.opacity = i);
        },
      });
    var f = n(e("group"), { behavior: "url(#default#VML)" });
    return (
      !o(f, "transform") && f.adj
        ? (function () {
            function i(t, i) {
              return e(
                "<" +
                  t +
                  ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',
                i
              );
            }
            p.addRule(".spin-vml", "behavior:url(#default#VML)"),
              (l.prototype.lines = function (e, o) {
                function r() {
                  return n(
                    i("group", {
                      coordsize: u + " " + u,
                      coordorigin: -c + " " + -c,
                    }),
                    { width: u, height: u }
                  );
                }
                function a(e, a, l) {
                  t(
                    p,
                    t(
                      n(r(), {
                        rotation: (360 / o.lines) * e + "deg",
                        left: ~~a,
                      }),
                      t(
                        n(i("roundrect", { arcsize: o.corners }), {
                          width: c,
                          height: o.width,
                          left: o.radius,
                          top: -o.width >> 1,
                          filter: l,
                        }),
                        i("fill", { color: s(o.color, e), opacity: o.opacity }),
                        i("stroke", { opacity: 0 })
                      )
                    )
                  );
                }
                var l,
                  c = o.length + o.width,
                  u = 2 * c,
                  d = 2 * -(o.width + o.length) + "px",
                  p = n(r(), { position: "absolute", top: d, left: d });
                if (o.shadow)
                  for (l = 1; l <= o.lines; l++)
                    a(
                      l,
                      -2,
                      "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)"
                    );
                for (l = 1; l <= o.lines; l++) a(l);
                return t(e, p);
              }),
              (l.prototype.opacity = function (e, t, i, o) {
                var n = e.firstChild;
                (o = (o.shadow && o.lines) || 0),
                  n &&
                    t + o < n.childNodes.length &&
                    ((n = n.childNodes[t + o]),
                    (n = n && n.firstChild),
                    (n = n && n.firstChild) && (n.opacity = i));
              });
          })()
        : (c = o(f, "animation")),
      l
    );
  }),
  (function (e) {
    if ("object" == typeof exports) e(require("jquery"), require("spin"));
    else if ("function" == typeof define && define.amd)
      define(["jquery", "spin"], e);
    else {
      if (!window.Spinner) throw new Error("Spin.js not present");
      e(window.jQuery, window.Spinner);
    }
  })(function (e, t) {
    (e.fn.spin = function (i, o) {
      return this.each(function () {
        var n = e(this),
          r = n.data();
        r.spinner && (r.spinner.stop(), delete r.spinner),
          !1 !== i &&
            ((i = e.extend(
              { color: o || n.css("color") },
              e.fn.spin.presets[i] || i
            )),
            (r.spinner = new t(i).spin(this)));
      });
    }),
      (e.fn.spin.presets = {
        tiny: { lines: 8, length: 2, width: 2, radius: 3 },
        small: { lines: 8, length: 4, width: 3, radius: 5 },
        large: { lines: 10, length: 8, width: 4, radius: 8 },
      });
  }),
  function () {
    var e,
      t,
      i,
      o,
      n,
      r,
      a,
      s,
      l,
      c,
      u,
      d,
      p,
      h,
      f,
      m,
      g,
      v,
      y,
      w,
      b,
      _,
      k = function (e, t) {
        return function () {
          return e.apply(t, arguments);
        };
      },
      x = function (e, t) {
        function i() {
          this.constructor = e;
        }
        for (var o in t) C.call(t, o) && (e[o] = t[o]);
        return (
          (i.prototype = t.prototype),
          (e.prototype = new i()),
          (e.__super__ = t.prototype),
          e
        );
      },
      C = {}.hasOwnProperty;
    (function () {
      function e(e, t) {
        (this.element = e),
          (this.type = t),
          (this.resizeListeners = k(this.resizeListeners, this)),
          (this.fillYSpace = k(this.fillYSpace, this)),
          (this.checkOverlap = k(this.checkOverlap, this)),
          (this.createOverlapDetectors = k(this.createOverlapDetectors, this)),
          (this.position = k(this.position, this)),
          (this.parent = this.element.parent()),
          this.left_side_border,
          (this.right_element_width = null),
          this.position(),
          this.fillYSpace(),
          this.createOverlapDetectors(),
          this.resizeListeners();
      }
      (e.prototype.position = function () {
        if (
          ("center-x" === this.type &&
            this.element.css({ "margin-left": -this.element.outerWidth() / 2 }),
          "center-y" === this.type)
        )
          return this.element.css({
            "margin-top": -this.element.outerHeight() / 2,
          });
      }),
        (e.prototype.createOverlapDetectors = function () {
          var e;
          if (((e = this), "right" === e.type))
            return (this.right_element_width = e.element.outerWidth());
        }),
        (e.prototype.checkOverlap = function () {
          var e, t, i, o;
          if (
            ((e = this),
            "right" === e.type &&
              (e.parent.removeClass("overlap"),
              (t = e.parent.children().eq(e.element.index() - 1)),
              (i = t.position().left + t.outerWidth()),
              (o = e.parent.outerWidth() - e.right_element_width),
              i >= o))
          )
            return e.parent.addClass("overlap");
        }),
        (e.prototype.fillYSpace = function () {
          var e, t, i;
          if (((e = this), "fill-y--dynamic" === e.type))
            return (
              (t = e.parent.outerHeight()),
              (i = e.parent.find(".fw--align--fill-y--fixed").outerHeight()),
              e.element.outerHeight(t - i)
            );
        }),
        (e.prototype.resizeListeners = function () {
          var e;
          return (
            (e = this),
            $(window).on("resize.FrameworkAlign", function () {
              return e.checkOverlap(), e.fillYSpace();
            }),
            setTimeout(function () {
              return e.checkOverlap();
            }, 1)
          );
        });
    })(),
      (theme.classes.FrameworkAnimation = (function () {
        function e() {}
        return e;
      })()),
      (theme.classes.FrameworkCart = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.convertCurrency = k(this.convertCurrency, this)),
            (this.openModalListener = k(this.openModalListener, this)),
            (this.openOffCanvasListener = k(this.openOffCanvasListener, this)),
            (this.removeItem = k(this.removeItem, this)),
            (this.removeItemListeners = k(this.removeItemListeners, this)),
            (this.updateTotalsComplete = k(this.updateTotalsComplete, this)),
            (this.updateTotals = k(this.updateTotals, this)),
            (this.plusQuantity = k(this.plusQuantity, this)),
            (this.minusQuantity = k(this.minusQuantity, this)),
            (this.updateQuantityListeners = k(
              this.updateQuantityListeners,
              this
            )),
            (this.addItem = k(this.addItem, this)),
            (this.renderOther = k(this.renderOther, this)),
            (this.renderListener = k(this.renderListener, this)),
            (this.renderCart = k(this.renderCart, this)),
            (t = this),
            (t.adjusting_qty_timer = null),
            (t.table_content = t.root.find("form > .content")),
            (t.render_trigger = $(".fw--cart-modal--trigger-render")),
            (t.totals = {}),
            (t.add_locked = !1),
            (t.render_locked = !1),
            t.root.hasClass("off-canvas") && (t.view = "off canvas"),
            t.root.hasClass("modal--content") && (t.view = "modal"),
            (t.temp_quantity = 0),
            t.renderCart(),
            "off canvas" === t.view && t.openOffCanvasListener(),
            t.openModalListener(),
            t.renderListener();
        }
        return (
          (e.prototype.renderCart = function (e) {
            var t;
            if (((t = this), !t.render_locked))
              return (
                (t.render_locked = !0),
                t.table_content.empty(),
                $.ajax({ type: "GET", url: "/cart.js", dataType: "json" })
                  .done(function (i, o, n) {
                    var r, a, s, l, c, u, d;
                    if ("success" === o) {
                      for (
                        r = i,
                          r.items.length
                            ? t.root.removeClass("no-items")
                            : t.root.addClass("no-items"),
                          u = r.items,
                          a = l = 0,
                          c = u.length;
                        l < c;
                        a = ++l
                      )
                        (s = u[a]),
                          (s.image_url = Shopify.resizeImage(s.image, "400x")),
                          (s.price = Currency.formatMoney(
                            s.price,
                            theme.money_format
                          )),
                          (d =
                            a + 1 === r.items.length
                              ? '<div class="variant-id last-variant width--12" data-variant-id=' +
                                s.variant_id +
                                ">"
                              : '<div class="variant-id width--12" data-variant-id=' +
                                s.variant_id +
                                ">"),
                          (d +=
                            '<div class="width--12 width--medium-4 width--large-6 block">'),
                          null === s.image_url
                            ? (d +=
                                '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"></span>')
                            : (d +=
                                '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"><a href="' +
                                s.url +
                                '"><img src="' +
                                s.image_url +
                                '" alt="' +
                                s.title +
                                '"></a></span>'),
                          (d +=
                            '<span class="title show--small show--large block width--8 spacing--3 font--size-4"><a href="' +
                            s.url +
                            '">' +
                            s.title +
                            "</a></span>"),
                          (d += "</div>"),
                          (d +=
                            '<div class="right-column width--12 width--medium-8 width--large-6 block spacing--3y text-align--left text-align--large-right">'),
                          (d +=
                            '<span class="title show--medium block width--12 spacing--3 font--size-4"><a href="' +
                            s.url +
                            '">' +
                            s.title +
                            "</a></span>"),
                          (d +=
                            '<span class="price font--accent spacing--3 font--size-3 money">' +
                            s.price +
                            "</span>"),
                          (d +=
                            '<span class="quantity spacing--3"><div class="input--number">'),
                          (d +=
                            '<a aria-label="' +
                            theme.translations.remove_one_item +
                            '" class="minus">' +
                            theme.utils.addSymbol("minus") +
                            "</a>"),
                          (d +=
                            '<input type="text" value="' +
                            s.quantity +
                            '" min="1" pattern="[1-9]*">'),
                          (d +=
                            '<a aria-label="' +
                            theme.translations.add_one_item +
                            '" class="plus">' +
                            theme.utils.addSymbol("plus") +
                            "</a>"),
                          (d += "</div></span>"),
                          (d += '<span class="remove spacing--3">'),
                          (d +=
                            '<a aria-label="' +
                            theme.translations.remove_item +
                            '" role="button" href="#" class="cart--remove-button remove">' +
                            theme.utils.addSymbol("cross-circle") +
                            "</a>"),
                          (d += "</span>"),
                          (d += "</div>"),
                          (d += "</div>"),
                          (d += '<div class="spacer spacing--3y"></div>'),
                          t.table_content.append(d);
                      return (
                        (d =
                          '<div class="totals width--12 text-align--center ">'),
                        (d += '<div class="width--12 width--large-8 block">'),
                        (d += "</div>"),
                        (d +=
                          '<div class="block spacing--3y width--12 width--large-4 font--size-3 text-align--large-right text--uppercase">'),
                        (d +=
                          '<span class="spacing--3">' +
                          theme.translations.cart_subtotal +
                          "</span>"),
                        (d +=
                          '<span class="total spacing--3 money font--accent font--subheading--size">' +
                          t.totals.price +
                          "</span>"),
                        (d += "</div>"),
                        (d += "</div>"),
                        (d +=
                          '<div class="spacer spacing--3y show--small-medium"></div>'),
                        t.table_content.append(d),
                        t.updateTotals(),
                        e && e(),
                        $(window).trigger("resize.FrameworkModal"),
                        (t.render_locked = !1),
                        t.removeItemListeners(),
                        t.updateQuantityListeners(),
                        t.convertCurrency(t.root.find(".money"))
                      );
                    }
                    return console.log("cart - render item status - " + o);
                  })
                  .fail(function (e, i) {
                    return (
                      console.log("cart rendering failed"),
                      (t.render_locked = !1)
                    );
                  })
              );
          }),
          (e.prototype.renderListener = function () {
            var e;
            return (
              (e = this),
              e.root.on("renderCart", function () {
                return e.renderCart();
              })
            );
          }),
          (e.prototype.renderOther = function () {
            return (
              this,
              "small" === theme.utils.mqs.current_window
                ? $(".fw--cart.modal--content").trigger("renderCart")
                : $(".fw--cart.off-canvas").trigger("renderCart")
            );
          }),
          (e.prototype.addItem = function (e, t) {
            var i;
            if (((i = this), !i.add_locked))
              return (
                (i.add_locked = !0),
                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: e.serialize(),
                })
                  .done(function (e, o, n) {
                    return t(!0), i.renderOther(), (i.add_locked = !1);
                  })
                  .fail(function (e, o) {
                    return (
                      t(!1, $.parseJSON(e.responseText).description),
                      (i.add_locked = !1)
                    );
                  })
              );
          }),
          (e.prototype.updateQuantityListeners = function () {
            var e;
            return (
              (e = this),
              e.table_content
                .find(".input--number input")
                .attr("autocomplete", "off")
                .on("keyup.LayoutCartModal paste.LayoutCartModal", function () {
                  var t, i, o;
                  return (
                    (i = $(this).closest(".input--number")),
                    (t = i.find("input")),
                    parseInt(t.val()) > 0
                      ? (i.addClass("updating"),
                        clearTimeout(e.adjusting_qty_timer),
                        (o = $(this).closest(".variant-id").data("variant-id")),
                        (e.adjusting_qty_timer = setTimeout(function () {
                          return i.removeClass("updating"), e.updateTotals();
                        }, 500)))
                      : 0 === parseInt(t.val()) &&
                        ((o = $(this)
                          .closest(".variant-id")
                          .data("variant-id")),
                        e.removeItem(o),
                        1 === $(this).closest("form").find(".variant-id").length
                          ? e.root.addClass("no-items")
                          : $(this).closest(".variant-id").remove()),
                    !1
                  );
                }),
              e.table_content
                .find(".input--number .minus")
                .on(
                  "keypress.LayoutCartModal click.LayoutCartModal",
                  function (t) {
                    var i, o, n;
                    if (!0 === theme.utils.a11yClick(t))
                      return (
                        (o = $(this).closest(".input--number")),
                        (i = o.find("input")),
                        parseInt(i.val()) > 1 &&
                          (o.addClass("updating"),
                          clearTimeout(e.adjusting_qty_timer),
                          i.val(parseInt(i.val()) - 1),
                          (n = $(this)
                            .closest(".variant-id")
                            .data("variant-id")),
                          (e.adjusting_qty_timer = setTimeout(function () {
                            return (
                              e.minusQuantity(n, parseInt(i.val())),
                              o.removeClass("updating"),
                              e.updateTotals()
                            );
                          }, 500))),
                        !1
                      );
                  }
                ),
              e.table_content
                .find(".input--number .plus")
                .on(
                  "keypress.LayoutCartModal click.LayoutCartModal",
                  function (t) {
                    var i, o, n;
                    if (!0 === theme.utils.a11yClick(t))
                      return (
                        clearTimeout(e.adjusting_qty_timer),
                        (o = $(this).closest(".input--number")),
                        (i = o.find("input")),
                        0 === e.temp_quantity &&
                          (e.temp_quantity = parseInt(i.val())),
                        o.addClass("updating"),
                        i.val(1 + parseInt(i.val())),
                        (n = $(this).closest(".variant-id").data("variant-id")),
                        (e.adjusting_qty_timer = setTimeout(function () {
                          var t;
                          return (
                            (t = parseInt(i.val()) - e.temp_quantity),
                            e.plusQuantity(n, t, function (t, n) {
                              return t
                                ? (o.removeClass("updating"),
                                  e.updateTotals(),
                                  (e.temp_quantity = 0))
                                : (i.val(e.temp_quantity),
                                  o.removeClass("updating"),
                                  e.updateTotals(),
                                  (e.temp_quantity = 0));
                            })
                          );
                        }, 500)),
                        !1
                      );
                  }
                )
            );
          }),
          (e.prototype.minusQuantity = function (e, t) {
            var i;
            return (
              (i = this),
              $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: "quantity=" + t + "&id=" + e,
              })
                .done(function (e, t, o) {
                  return "success" === t
                    ? (i.updateTotals(), i.renderOther())
                    : console.log("cart - update cart item status - " + t);
                })
                .fail(function (e, t) {
                  return console.log("cart - update failed");
                })
            );
          }),
          (e.prototype.plusQuantity = function (e, t, i) {
            var o;
            if (((o = this), !o.add_locked))
              return (
                (o.add_locked = !0),
                $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: "quantity=" + t + "&id=" + e,
                })
                  .done(function (e, t, n) {
                    return i(!0), o.renderOther(), (o.add_locked = !1);
                  })
                  .fail(function (e, t) {
                    return (
                      i(!1, $.parseJSON(e.responseText).description),
                      (o.add_locked = !1)
                    );
                  })
              );
          }),
          (e.prototype.updateTotals = function () {
            var e;
            return (
              (e = this),
              $.ajax({ type: "GET", url: "/cart.js", dataType: "json" })
                .done(function (t, i, o) {
                  var n, r, a, s, l, c;
                  if ("success" === i) {
                    for (
                      n = t,
                        r = {},
                        r.quantity = 0,
                        r.price = 0,
                        c = n.items,
                        s = 0,
                        l = c.length;
                      s < l;
                      s++
                    )
                      (a = c[s]),
                        (r.quantity += a.quantity),
                        (r.price += a.price * a.quantity);
                    return (
                      (e.totals.count = r.quantity),
                      (e.totals.price = Currency.formatMoney(
                        r.price,
                        theme.money_format
                      )),
                      e.render_trigger.find(".count").html(e.totals.count),
                      e.render_trigger
                        .find(".total-price")
                        .html(e.totals.price),
                      e.table_content.find(".total").html(e.totals.price),
                      $(".layout--header .layout--off-canvas--open.right").html(
                        e.totals.count
                      ),
                      $(".layout--header .cart-link .count").html(
                        "(" + e.totals.count + ")"
                      ),
                      e.totals.count > 0
                        ? (e.render_trigger.css("display", "inline-block"),
                          $(".layout--header .cart-link .count").css(
                            "display",
                            "inline"
                          ),
                          $(".header--cart-count").css(
                            "display",
                            "inline-block"
                          ))
                        : (e.render_trigger.hide(),
                          $(".layout--header .cart-link .count").hide()),
                      theme.currency_switcher_enabled &&
                        (e.convertCurrency(
                          e.render_trigger.find(".total-price")
                        ),
                        e.convertCurrency(e.table_content.find(".total"))),
                      e.updateTotalsComplete()
                    );
                  }
                  return console.log("cart - update totals item status - " + i);
                })
                .fail(function (e, t) {
                  return console.log("cart - updating totals failed");
                })
            );
          }),
          (e.prototype.updateTotalsComplete = function () {
            return this;
          }),
          (e.prototype.removeItemListeners = function () {
            var e;
            return (
              (e = this),
              e.table_content
                .find("a.remove")
                .on("click.LayoutCartModal", function () {
                  var t;
                  return (
                    (t = $(this).closest(".variant-id").data("variant-id")),
                    e.removeItem(t),
                    1 === $(this).closest("form").find(".variant-id").length
                      ? (e.root.addClass("no-items"),
                        $(window).trigger("resize.FrameworkModal"))
                      : $(this).closest(".variant-id").remove(),
                    e.updateTotals(),
                    !1
                  );
                })
            );
          }),
          (e.prototype.removeItem = function (e) {
            var t;
            return (t = this), t.minusQuantity(e, 0);
          }),
          (e.prototype.openOffCanvasListener = function () {
            return (
              this,
              $(".layout--off-canvas--cart--open-trigger").on(
                "click",
                function () {
                  return (
                    $(".layout--off-canvas--right-sidebar").trigger("open"), !1
                  );
                }
              )
            );
          }),
          (e.prototype.openModalListener = function () {
            return (
              this,
              $(".fw--cart-modal--trigger-render").on("click", function () {
                return $(".cart-link .modal--link").trigger("click"), !1;
              })
            );
          }),
          (e.prototype.convertCurrency = function (e) {
            return (
              this,
              !!theme.currency_switcher_enabled &&
                Currency.convertAll(
                  shopCurrency,
                  jQuery("[name=currencies]").val()
                )
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkFeaturedBlog = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (t = this),
            (t.item_container = t.root.find(".featured-blog--body")),
            (t.items = t.root.find(".featured-blog--item")),
            t.matchImageHeights(),
            t.resizeListeners();
        }
        return (
          (e.prototype.matchImageHeights = function () {
            var e;
            return (
              (e = this),
              theme.utils.matchImageHeights(
                e.item_container,
                e.items,
                ".featured-blog--item--image"
              )
            );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.FeaturedGrid",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              )
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkFeaturedCollections = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (t = this),
            (t.item_container = t.root.find(".featured-collections--body")),
            (t.items = t.root.find(".featured-collections--item")),
            t.matchImageHeights(),
            t.resizeListeners();
        }
        return (
          (e.prototype.matchImageHeights = function () {
            var e;
            return (
              (e = this),
              theme.utils.matchImageHeights(
                e.item_container,
                e.items,
                ".featured-collections--image"
              )
            );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.FeaturedCollections",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              )
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkFeaturedContent = (function () {
        function e(e) {
          this.root = e;
        }
        return e;
      })()),
      (theme.classes.FrameworkFeaturedGrid = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (t = this),
            (t.item_container = t.root.find(".featured-grid--body")),
            (t.items = t.root.find(".featured-grid--item")),
            (t.text_position = t.root.data("text-position")),
            t.matchImageHeights(),
            t.resizeListeners();
        }
        return (
          (e.prototype.matchImageHeights = function () {
            var e;
            if (
              ((e = this),
              e.items
                .find(".featured-grid--item--image, .placeholder--root")
                .css("height", "auto"),
              "center" !== e.text_position ||
                "small" === theme.utils.mqs.current_window)
            )
              return theme.utils.matchImageHeights(
                e.item_container,
                e.items,
                ".featured-grid--item--image"
              );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.FeaturedGrid",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              )
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkFeaturedProduct = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.addProductComplete = k(this.addProductComplete, this)),
            (this.renderCart = k(this.renderCart, this)),
            (this.addToCartListener = k(this.addToCartListener, this)),
            (this.updateVariantImage = k(this.updateVariantImage, this)),
            (this.sectionListeners = k(this.sectionListeners, this)),
            (this.variantSelected = k(this.variantSelected, this)),
            (this.initiateVariants = k(this.initiateVariants, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.id = t.root.data("id")),
            (t.add_button = t.root.find(".featured-product--add-to-cart")),
            (t.cart_form = t.root.find(".featured-product--cart-form > form")),
            (t.compare_price = t.root.find(".featured-product--compare-price")),
            (t.main_images = t.root.find(".featured-product--image")),
            (t.price = t.root.find(".featured-product--actual-price")),
            (t.price_wrapper = t.root.find(".featured-product--price-wrapper")),
            (t.smart_payment_buttons = t.root.find(
              ".featured-product--smart-payment-buttons"
            )),
            (t.unavailable_variant = t.root.find(
              ".featured-product--unavailable-variant"
            )),
            (t.variant_sold_out = t.root.find(
              ".featured-product--sold-out--variant"
            )),
            (t.cart_form = t.root.find(".featured-product--cart-form > form")),
            (t.json = $.parseJSON(
              t.root.find(".featured-product--json").text()
            )),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (e = this), e.initiateVariants(), e.addToCartListener();
          }),
          (e.prototype.initiateVariants = function () {
            var e, t;
            if (((e = this), e.root.find("select").length > 0))
              return (
                (t = "featured-product--select--" + e.id),
                new Shopify.OptionSelectors(t, {
                  product: e.json,
                  onVariantSelected: e.variantSelected,
                  enableHistoryState: !1,
                })
              );
          }),
          (e.prototype.variantSelected = function (e, t, i) {
            var o, n, r, a;
            return (
              (o = this),
              (n = !1),
              o.root.find(".featured-product--sold-out--product").length &&
                (n = !0),
              o.variant_sold_out.hide(),
              o.unavailable_variant.hide(),
              o.add_button.hide(),
              o.price_wrapper.hide(),
              e
                ? (e && e.available
                    ? (o.price_wrapper.show(),
                      o.add_button.show(),
                      o.smart_payment_buttons.show())
                    : n
                    ? (o.variant_sold_out.hide(),
                      o.add_button.hide(),
                      o.smart_payment_buttons.hide())
                    : (o.variant_sold_out.show(),
                      o.smart_payment_buttons.hide()),
                  (a = Shopify.formatMoney(e.price, theme.money_format)),
                  o.price.replaceWith(
                    '<span class="featured-product--actual-price money">' +
                      a +
                      "</span>"
                  ),
                  (o.price = o.root.find(".featured-product--actual-price")),
                  e.compare_at_price > e.price
                    ? ((r = Shopify.formatMoney(
                        e.compare_at_price,
                        theme.money_format
                      )),
                      o.compare_price.replaceWith(
                        '<span class="featured-product--compare-price money">' +
                          r +
                          "</span>"
                      ),
                      (o.compare_price = o.root.find(
                        ".featured-product--compare-price"
                      )),
                      o.compare_price.show())
                    : o.compare_price.hide(),
                  theme.settings.currency_switcher_enabled &&
                    Currency.convertAll(
                      shopCurrency,
                      $("[name=currencies]").val()
                    ),
                  e.featured_image
                    ? o.updateVariantImage(e.featured_image.id)
                    : void 0)
                : (o.unavailable_variant.show(),
                  o.smart_payment_buttons.hide(),
                  !1)
            );
          }),
          (e.prototype.sectionListeners = function () {
            var e;
            return (
              (e = this),
              e.root.on("theme:section:load", function () {
                return new Shopify.OptionSelectors("featured-product--select", {
                  product: theme.product_json,
                  onVariantSelected: e.variantSelected,
                  enableHistoryState: !0,
                });
              })
            );
          }),
          (e.prototype.updateVariantImage = function (e) {
            var t, i;
            return (
              (t = this),
              t.main_images.attr("data-active", "false"),
              (i = t.main_images.filter('[data-image-id="' + e + '"]')),
              i.attr("data-active", "true")
            );
          }),
          (e.prototype.addToCartListener = function () {
            var e;
            if (((e = this), e.cart_form.length > 0))
              return e.cart_form.submit(function () {
                return (
                  e.cart_form.find(".error").remove(),
                  e.add_button.attr("data-loading", "true"),
                  theme.partials.Cart.addItem($(this), function (t, i) {
                    return t
                      ? e.renderCart()
                      : (e.cart_form.append(
                          '<div class="featured-product--error error">' +
                            i +
                            "</div>"
                        ),
                        e.add_button.attr("data-loading", "false"));
                  }),
                  !1
                );
              });
          }),
          (e.prototype.renderCart = function () {
            var e;
            return (
              (e = this),
              theme.partials.Cart.renderCart(function () {
                return e.addProductComplete();
              })
            );
          }),
          (e.prototype.addProductComplete = function () {
            var e;
            return (
              (e = this),
              e.add_button.attr("data-loading", "false"),
              $(".modal.cart-link .modal--link").trigger("click")
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkFeedbackBar = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.load = k(this.load, this)),
            (t = this),
            (t.messages = t.root.find(".feedback-bar--message span")),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e, t, i, o;
            if (
              ((e = this),
              e.messages.hide(),
              (t = window.location.hash.substr(1)),
              (i = t.replace("feedback-bar--", "")),
              (o = e.messages.filter(
                '[data-feedback-bar--message="' + i + '"]'
              )),
              o.length)
            )
              return (
                o.show(),
                setTimeout(function () {
                  return e.root.attr("data-feedback-bar--open", "true");
                }, 200),
                setTimeout(function () {
                  return e.root.attr("data-feedback-bar--open", "false");
                }, 3e3)
              );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkInstagram = (function () {
        function e(e) {
          var t;
          (this.container = e),
            (this.load = k(this.load, this)),
            (t = this),
            (t.username = t.container.data("username")),
            (t.access_token = t.container.data("access-token")),
            (t.body = t.container.find(".instagram--body")),
            (t.rows = t.container.data("rows")),
            (t.columns = t.container.data("columns")),
            (t.total_items = t.rows * t.columns),
            "small" === theme.utils.mqs.current_window && (t.total_items = 4),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              !(e.access_token.length < 1) &&
                $.ajax({
                  dataType: "jsonp",
                  url:
                    "https://api.instagram.com/v1/users/self/media/recent/?access_token=" +
                    e.access_token +
                    "&count=" +
                    e.total_items,
                  success: function (t) {
                    var i, o, n, r, a, s;
                    if (200 === t.meta.code) {
                      for (
                        i = t.data, s = [], o = r = 0, a = e.total_items - 1;
                        0 <= a ? r <= a : r >= a;
                        o = 0 <= a ? ++r : --r
                      )
                        i[o]
                          ? ((n = i[o].images.standard_resolution.url),
                            (n = n.replace("http:", "https:")),
                            s.push(
                              e.body.append(
                                '<a class="instagram--item" target="_blank" href="' +
                                  i[o].link +
                                  '" > <div class="instagram--item-container"> <div class="instagram--image" style="background-image: url(\'' +
                                  n +
                                  "');\" > </div> </div> </a>"
                              )
                            ))
                          : s.push(void 0);
                      return s;
                    }
                    return e.items.append(
                      '<h4 class="error">' + t.meta.error_message + "</h4>"
                    );
                  },
                  error: function (e, t) {
                    return console.log(e), console.log(t);
                  },
                })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkLoadingAnimation = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (t = this),
            t.root.hasClass("tiny")
              ? t.root.spin("tiny")
              : t.root.spin("small");
        }
        return e;
      })()),
      (theme.classes.FrameworkMap = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.buildStyles = k(this.buildStyles, this)),
            (this.buildMap = k(this.buildMap, this)),
            (this.geolocate = k(this.geolocate, this)),
            (this.loadMapsApi = k(this.loadMapsApi, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.api_status = null),
            (t.map_instance = null),
            (t.key = t.root.data("api-key")),
            (t.address = t.root.data("address")),
            (t.theme = t.root.data("theme")),
            (t.styles = null),
            (t.container = t.root.find(".map--google-maps")),
            (t.center = null),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            if (((e = this), e.container.length > 0)) return e.loadMapsApi();
          }),
          (e.prototype.loadMapsApi = function () {
            var e, t;
            return (
              (e = this),
              "loading" === theme.utils.google_map_api_status
                ? (t = setInterval(function () {
                    if ("loaded" === theme.utils.google_map_api_status)
                      return e.geolocate(), clearInterval(t);
                  }, 100))
                : void 0 === window.google
                ? ((theme.utils.google_map_api_status = "loading"),
                  $.getScript(
                    "https://maps.googleapis.com/maps/api/js?key=" + e.key
                  ).then(function () {
                    return (
                      e.geolocate(),
                      (theme.utils.google_map_api_status = "loaded")
                    );
                  }))
                : e.geolocate()
            );
          }),
          (e.prototype.geolocate = function () {
            var e, t;
            return (
              (e = this),
              (t = new google.maps.Geocoder()),
              t.geocode({ address: e.address }, function (t, i) {
                return "OK" === i
                  ? ((e.center = t[0].geometry.location),
                    e.buildStyles(),
                    e.buildMap())
                  : console.log("couldn't convert address with geocoder");
              })
            );
          }),
          (e.prototype.buildMap = function () {
            var e, t, i, o;
            return (
              (e = this),
              (o = {
                zoom: 15,
                center: e.center,
                disableDefaultUI: !0,
                zoomControl: !0,
                scrollwheel: !1,
                styles: e.styles,
              }),
              (i = new google.maps.Map(e.container[0], o)),
              (t = i.getCenter()),
              new google.maps.Marker({ map: i, position: i.getCenter() }),
              (e.map_instance = google.maps.event.addDomListener(
                window,
                "resize",
                theme.utils.debounce(500, function () {
                  google.maps.event.trigger(i, "resize"), i.setCenter(t);
                })
              ))
            );
          }),
          (e.prototype.buildStyles = function () {
            var e;
            return (
              (e = this),
              "grayscale" === e.theme
                ? (e.styles = [
                    {
                      elementType: "geometry",
                      stylers: [{ color: "#f5f5f5" }],
                    },
                    {
                      elementType: "labels.icon",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#616161" }],
                    },
                    {
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "#f5f5f5" }],
                    },
                    {
                      featureType: "administrative.land_parcel",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#bdbdbd" }],
                    },
                    {
                      featureType: "poi",
                      elementType: "geometry",
                      stylers: [{ color: "#eeeeee" }],
                    },
                    {
                      featureType: "poi",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      featureType: "poi.park",
                      elementType: "geometry",
                      stylers: [{ color: "#e5e5e5" }],
                    },
                    {
                      featureType: "poi.park",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#9e9e9e" }],
                    },
                    {
                      featureType: "road",
                      elementType: "geometry",
                      stylers: [{ color: "#ffffff" }],
                    },
                    {
                      featureType: "road.arterial",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      featureType: "road.highway",
                      elementType: "geometry",
                      stylers: [{ color: "#dadada" }],
                    },
                    {
                      featureType: "road.highway",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#616161" }],
                    },
                    {
                      featureType: "road.local",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#9e9e9e" }],
                    },
                    {
                      featureType: "transit.line",
                      elementType: "geometry",
                      stylers: [{ color: "#e5e5e5" }],
                    },
                    {
                      featureType: "transit.station",
                      elementType: "geometry",
                      stylers: [{ color: "#eeeeee" }],
                    },
                    {
                      featureType: "water",
                      elementType: "geometry",
                      stylers: [{ color: "#c9c9c9" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#9e9e9e" }],
                    },
                  ])
                : "dark" === e.theme
                ? (e.styles = [
                    {
                      elementType: "geometry",
                      stylers: [{ color: "#212121" }],
                    },
                    {
                      elementType: "labels.icon",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "#212121" }],
                    },
                    {
                      featureType: "administrative",
                      elementType: "geometry",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      featureType: "administrative.country",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#9e9e9e" }],
                    },
                    {
                      featureType: "administrative.land_parcel",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      featureType: "administrative.locality",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#bdbdbd" }],
                    },
                    {
                      featureType: "poi",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      featureType: "poi.park",
                      elementType: "geometry",
                      stylers: [{ color: "#181818" }],
                    },
                    {
                      featureType: "poi.park",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#616161" }],
                    },
                    {
                      featureType: "poi.park",
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "#1b1b1b" }],
                    },
                    {
                      featureType: "road",
                      elementType: "geometry.fill",
                      stylers: [{ color: "#2c2c2c" }],
                    },
                    {
                      featureType: "road",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#8a8a8a" }],
                    },
                    {
                      featureType: "road.arterial",
                      elementType: "geometry",
                      stylers: [{ color: "#373737" }],
                    },
                    {
                      featureType: "road.highway",
                      elementType: "geometry",
                      stylers: [{ color: "#3c3c3c" }],
                    },
                    {
                      featureType: "road.highway.controlled_access",
                      elementType: "geometry",
                      stylers: [{ color: "#4e4e4e" }],
                    },
                    {
                      featureType: "road.local",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#616161" }],
                    },
                    {
                      featureType: "transit",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#757575" }],
                    },
                    {
                      featureType: "water",
                      elementType: "geometry",
                      stylers: [{ color: "#000000" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#3d3d3d" }],
                    },
                  ])
                : void 0
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkMediaQueries = (function () {
        function e() {
          (this.screenSizeListener = k(this.screenSizeListener, this)),
            (this.getScreenSize = k(this.getScreenSize, this)),
            (this.medium_screen = 768),
            (this.large_screen = 1024),
            (this.current_window = null),
            this.getScreenSize(),
            this.screenSizeListener();
        }
        return (
          (e.prototype.getScreenSize = function () {
            var e;
            if (
              ((e = this),
              window.matchMedia(
                "only screen and (min-width: " + e.large_screen + "px)"
              ).matches)
            ) {
              if ("large" !== e.current_window)
                return (
                  $.event.trigger("largeWindow"), (e.current_window = "large")
                );
            } else if (
              window.matchMedia(
                "only screen and (min-width: " + e.medium_screen + "px)"
              ).matches
            ) {
              if ("medium" !== e.current_window)
                return (
                  $.event.trigger("mediumWindow"), (e.current_window = "medium")
                );
            } else if ("small" !== e.current_window)
              return (
                $.event.trigger("smallWindow"), (e.current_window = "small")
              );
          }),
          (e.prototype.screenSizeListener = function () {
            var e;
            return (
              (e = this),
              $(window).resize(function () {
                return e.getScreenSize();
              })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkModal = (function () {
        function e(e) {
          var t;
          (this.container = e),
            (t = this),
            (t.fullscreen = !!t.container.data("modal--fullscreen")),
            t.container.data("modal--custom-close")
              ? (t.custom_close_button = t.container.data(
                  "modal--custom-close"
                ))
              : (t.custom_close_button = ""),
            (t.force_view = t.container.data("force-view")),
            (t.view = t.container.data("modal--view")),
            (t.links = t.container.find(".modal--link")),
            (t.content = t.container.find(".modal--content")),
            (t.window = t.createModalWindow()),
            (t.window_container = t.window.find(".modal--container")),
            (t.mask = t.window.find(".modal--mask")),
            (t.close_button = t.window.find(".modal--close")),
            (t.next_button = t.window.find(".modal--next")),
            (t.prev_button = t.window.find(".modal--prev")),
            (t.slider = null),
            (t.slides = null),
            (t.main_content_window = $(".off-canvas--main-content")),
            t.openListeners(),
            (t.modal_state = "closed"),
            (t.nav_lock = !1);
        }
        return (
          (e.prototype.createModalWindow = function () {
            var e, t;
            return (
              this,
              (e = null),
              $(".modal--window").length
                ? (e = $(".modal--window"))
                : ((t =
                    '<div class="modal--window"> <div class="modal--mask"></div> <div class="modal--container"></div> <button class="modal--close" aria-label="Close">' +
                    theme.utils.addSymbol("cross") +
                    '</button> <button class="modal--prev" aria-label="Previous">' +
                    theme.utils.addSymbol("chevron-left") +
                    '</button> <button class="modal--next" aria-label="Next">' +
                    theme.utils.addSymbol("chevron-right") +
                    "</button> </div>"),
                  (e = $(t).appendTo("body"))),
              e
            );
          }),
          (e.prototype.openListeners = function () {
            var e;
            return (
              (e = this),
              e.links.on(
                "keypress.FrameworkModal, click.FrameworkModal, quick-open",
                function (t) {
                  var i;
                  return (
                    ("keypress" !== t.type ||
                      !1 !== theme.utils.a11yClick(t)) &&
                    ((i = $(this)),
                    e.links.each(function (o) {
                      if ($(this).is(i))
                        return "quick-open" === t.type
                          ? e.open(o, !0)
                          : e.open(o);
                    }),
                    !1)
                  );
                }
              )
            );
          }),
          (e.prototype.open = function (e, t) {
            var i, o;
            if ((null == t && (t = !1), (i = this), "closed" === i.modal_state))
              return (
                (i.modal_state = "opened"),
                $("html").addClass("modal-open"),
                i.window.attr("data-modal--fullscreen", i.fullscreen),
                i.window.attr(
                  "data-modal--custom-close",
                  i.custom_close_button
                ),
                i.window.attr("data-modal--view", i.view),
                i.closeListeners(),
                i.positionListeners(),
                (o = $(window).scrollTop()),
                i.main_content_window.css({ position: "fixed", top: -o }),
                i.moveContentToWindow(),
                i.slides.length > 1 &&
                  (i.next_button.show(),
                  i.prev_button.show(),
                  i.prevListeners(),
                  i.nextListeners()),
                i.window.show(),
                i.window_container.show(),
                i.renderVideo(i.slides.eq(e)),
                t
                  ? (i.slides.eq(e).addClass("active"), i.position())
                  : (i.mask.fadeIn(),
                    i.loadModal(i.slides.eq(e), function () {
                      return setTimeout(function () {
                        return i.window_container
                          .find('input[type="text"]')
                          .focus();
                      }, 0);
                    }))
              );
          }),
          (e.prototype.moveContentToWindow = function (e) {
            var t, i;
            return (
              (t = this),
              (i = t.container.find(".modal--content")),
              t.window_container.append(i),
              (t.slides = t.window_container.find(".modal--content"))
            );
          }),
          (e.prototype.detectImageSlide = function (e) {
            return this;
          }),
          (e.prototype.renderVideo = function (e) {
            var t, i, o, n, r, a;
            return (
              (t = this),
              (a = e.find(".responsive-video").first()),
              (n = a.data("video")),
              (r = t.extractVideoType(n)),
              (i = t.extractVideoId(n, r)),
              (o = t.createIframe(r, i)),
              "vimeo" === r && a.addClass("vimeo"),
              "kickstarter" === r && a.addClass("kickstarter"),
              a.append(o)
            );
          }),
          (e.prototype.extractVideoType = function (e) {
            var t;
            return (
              this,
              (t =
                /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i),
              t.exec(e)
                ? "youtube"
                : ((t = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/),
                  t.exec(e)
                    ? "vimeo"
                    : ((t = /^.*(kickstarter)\.com/g),
                      !!t.exec(e) && "kickstarter"))
            );
          }),
          (e.prototype.extractVideoId = function (e, t) {
            var i, o;
            if ((this, "youtube" === t)) {
              if (
                ((o =
                  /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/),
                (i = e.match(o)) && 11 === i[2].length)
              )
                return i[2];
            } else if ("vimeo" === t) {
              if (
                ((o = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/),
                (i = e.match(o)))
              )
                return i[2];
            } else if (
              "kickstarter" === t &&
              ((o = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/),
              (i = e.match(o)))
            )
              return i[1];
          }),
          (e.prototype.createIframe = function (e, t) {
            return (
              this,
              "youtube" === e
                ? '<iframe  src="//www.youtube.com/embed/' +
                  t +
                  '?autoplay=1" frameborder="0" allowfullwidth></iframe>'
                : "vimeo" === e
                ? '<iframe src="//player.vimeo.com/video/' +
                  t +
                  '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
                : "kickstarter" === e
                ? '<iframe src="//www.kickstarter.com/projects/' +
                  t +
                  '/widget/video.html" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>'
                : void 0
            );
          }),
          (e.prototype.removeVideos = function () {
            var e;
            return (
              (e = this),
              e.slides.find(".responsive-video").each(function () {
                if ($(this).data("video"))
                  return $(this).find("iframe").remove();
              })
            );
          }),
          (e.prototype.loadModal = function (e, t) {
            var i;
            return (
              (i = this),
              e.addClass("active"),
              i.position(),
              t && t(),
              (i.nav_lock = !1)
            );
          }),
          (e.prototype.position = function () {
            var e, t, i, o;
            if (((e = this), null != e.window_container)) {
              if (
                ((t = e.content.filter(".active")),
                e.window_container.attr("style", ""),
                e.positionVideoColumns(t),
                e.detectImageSlide(t),
                e.window.removeClass("fixed"),
                (o = t.outerHeight()),
                t.outerWidth(),
                (i =
                  o +
                  parseInt(e.window.css("padding-top")) +
                  parseInt(e.window.css("padding-bottom"))),
                e.fullscreen)
              )
                return;
              return (
                t.hasClass("type--image") && (i = o),
                $(window).height() >= i && "absolute" !== e.force_view
                  ? e.window.addClass("fixed")
                  : ($("html, body").animate({ scrollTop: 0 }, "0"),
                    $("body,html").on(
                      "DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal",
                      function (e) {
                        if (
                          e.which > 0 ||
                          "mousewheel" === e.type ||
                          "touchmove" === e.type
                        )
                          return $("html,body").stop();
                      }
                    ),
                    e.window.removeClass("fixed"))
              );
            }
          }),
          (e.prototype.positionVideoColumns = function (e) {
            var t, i, o, n;
            if (
              (this,
              e.find(".responsive-video").length > 0 &&
                ((t = e.find(".fw--blocks > div").eq(0)),
                (i = e.find(".fw--blocks > div").eq(1)),
                t.css({ width: "" }),
                i.css({ width: "" }),
                (o = t.outerHeight()),
                (n = i.outerHeight()),
                o < n))
            )
              return t.css({ width: "100%" }), i.css({ width: "100%" });
          }),
          (e.prototype.positionListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on("resize.FrameworkModal", function () {
                return e.position();
              })
            );
          }),
          (e.prototype.nextListeners = function () {
            var e;
            return (
              (e = this),
              $(document).on("keydown.FrameworkModal", function (t) {
                if (39 === t.keyCode) return e.next();
              }),
              e.next_button.on("click.FrameworkModal", function () {
                return e.next();
              })
            );
          }),
          (e.prototype.next = function () {
            var e, t, i;
            if (((e = this), !e.nav_lock))
              return (
                (e.nav_lock = !0),
                (i = e.slides.filter(".active").index()),
                e.slides.removeClass("active"),
                e.removeVideos(),
                (t =
                  i + 1 === e.slides.length
                    ? e.slides.eq(0)
                    : e.slides.eq(i + 1)),
                e.renderVideo(t),
                e.loadModal(t)
              );
          }),
          (e.prototype.prevListeners = function () {
            var e;
            return (
              (e = this),
              $(document).on("keydown.FrameworkModal", function (t) {
                if (37 === t.keyCode) return e.prev();
              }),
              e.prev_button.on("click.FrameworkModal", function () {
                return e.prev();
              })
            );
          }),
          (e.prototype.prev = function () {
            var e, t, i;
            if (((e = this), !e.nav_lock))
              return (
                (e.nav_lock = !0),
                (i = e.slides.filter(".active").index()),
                e.slides.removeClass("active"),
                e.removeVideos(),
                (t =
                  0 === i
                    ? e.slides.eq(e.slides.length - 1)
                    : e.slides.eq(i - 1)),
                e.renderVideo(t),
                e.loadModal(t)
              );
          }),
          (e.prototype.closeListeners = function () {
            var e;
            return (
              (e = this),
              e.container.on("quick-close", function () {
                return e.close(!0);
              }),
              $(document).on("keydown.FrameworkModal", function (t) {
                if (27 === t.keyCode) return e.close();
              }),
              e.mask.on("click.FrameworkModal", function () {
                return e.close();
              }),
              e.window_container.on("click.FrameworkModal", function () {
                return e.close();
              }),
              e.content.on("click.FrameworkModal", function (e) {
                return e.stopPropagation();
              }),
              e.close_button.on("click.FrameworkModal", function () {
                if (window.innerWidth > 1162)
                  document.querySelector(".searchbar-open").focus();
                else
                  document
                    .querySelector(".header--mobile .off-canvas--open")
                    .click();
                return e.close();
              })
            );
          }),
          (e.prototype.close = function (e) {
            var t, i;
            return (
              null == e && (e = !1),
              (t = this),
              (i = -1 * parseInt(t.main_content_window.css("top"))),
              t.container.trigger("modalClosed"),
              t.main_content_window.css({ top: "0", position: "relative" }),
              $(window).scrollTop(i),
              t.putBackContent(),
              t.next_button.hide(),
              t.prev_button.hide(),
              t.window.hide(),
              e
                ? (t.mask.hide(),
                  this.window_container.empty(),
                  (t.modal_state = "closed"))
                : t.mask.fadeOut(function () {
                    return (
                      t.window_container.empty(), (t.modal_state = "closed")
                    );
                  }),
              $("html").removeClass("modal-open"),
              t.removeListeners(),
              $(window).trigger("FrameworkModal.afterClose")
            );
          }),
          (e.prototype.putBackContent = function () {
            var e;
            return (
              (e = this),
              e.removeVideos(),
              e.slides.removeClass("active").appendTo(e.container)
            );
          }),
          (e.prototype.removeListeners = function () {
            var e;
            return (
              (e = this),
              $(document).off("keydown.FrameworkModal"),
              $(window).off("resize.FrameworkModal"),
              $("body,html").off(
                "DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal"
              ),
              e.next_button.off("click.FrameworkModal"),
              e.prev_button.off("click.FrameworkModal"),
              e.close_button.off("click.FrameworkModal"),
              e.mask.off("click.FrameworkModal"),
              e.window_container.off("click.FrameworkModal")
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkOffCanvas = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.touchListener = k(this.touchListener, this)),
            (this.closeRight = k(this.closeRight, this)),
            (this.closeLeft = k(this.closeLeft, this)),
            (this.fadeInOverlay = k(this.fadeInOverlay, this)),
            (this.openRight = k(this.openRight, this)),
            (this.openLeft = k(this.openLeft, this)),
            (this.toggle = k(this.toggle, this)),
            (this.toggleListeners = k(this.toggleListeners, this)),
            (this.viewPortHeightListener = k(
              this.viewPortHeightListener,
              this
            )),
            (this.setViewPortHeight = k(this.setViewPortHeight, this)),
            (this.setState = k(this.setState, this)),
            (this.unload = k(this.unload, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.viewport = $(".off-canvas--viewport")),
            (t.left_sidebar = $(".off-canvas--left-sidebar")),
            (t.right_sidebar = $(".off-canvas--right-sidebar")),
            (t.main_content = $(".off-canvas--main-content")),
            (t.overlay = $(".off-canvas--overlay")),
            (t.state = "closed"),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              (e.close = $(".off-canvas--close")),
              (e.triggers = $(".off-canvas--open")),
              e.setViewPortHeight(),
              e.viewPortHeightListener(),
              e.toggleListeners(),
              e.touchListener()
            );
          }),
          (e.prototype.unload = function () {
            var e;
            return (
              (e = this),
              e.triggers.off("click"),
              e.overlay.add(e.close).off("click"),
              $(document).off("touchstart.FrameworkOffCanvas"),
              $(document).off("touchend.FrameworkOffCanvas")
            );
          }),
          (e.prototype.setState = function (e) {
            var t;
            return (
              (t = this),
              (t.state = e),
              t.root.attr("data-off-canvas--state", e)
            );
          }),
          (e.prototype.setViewPortHeight = function () {
            var e;
            return (
              (e = this), e.viewport.css({ "min-height": $(window).height() })
            );
          }),
          (e.prototype.viewPortHeightListener = function () {
            var e;
            return (
              (e = this),
              $(window).resize(function () {
                return e.setViewPortHeight();
              })
            );
          }),
          (e.prototype.toggleListeners = function () {
            var e;
            return (
              (e = this),
              e.triggers.on("click", function () {
                document
                  .querySelector(".header--mobile .off-canvas--open")
                  .setAttribute("aria-expanded", true);
                return (
                  "left-sidebar" === $(this).data("off-canvas--open")
                    ? e.toggle("left-sidebar") &&
                      document.querySelector(".mobile-nav--search a").focus()
                    : "right-sidebar" === $(this).data("off-canvas--open") &&
                      e.toggle("right-sidebar"),
                  !1
                );
              }),
              e.overlay.add(e.close).on("click", function () {
                document
                  .querySelector(".header--mobile .off-canvas--open")
                  .removeAttribute("aria-expanded");
                return "left-open" === e.state
                  ? e.toggle("left-sidebar") &&
                      document
                        .querySelector(".header--mobile .off-canvas--open")
                        .focus()
                  : "right-open" === e.state
                  ? e.toggle("right-sidebar")
                  : void 0;
              })
            );
          }),
          (e.prototype.toggle = function (e) {
            var t;
            return (
              (t = this),
              "left-sidebar" === e && "closed" === t.state
                ? t.openLeft()
                : "left-sidebar" === e && "left-open" === t.state
                ? t.closeLeft()
                : "right-sidebar" === e && "closed" === t.state
                ? t.openRight()
                : "right-sidebar" === e && "right-open" === t.state
                ? t.closeRight()
                : void 0
            );
          }),
          (e.prototype.openLeft = function () {
            var e;
            return (
              (e = this),
              e.setState("left-open"),
              e.main_content.css({
                position: "fixed",
                top: -$(window).scrollTop(),
              }),
              e.left_sidebar.velocity(
                { translateX: [0, "-100%"] },
                {
                  complete: function () {
                    return e.left_sidebar.css({ position: "relative" });
                  },
                }
              ),
              e.fadeInOverlay()
            );
          }),
          (e.prototype.openRight = function () {
            var e;
            return (
              (e = this),
              e.setState("right-open"),
              e.main_content.css({
                position: "fixed",
                top: -$(window).scrollTop(),
              }),
              e.right_sidebar.velocity(
                { translateX: ["-100%", 0] },
                {
                  complete: function () {
                    return e.right_sidebar.css({ position: "relative" });
                  },
                }
              ),
              e.fadeInOverlay()
            );
          }),
          (e.prototype.fadeInOverlay = function () {
            var e;
            return (
              (e = this),
              e.overlay.show(),
              e.overlay.velocity({ opacity: "0.3" })
            );
          }),
          (e.prototype.closeLeft = function () {
            var e, t;
            return (
              (e = this),
              "left-open" === e.state &&
                (e.setState("closed"),
                (t = -1 * parseInt(e.main_content.css("top"))),
                e.left_sidebar.velocity(
                  { translateX: ["-100%", 0] },
                  {
                    complete: function () {
                      return (
                        e.left_sidebar.css({ position: "absolute" }),
                        e.main_content.css({
                          position: "relative",
                          top: "initial",
                        }),
                        $(window).scrollTop(t)
                      );
                    },
                  }
                ),
                e.overlay.velocity("fadeOut"))
            );
          }),
          (e.prototype.closeRight = function () {
            var e, t;
            return (
              (e = this),
              "right-open" === e.state &&
                (e.setState("closed"),
                (t = -1 * parseInt(e.main_content.css("top"))),
                e.right_sidebar.velocity(
                  { translateX: [0, "-100%"] },
                  {
                    complete: function () {
                      return (
                        e.right_sidebar.css({ position: "absolute" }),
                        e.main_content.css({
                          position: "relative",
                          top: "initial",
                        }),
                        $(window).scrollTop(t)
                      );
                    },
                  }
                ),
                e.overlay.velocity("fadeOut"))
            );
          }),
          (e.prototype.touchListener = function () {
            var e, t;
            return (
              (e = this),
              !!Modernizr.touchevents &&
                ((t = { start: {}, end: {} }),
                $(document).on("touchstart.FrameworkOffCanvas", function (e) {
                  (t.start.x = e.originalEvent.touches[0].clientX),
                    (t.start.y = e.originalEvent.touches[0].clientY);
                }),
                $(document).on("touchend.FrameworkOffCanvas", function (i) {
                  return (
                    (t.end.x = i.originalEvent.changedTouches[0].clientX),
                    (t.end.y = i.originalEvent.changedTouches[0].clientY),
                    !(Math.abs(t.start.y - t.end.y) > 30) &&
                      (t.start.x > t.end.x + 5
                        ? e.closeLeft()
                        : t.start.x < t.end.x - 5
                        ? e.closeRight()
                        : void 0)
                  );
                }))
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkSearch = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (this.getResults = k(this.getResults, this)),
            (this.listenForKeyEntered = k(this.listenForKeyEntered, this)),
            (this.getSearchUrl = k(this.getSearchUrl, this)),
            (this.searchLinks = k(this.searchLinks, this)),
            (this.loadSpinners = k(this.loadSpinners, this)),
            (this.onOpen = k(this.onOpen, this)),
            (t = this),
            (t.articles = t.root.find(".search--articles")),
            (t.form = t.root.find("form")),
            (t.icon = t.root.find(".search--icon")),
            (t.loading = t.root.find(".search--loading")),
            (t.no_results = t.root.find(".search--no-results")),
            (t.products = t.root.find(".search--products")),
            (t.results = t.root.find(".search--results")),
            (t.text_box = t.root.find(".search--textbox")),
            (t.toggle_link = t.root.find(".search--toggle")),
            (t.show_articles = t.root.data("show-articles")),
            (t.show_pages = t.root.data("show-pages")),
            (t.view = t.root.data("view")),
            (t.ajax_request = null),
            (t.search_term = null),
            (t.search_url = null),
            (t.close_results_timer = null),
            (t.typing_timer = null),
            (t.article_page_combination = ""),
            (t.offCanvas = null),
            void 0 !== theme.partials.OffCanvas
              ? (t.offCanvas = theme.partials.OffCanvas)
              : (t.offCanvas = theme.partials.FrameworkOffCanvas),
            t.show_articles && t.show_pages
              ? (t.article_page_combination = "article,page")
              : t.show_articles
              ? (t.article_page_combination = "article")
              : t.show_pages && (t.article_page_combination = "page"),
            "modal" === t.view &&
              (t.searchLinks(),
              t.getSearchUrl(),
              t.listenForKeyEntered(),
              t.loadSpinners()),
            t.resizeListeners(),
            t.matchImageHeights();
        }
        return (
          (e.prototype.onOpen = function () {
            var e, t;
            return (
              (e = this),
              e.text_box.focus(),
              (t = e.text_box.val()),
              e.text_box.val(""),
              e.text_box.val(t),
              e.text_box.trigger("keyup")
            );
          }),
          (e.prototype.loadSpinners = function () {
            var e, t;
            return (
              (e = this),
              (t = e.loading.find(".animation")),
              t.hasClass("tiny") ? t.spin("tiny") : t.spin("small")
            );
          }),
          (e.prototype.searchLinks = function () {
            var e;
            return (
              (e = this),
              $('.off-canvas--main-content a[href="/search"]').on(
                "click",
                function () {
                  return (
                    $('[data-trigger="search-modal"]').trigger("click"),
                    e.onOpen(),
                    !1
                  );
                }
              ),
              $('.off-canvas--right-sidebar a[href="/search"]').on(
                "click",
                function () {
                  return (
                    e.offCanvas.closeRight(),
                    setTimeout(function () {
                      return (
                        $('[data-trigger="search-modal"]').trigger("click"),
                        e.onOpen()
                      );
                    }, 450),
                    !1
                  );
                }
              ),
              $('.off-canvas--left-sidebar a[href="/search"]').on(
                "click",
                function () {
                  return (
                    e.offCanvas.closeLeft(),
                    setTimeout(function () {
                      return (
                        $('[data-trigger="search-modal"]').trigger("click"),
                        e.onOpen()
                      );
                    }, 450),
                    !1
                  );
                }
              )
            );
          }),
          (e.prototype.getSearchUrl = function () {
            var e;
            return (
              (e = this),
              (e.search_url = window.location.href),
              (e.search_url = e.search_url.replace(
                window.location.hostname + window.location.pathname,
                window.location.hostname + "/search"
              )),
              (e.search_url = e.search_url.replace("#", "")),
              e.search_url.indexOf("?") >= 0
                ? (e.search_url = e.search_url + "&")
                : (e.search_url = e.search_url + "?")
            );
          }),
          (e.prototype.listenForKeyEntered = function () {
            var e;
            return (
              (e = this),
              e.text_box
                .attr("autocomplete", "off")
                .on("keyup paste", function () {
                  var t;
                  return (
                    clearTimeout(e.typing_timer),
                    (t = $(this).val()),
                    t.length < 2
                      ? (e.products.empty(),
                        e.articles.empty(),
                        e.loading.hide(),
                        e.icon.show(),
                        !1)
                      : (e.loading.show(),
                        e.icon.hide(),
                        (e.typing_timer = setTimeout(function () {
                          var i;
                          if (
                            (clearTimeout(e.typing_timer),
                            (i =
                              e.search_url +
                              "view=ajax-product&type=product&q=" +
                              t +
                              "*"),
                            e.getResults(i, t, "product"),
                            e.show_articles || e.show_pages)
                          )
                            return (
                              (i =
                                e.search_url +
                                "view=ajax-article-page&type=" +
                                e.article_page_combination +
                                "&q=" +
                                t +
                                "*"),
                              e.getResults(i, t, "article")
                            );
                        }, 750)))
                  );
                })
            );
          }),
          (e.prototype.getResults = function (e, t, i) {
            var o;
            (o = this),
              o.products.empty(),
              o.articles.empty(),
              $.ajax({
                url: e,
                type: "GET",
                dataType: "html",
                success: function (e) {
                  return (
                    o.loading.hide(),
                    o.icon.show(),
                    "product" === i
                      ? (o.products.empty(),
                        o.products.append(e),
                        o.matchImageHeights())
                      : "article" === i
                      ? (o.articles.empty(), o.articles.append(e))
                      : void 0
                  );
                },
                error: function (e, t, i) {
                  var o;
                  return (
                    (o = t + ", " + i),
                    console.log("search.json Request Failed: " + o)
                  );
                },
              });
          }),
          (e.prototype.matchImageHeights = function () {
            var e;
            return (
              (e = this),
              theme.utils.matchImageHeights(
                e.products,
                e.products.find(".product--root"),
                ".product--image-wrapper"
              )
            );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.Search",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              )
            );
          }),
          e
        );
      })()),
      (theme.classes.Sections = (function () {
        function e() {
          (this.unload = k(this.unload, this)),
            (this.deselectBlock = k(this.deselectBlock, this)),
            (this.selectBlock = k(this.selectBlock, this)),
            (this.deselectSection = k(this.deselectSection, this)),
            (this.selectSection = k(this.selectSection, this)),
            (this.load = k(this.load, this)),
            (this.getActiveBlock = k(this.getActiveBlock, this)),
            (this.getActiveSection = k(this.getActiveSection, this)),
            (this.listeners = k(this.listeners, this));
          var e;
          (e = this), e.listeners();
        }
        return (
          (e.prototype.listeners = function () {
            var e;
            return (
              (e = this),
              e.load(),
              e.unload(),
              e.selectSection(),
              e.deselectSection(),
              e.selectBlock(),
              e.deselectBlock()
            );
          }),
          (e.prototype.getActiveSection = function (e) {
            return this, $(e.target).find("[data-section-id]");
          }),
          (e.prototype.getActiveBlock = function (e) {
            return this, $(e.target);
          }),
          (e.prototype.load = function (e) {
            var t;
            return (
              (t = this),
              $(document).on("shopify:section:load", function (e) {
                var i;
                return (
                  theme.utils.loadJsClasses(),
                  (i = t.getActiveSection(e)),
                  i.triggerHandler("theme:section:load"),
                  i.find("[data-js-class]").each(function () {
                    return $(this).triggerHandler("theme:section:load");
                  })
                );
              })
            );
          }),
          (e.prototype.selectSection = function () {
            var e;
            return (
              (e = this),
              $(document).on("shopify:section:select", function (t) {
                var i;
                return (
                  (i = e.getActiveSection(t)),
                  i.triggerHandler("theme:section:select")
                );
              })
            );
          }),
          (e.prototype.deselectSection = function () {
            var e;
            return (
              (e = this),
              $(document).on("shopify:section:deselect", function (t) {
                var i;
                return (
                  (i = e.getActiveSection(t)),
                  i.triggerHandler("theme:section:deselect")
                );
              })
            );
          }),
          (e.prototype.selectBlock = function () {
            var e;
            return (
              (e = this),
              $(document).on("shopify:block:select", function (t) {
                var i;
                return (
                  (i = e.getActiveBlock(t)),
                  i.triggerHandler("theme:block:select")
                );
              })
            );
          }),
          (e.prototype.deselectBlock = function () {
            var e;
            return (
              (e = this),
              $(document).on("shopify:block:deselect", function (t) {
                var i;
                return (
                  (i = e.getActiveBlock(t)),
                  i.triggerHandler("theme:block:deselect")
                );
              })
            );
          }),
          (e.prototype.unload = function (e) {
            var t;
            return (
              (t = this),
              $(document).on("shopify:section:unload", function (e) {
                var i;
                return (
                  (i = t.getActiveSection(e)),
                  i.triggerHandler("theme:section:unload"),
                  i.find('[data-js-loaded="true"]').each(function () {
                    return $(this).triggerHandler("theme:section:unload");
                  })
                );
              })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkSlider = (function () {
        function e(e) {
          (this.container = e),
            (this.eventListeners = k(this.eventListeners, this)),
            (this.alignPlayButton = k(this.alignPlayButton, this)),
            (this.updateContextMenu = k(this.updateContextMenu, this)),
            (this.autoplay = k(this.autoplay, this)),
            (this.formatPaginationNumbers = k(
              this.formatPaginationNumbers,
              this
            )),
            (this.getActiveIndex = k(this.getActiveIndex, this)),
            (this.createSlider = k(this.createSlider, this)),
            (this.autoplay_enabled = !!this.container.data("autoplay")),
            (this.navigation = !!this.container.data("navigation")),
            (this.pagination_numbers =
              !!this.container.data("pagination-numbers")),
            (this.autoplay_frequency = 3e3),
            (this.slide_length = this.container.children().length),
            (this.active_index = 0),
            (this.news_panel = !!this.container.data("news-panel")),
            this.createSlider(),
            this.eventListeners(),
            (this.owl = this.container.data("owlCarousel"));
        }
        return (
          (e.prototype.createSlider = function () {
            var e, t;
            return (
              (e = this),
              (t = this.container.owlCarousel({
                singleItem: !0,
                navigation: e.navigation,
                navigationText: !1,
                pagination: !!e.container.data("pagination"),
                paginationNumbers: e.pagination_numbers,
                scrollPerPageNav: !0,
                slideSpeed: 800,
                autoHeight: !1,
                autoPlay: e.autoplay(),
                afterInit: function () {},
                afterAction: function () {
                  return (
                    e.alignPlayButton(),
                    (e.active_index = e.getActiveIndex()),
                    e.updateContextMenu(e.active_index),
                    e.formatPaginationNumbers()
                  );
                },
              })),
              e.navigation &&
                (t
                  .find(".owl-prev")
                  .html(theme.utils.addSymbol("chevron-left")),
                t
                  .find(".owl-next")
                  .html(theme.utils.addSymbol("chevron-right"))),
              t
            );
          }),
          (e.prototype.getActiveIndex = function () {
            return this.container
              .find(".owl-pagination .owl-page.active")
              .index();
          }),
          (e.prototype.formatPaginationNumbers = function () {
            return this.container
              .find(".owl-page.active .owl-numbers")
              .text(this.active_index + 1 + "/" + this.slide_length);
          }),
          (e.prototype.autoplay = function () {
            return !!this.autoplay_enabled && this.autoplay_frequency;
          }),
          (e.prototype.updateContextMenu = function (e) {
            var t, i;
            if (this.news_panel)
              return (
                (i =
                  "." + this.container.find(".slide").eq(e).data("feed-type")),
                (t = this.container
                  .closest(".template--index--news")
                  .find(".context-navigation")),
                t.find(".item").hide(),
                t.find(i).show()
              );
          }),
          (e.prototype.alignPlayButton = function () {
            var e, t, i, o, n;
            if (
              ((i = this.container.find(".owl-item").eq(this.active_index)),
              (e = i.find(".play-button")),
              0 !== e.length)
            )
              return (
                e.css("visibility", "hidden"),
                c.hasClass("transparent-menu") &&
                "absolute" === $(".main-header").css("position")
                  ? ((o = i.outerHeight()),
                    (t = e.outerHeight()),
                    (n = (o - t) / 2),
                    e.css({ "margin-top": 0, top: n }))
                  : e.css({ "margin-top": "-40px", top: "50%" }),
                e.css("visibility", "visible")
              );
          }),
          (e.prototype.eventListeners = function () {
            var e;
            return (
              (e = this),
              this.container.find(".play-button").on("click", function () {
                var t;
                return (
                  (t = new m($(this).closest(".video"))),
                  t.open(),
                  e.owl.stop(),
                  !1
                );
              }),
              this.container
                .find(".owl-pagination .owl-page, .skip-to-next")
                .on("click", function () {
                  return e.owl.next(), !1;
                })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkStickyColumn = (function () {
        function e(e, t, i, o) {
          if (
            ((this.container = e),
            (this.column_a = t),
            (this.column_b = i),
            (this.mq = o),
            (this.Listeners = k(this.Listeners, this)),
            (this.setColumnPosition = k(this.setColumnPosition, this)),
            (this.getAlignment = k(this.getAlignment, this)),
            (this.getState = k(this.getState, this)),
            (this.resetLargerColumn = k(this.resetLargerColumn, this)),
            (this.getSmallerColumn = k(this.getSmallerColumn, this)),
            (this.heightsHaveChanged = k(this.heightsHaveChanged, this)),
            (this.setHeights = k(this.setHeights, this)),
            (this.loadColumns = k(this.loadColumns, this)),
            Modernizr.touchevents)
          )
            return !1;
          (this.current_state = "auto"),
            (this.column_a_height = 0),
            (this.column_b_height = 0),
            this.loadColumns();
        }
        return (
          (e.prototype.loadColumns = function () {
            var e;
            return (
              (e = this),
              theme.utils.imagesLoaded(e.container, function () {
                return e.Listeners(), e.setColumnPosition();
              })
            );
          }),
          (e.prototype.setHeights = function () {
            return (
              (this.column_a_height = this.column_a.outerHeight()),
              (this.column_b_height = this.column_b.outerHeight())
            );
          }),
          (e.prototype.heightsHaveChanged = function () {
            return this.column_a.outerHeight() !== this.column_a_height
              ? (this.setHeights(), !0)
              : this.column_b.outerHeight() !== this.column_b_height &&
                  (this.setHeights(), !0);
          }),
          (e.prototype.getSmallerColumn = function () {
            return this.column_a_height < this.column_b_height
              ? this.column_a
              : this.column_b;
          }),
          (e.prototype.resetLargerColumn = function () {
            return this.column_a_height > this.column_b_height
              ? this.column_a.css({
                  position: "relative",
                  top: "auto",
                  bottom: "auto",
                })
              : this.column_b.css({
                  position: "relative",
                  top: "auto",
                  bottom: "auto",
                });
          }),
          (e.prototype.getState = function (e, t, i) {
            var o, n, r, a;
            return (
              (a = "auto"),
              "small" === this.mq.current_window
                ? "auto"
                : ((o = i.outerHeight()),
                  t > o && (r = !0),
                  e < this.container.offset().top && (a = "auto"),
                  (n = r ? o : t),
                  e + n >
                  this.container.offset().top + this.container.outerHeight()
                    ? (a = "absolute-bottom")
                    : e > this.container.offset().top && r
                    ? (a = "fixed-top")
                    : t < o &&
                      e + t > this.container.offset().top + i.outerHeight() &&
                      (a = "fixed-bottom"),
                  a)
            );
          }),
          (e.prototype.getAlignment = function (e) {
            return e.hasClass("column-a")
              ? "left"
              : e.hasClass("column-b")
              ? "right"
              : void 0;
          }),
          (e.prototype.setColumnPosition = function () {
            var e, t, i, o;
            if (
              ((e = this),
              e.setHeights(),
              (i = e.getSmallerColumn()),
              (o = e.getState($(window).scrollTop(), $(window).height(), i)),
              (t = e.getAlignment(i)),
              "auto" === o && "auto" !== this.current_state
                ? ((this.current_state = "auto"),
                  i.css({ position: "relative", top: "auto", bottom: "auto" }))
                : "fixed-bottom" === o && "fixed-bottom" !== this.current_state
                ? ((this.current_state = "fixed-bottom"),
                  i.css({ position: "fixed", top: "auto", bottom: 0 }))
                : "fixed-top" === o && "fixed-top" !== this.current_state
                ? ((this.current_state = "fixed-top"),
                  i.css({ position: "fixed", top: 0, bottom: "auto" }))
                : "absolute-bottom" === o &&
                  "absolute-bottom" !== this.current_state &&
                  ((this.current_state = "absolute-bottom"),
                  i.css({ position: "absolute", top: "auto", bottom: 0 })),
              "right" === t)
            )
              return i.css({ right: 0 });
          }),
          (e.prototype.Listeners = function () {
            var e;
            return (
              (e = this),
              $(window).scroll(function () {
                return e.setColumnPosition();
              }),
              setInterval(function () {
                if (e.heightsHaveChanged())
                  return e.resetLargerColumn(), e.setColumnPosition();
              }, 250),
              $(window).resize(function () {
                return e.resetLargerColumn(), e.setColumnPosition();
              })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkUtils = (function () {
        function e() {
          var e;
          (e = this), (e.google_map_api_status = null);
        }
        return (
          (e.prototype.debounce = function (e, t) {
            var i;
            return (
              (i = void 0),
              function () {
                i && clearTimeout(i),
                  (i = setTimeout(t.bind(this), e, arguments));
              }
            );
          }),
          (e.prototype.imagesLoaded = function (e, t) {
            var i, o;
            return (
              (i = 0),
              (o = e.find('img[data-sizes="auto"]').length),
              o < 1
                ? void t()
                : e.on("lazybeforeunveil", function (e) {
                    return $(e.target).one("load", function () {
                      if (++i === o) return t();
                    });
                  })
            );
          }),
          (e.prototype.a11yClick = function (e) {
            var t;
            return (
              "click" === e.type ||
              ("keypress" === e.type &&
                ((t = e.charCode || e.keyCode),
                32 === t && e.preventDefault(),
                32 === t || 13 === t))
            );
          }),
          (e.prototype.matchImageHeights = function (e, t, i) {
            var o, n, r;
            return (
              this,
              (n = Math.round(e.width() / t.first().outerWidth())),
              (o = 0),
              (r = $()),
              t.find(i).css("height", "auto"),
              t.find(".placeholder--root").css("height", "auto"),
              t.each(function (e) {
                var a;
                if (
                  ((a =
                    $(this).find(".image--root").length > 0
                      ? $(this)
                          .find(i + " .image--root")
                          .outerHeight()
                      : $(this).find(".placeholder--root").outerHeight()),
                  (r = r.add($(this))),
                  a > o && (o = a),
                  e % n == n - 1 || e + 1 === t.length)
                )
                  return (
                    r.find(i + ", .placeholder--root").height(o),
                    (o = 0),
                    (r = $())
                  );
              })
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkVideo = (function () {
        function e(e) {
          var t;
          (this.root = e), (t = this), t.root.fitVids();
        }
        return e;
      })()),
      (theme.classes.FrameworkXMenu = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.slideUp = k(this.slideUp, this)),
            (this.slideDown = k(this.slideDown, this)),
            (this.arrangeMegaNav = k(this.arrangeMegaNav, this)),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.checkOverlap = k(this.checkOverlap, this)),
            (this.listeners = k(this.listeners, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.debugging = !1),
            (t.state = "closed"),
            (t.parent_links = t.root.find(".x-menu--level-1--link > a")),
            (t.sub_menu_links = t.root.find(
              '.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a'
            )),
            (t.sub_menu_items = t.sub_menu_links.parent().find("ul a")),
            (t.parents_with_sub_menu = t.sub_menu_links.parent()),
            (t.overlap_parent = t.root.data("x-menu--overlap-parent")),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              e.arrangeMegaNav(),
              e.listeners(),
              e.checkOverlap(),
              e.resizeListeners()
            );
          }),
          (e.prototype.listeners = function () {
            var e;
            return (
              (e = this),
              e.parents_with_sub_menu.on("click.XMenu", function (t) {
                if (t.target.tagName == "SPAN") t.preventDefault();
                if ($(this).attr("data-x-menu--open") === "true") {
                  return e.slideUp();
                } else {
                  return e.slideDown($(this).find("> a"));
                }
                //t.preventDefault();return e.slideDown($(this).find("> a"))
              }),
              e.parents_with_sub_menu.on("mouseleave.XMenu", function () {
                return e.slideUp();
              })
            ); //,
            //e.parent_links.on("focus",function(t){return e.slideUp()}),
            //e.sub_menu_links.on("focus",function(t){return e.slideDown($(this))}),
            //e.sub_menu_links.on("touchstart.XMenu",function(t){return t.preventDefault(),"true"===$(this).parent().attr("data-x-menu--open")?e.slideUp():e.slideDown($(this))})
          }),
          (e.prototype.checkOverlap = function () {
            var e, t, i, o, n, r, a, s, l, c, u, d, p;
            return (
              (e = this),
              Modernizr.touchevents &&
              "large" !== theme.utils.mqs.current_window
                ? (e.root.attr("data-x-menu--overlap", "true"), !1)
                : (e.root.attr("data-x-menu--overlap", "false"),
                  (i = e.root),
                  1 === e.overlap_parent
                    ? (i = i.parent())
                    : 2 === e.overlap_parent && (i = i.parent().parent()),
                  (a = i.parent()),
                  (t = i.index()),
                  (u = !1),
                  t > 1 && (u = a.children().eq(t - 1)),
                  (d = !1),
                  t + 1 < a.children().length && (d = a.children().eq(t + 1)),
                  (s = a.width()),
                  (r = e.root.outerWidth()),
                  u &&
                    ((l = i.find("> :first-child")),
                    (o = l.offset().left - 1),
                    (s - r) / 2,
                    left_edge >= o &&
                      e.root.attr("data-x-menu--overlap", "true")),
                  d &&
                  ((c = i.find("> :last-child")),
                  (n = c.outerWidth() + c.offset().left + 1),
                  (p = d.offset().left),
                  n >= p)
                    ? e.root.attr("data-x-menu--overlap", "true")
                    : void 0)
            );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.XMenu",
                e.debounce(100, function () {
                  return e.checkOverlap();
                })
              )
            );
          }),
          (e.prototype.debounce = function (e, t) {
            var i;
            return (
              (i = void 0),
              function () {
                i && clearTimeout(i),
                  (i = setTimeout(t.bind(this), e, arguments));
              }
            );
          }),
          (e.prototype.arrangeMegaNav = function () {
            var e, t;
            return (
              (e = this),
              0 !== e.parents_with_sub_menu.length &&
                ((t = e.root.find(
                  '[data-x-menu--depth="3"] .x-menu--level-2--container'
                )),
                t.each(function () {
                  var e, t, i;
                  if (
                    ((e = $(this)),
                    (t = e.find('[data-x-menu--single-parent="true"]')),
                    t.length > 0)
                  )
                    return (
                      (i = $(
                        '<div class="x-menu--single-parents"></div>'
                      ).insertAfter(e.find(".x-menu--bg"))),
                      i.append("<ul>").find("ul").append(t)
                    );
                }))
            );
          }),
          (e.prototype.slideDown = function (e, t) {
            var i, o, n, r, a;
            if (
              (null == t && (t = !1),
              (i = this),
              clearTimeout(i.timer),
              (n = e.parent()),
              "true" === n.attr("data-x-menu--open") || "closing" === i.state)
            )
              return !1;
            i.slideUp(!1),
              t && "complete" !== t
                ? (i.timer = setTimeout(function () {
                    return i.slideDown(e, "complete");
                  }, t))
                : (e
                    .closest(".x-menu--level-1--link")
                    .find(".fw--icon--expand-less")
                    .show(),
                  e
                    .closest(".x-menu--level-1--link")
                    .find(".fw--icon--expand-more")
                    .hide(),
                  e
                    .closest(".x-menu--level-1--link")
                    .find(".fw--icon--minus")
                    .show(),
                  e
                    .closest(".x-menu--level-1--link")
                    .find(".fw--icon--plus")
                    .hide(),
                  (i.state = "open"),
                  n.attr("data-x-menu--open", "true"),
                  e.attr("aria-expanded", "true"),
                  (a = e
                    .closest(".x-menu--level-1--link")
                    .find(".x-menu--level-2--container")),
                  (o = "block"),
                  "3" === n.attr("data-x-menu--depth") && (o = "flex"),
                  a.velocity("stop"),
                  a.css({ height: "auto", display: o }),
                  a.find(".x-menu--level-2--list").css({ display: o }),
                  (r = a.outerHeight()),
                  a.css({ height: 0, opacity: 1 }),
                  a.velocity(
                    { height: [r, 0] },
                    { queue: !1, duration: 600, easing: "easeOutExpo" }
                  ));
          }),
          (e.prototype.slideUp = function (e) {
            var t, i, o, n;
            return (
              null == e && (e = 300),
              (t = this),
              !t.debugging &&
                ((o = t.parents_with_sub_menu.filter(
                  '[data-x-menu--open="true"]'
                )),
                (i = o.find("> a")),
                "false" !== o.attr("data-x-menu--open") &&
                  (e
                    ? (t.timer = setTimeout(function () {
                        return t.slideUp(!1);
                      }, e))
                    : (i
                        .closest(".x-menu--level-1--link")
                        .find(".fw--icon--expand-less")
                        .hide(),
                      i
                        .closest(".x-menu--level-1--link")
                        .find(".fw--icon--expand-more")
                        .show(),
                      i
                        .closest(".x-menu--level-1--link")
                        .find(".fw--icon--minus")
                        .hide(),
                      i
                        .closest(".x-menu--level-1--link")
                        .find(".fw--icon--plus")
                        .show(),
                      (n = i
                        .closest(".x-menu--level-1--link")
                        .find(".x-menu--level-2--container")),
                      o.attr("data-x-menu--open", "false"),
                      i.attr("aria-expanded", "false"),
                      n.velocity(
                        { opacity: 0 },
                        {
                          begin: function () {
                            return (t.state = "closing");
                          },
                          complete: function () {
                            return (
                              n.css({ display: "none" }), (t.state = "closed")
                            );
                          },
                          duration: 200,
                        }
                      ))))
            );
          }),
          e
        );
      })()),
      (theme.classes.FrameworkYMenu = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.slideRight = k(this.slideRight, this)),
            (this.slideLeft = k(this.slideLeft, this)),
            (this.adjustHeight = k(this.adjustHeight, this)),
            (this.listeners = k(this.listeners, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.state = "closed"),
            (t.sub_menu_links = t.root
              .find(".fw--icon--chevron-right")
              .parent()),
            (t.back_links = t.root.find(".y-menu--back-link a")),
            (t.regular_links = t.root.find(
              '.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])'
            )),
            (t.timer = null),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (e = this), e.listeners();
          }),
          (e.prototype.listeners = function () {
            var e;
            return (
              (e = this),
              e.regular_links.on("click", function (e) {
                var t;
                (t = $(this).attr("href")),
                  -1 !== t.indexOf("#") &&
                    ("left-open" === theme.partials.FrameworkOffCanvas.state
                      ? theme.partials.FrameworkOffCanvas.closeLeft()
                      : "right-open" ===
                          theme.partials.FrameworkOffCanvas.state &&
                        theme.partials.FrameworkOffCanvas.closeRight(),
                    setTimeout(function () {
                      return (window.location.href = t);
                    }, 450));
              }),
              e.sub_menu_links.on("click", function (t) {
                return e.slideLeft($(this)), !1;
              }),
              e.back_links.on("click", function (t) {
                return e.slideRight($(this)), !1;
              })
            );
          }),
          (e.prototype.adjustHeight = function (e) {
            var t, i;
            return (
              (t = this),
              t.root.css({ height: "auto" }),
              t.root.outerHeight(),
              (i = e.outerHeight()),
              "absolute" === e.css("position") &&
                (e.css("position", "relative"),
                (i = e.outerHeight()),
                e.css("position", "absolute")),
              t.root.velocity({ height: i })
            );
          }),
          (e.prototype.slideLeft = function (e) {
            var t, i;
            return (
              (t = this),
              (i = e.closest("li").find("ul").first()),
              i.css({ display: "block" }),
              t.adjustHeight(i),
              i.velocity({ translateX: ["-100%", 0] }),
              i.find("li").first().find("a").focus()
            );
          }),
          (e.prototype.slideRight = function (e) {
            var t, i, o;
            return (
              (t = this),
              (i = e.closest("ul")),
              (o = i.parent().closest("ul")),
              t.adjustHeight(o),
              i.velocity({ translateX: [0, "-100%"] }),
              setTimeout(function () {
                i.hide();
                i.parent().find("a").first().focus();
              }, 100)
            );
          }),
          e
        );
      })()),
      (e = (function () {
        function e() {
          $(".accordion.headings").each(function () {
            return $(this)
              .add($(this).next(".accordion.content"))
              .wrapAll("<div class='accordion-wrapper'/>");
          }),
            $(".accordion.headings li").wrapInner(
              '<div class="trigger"></div>'
            ),
            $(".accordion.headings li .trigger").append(
              '<div class="bg"></div>'
            ),
            $(".accordion-wrapper").each(function () {
              var e, t;
              return (
                (t = $(this).find(".accordion.headings > li")),
                (e = $(this).find(".accordion.content > li")),
                t.first().addClass("active"),
                e.each(function (e) {
                  var i;
                  return (
                    (i = $(
                      '<div class="content">' + $(this).html() + "</div>"
                    )),
                    i.appendTo(t.eq(e))
                  );
                }),
                e.remove(),
                $(this).find(".content").first().show(),
                $(this)
                  .find(".trigger")
                  .on("click", function () {
                    var e, t;
                    return (
                      (e = $(this).closest(".accordion").find(".content")),
                      (t = $(this).closest("li").find(".content")),
                      e.not(t).slideUp(200),
                      t.slideDown(200, function () {
                        if (general_scroll_to_active_item)
                          return $("html, body").animate({
                            scrollTop: t.offset().top - 100,
                          });
                      }),
                      $(this)
                        .closest(".accordion")
                        .find("li")
                        .removeClass("active"),
                      $(this).closest("li").addClass("active")
                    );
                  })
              );
            });
        }
        return e;
      })()),
      (theme.classes.FeaturedBlog = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (t = this),
            (t.item_container = t.root.find(".featured-blog--body")),
            (t.items = t.root.find(".featured-blog--item")),
            t.matchImageHeights(),
            t.resizeListeners();
        }
        return (
          (e.prototype.matchImageHeights = function () {
            var e;
            return (
              (e = this),
              theme.utils.matchImageHeights(
                e.item_container,
                e.items,
                ".featured-blog--item--image"
              )
            );
          }),
          (e.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.FeaturedGrid",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              )
            );
          }),
          e
        );
      })()),
      (theme.classes.FeaturedProduct = (function (e) {
        function t() {
          return (
            (this.addToCartListener = k(this.addToCartListener, this)),
            t.__super__.constructor.apply(this, arguments)
          );
        }
        return (
          x(t, e),
          (t.prototype.addToCartListener = function () {
            var e;
            if (((e = this), e.cart_form.length > 0))
              return e.cart_form.submit(function () {
                return theme.partials.cart.addToCart($(this)), !1;
              });
          }),
          t
        );
      })(theme.classes.FrameworkFeaturedProduct)),
      (n = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.stickyFooter = k(this.stickyFooter, this)),
            (this.addListeners = k(this.addListeners, this)),
            (this.load = k(this.load, this)),
            (t = this),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (e = this), e.addListeners(), e.stickyFooter();
          }),
          (e.prototype.addListeners = function () {
            var e;
            return (
              (e = this),
              g.on("resize", function () {
                return e.stickyFooter();
              })
            );
          }),
          (e.prototype.stickyFooter = function () {
            var e;
            if (
              ((e =
                a.outerHeight() +
                $(".main-content").outerHeight() +
                $(".main-footer").outerHeight()),
              g.outerHeight() > e)
            )
              return $(".main-content").css({
                "min-height":
                  g.outerHeight() -
                  $(".main-header").outerHeight() -
                  $(".main-footer").outerHeight(),
              });
          }),
          e
        );
      })()),
      (r = (function () {
        function e(e) {
          (this.eventListeners = k(this.eventListeners, this)),
            (this.alignPlayButton = k(this.alignPlayButton, this)),
            (this.alignCaption = k(this.alignCaption, this)),
            (this.isFirstSlider = k(this.isFirstSlider, this)),
            (this.getActiveIndex = k(this.getActiveIndex, this)),
            (this.autoplay = k(this.autoplay, this)),
            (this.removeDuplicateVideoModals = k(
              this.removeDuplicateVideoModals,
              this
            )),
            (this.createSlider = k(this.createSlider, this));
          var t, i;
          (t = this),
            (this.el = e),
            (i = this.el.closest(".slider")),
            (this.autoplay_enabled = i.data("autoplay")),
            i.find(".slide").length < 2 && (this.autoplay_enabled = !1),
            (this.autoplay_frequency = i.data("rotateFrequency")),
            (this.transition_style = i.data("transitionStyle")),
            t.removeDuplicateVideoModals(),
            this.createSlider(),
            (this.owl = $(".owl-carousel").data("owlCarousel"));
        }
        return (
          (e.prototype.createSlider = function () {
            var e, t;
            return (
              (e = this),
              (t = {
                singleItem: !0,
                navigation: !0,
                navigationText: ["", ""],
                paginationNumbers: !1,
                scrollPerPageNav: !0,
                slideSpeed: 800,
                pagination: !0,
                autoHeight: !0,
                autoPlay: e.autoplay(),
                afterInit: function () {
                  return e.eventListeners();
                },
                afterAction: function () {
                  return e.alignCaption(), e.alignPlayButton();
                },
              }),
              "default" !== this.transition_style &&
                (t.transitionStyle = this.transition_style),
              e.el.owlCarousel(t)
            );
          }),
          (e.prototype.removeDuplicateVideoModals = function () {
            return this, $(".modal.video:gt(0)").remove();
          }),
          (e.prototype.autoplay = function () {
            return !!this.autoplay_enabled && this.autoplay_frequency;
          }),
          (e.prototype.getActiveIndex = function () {
            return this.el.find(".owl-pagination .owl-page.active").index();
          }),
          (e.prototype.isFirstSlider = function () {
            var e, t, i;
            return (
              (t = $(".index-sections").children("div:first")),
              (i = t.find(".slider").data("sectionId")),
              (e = this.el.closest(".slider").data("sectionId")),
              !!t.hasClass("section--slideshow") && e === i
            );
          }),
          (e.prototype.alignCaption = function () {
            var e, t, i, o, n, r;
            return (
              (o = this.el.find(".owl-item").eq(this.getActiveIndex())),
              (e = o.find(".caption")),
              e.css("visibility", "hidden"),
              (t = e.outerHeight()),
              (i = e.outerWidth()),
              (n = 30),
              (r =
                theme.utils.transparentMenuIsEnabled() &&
                !0 === this.isFirstSlider()
                  ? $(".main-header").outerHeight()
                  : 0),
              theme.utils.imagesLoaded(o.find("img").first(), function () {
                var a, s, l, c;
                return (
                  (l = o.outerHeight()),
                  (c = o.outerWidth()),
                  e.hasClass("top")
                    ? e.css("top", r + n)
                    : e.hasClass("middle") &&
                      ((s = r + (l - r - t) / 2), e.css("top", s)),
                  e.hasClass("center") && ((a = (c - i) / 2), e.css("left", a)),
                  e.css("visibility", "visible")
                );
              })
            );
          }),
          (e.prototype.alignPlayButton = function () {
            var e, t;
            return (
              (t = this.el.find(".owl-item").eq(this.getActiveIndex())),
              (e = t.find(".play-button")),
              e.css("visibility", "hidden"),
              theme.utils.transparentMenuIsEnabled() &&
              "absolute" === $(".main-header").css("position")
                ? theme.utils.imagesLoaded(t.find("img").first(), function () {
                    var i, o, n;
                    return (
                      (o = t.outerHeight()),
                      (i = e.outerHeight()),
                      (n = (o - i) / 2),
                      e.css({ "margin-top": 0, top: n })
                    );
                  })
                : e.css({ "margin-top": "-40px", top: "50%" }),
              e.css("visibility", "visible")
            );
          }),
          (e.prototype.eventListeners = function () {
            var e;
            return (
              (e = this),
              this.el.find(".play-button").on("click", function () {
                var t;
                return (
                  (t = new m($(this).closest(".video"))),
                  t.open(),
                  e.owl.stop(),
                  !1
                );
              }),
              this.el
                .find(".owl-pagination .owl-page")
                .on("click", function () {
                  return e.owl.stop();
                }),
              o.on("header.transparentMenuIsUpdated", e.alignCaption)
            );
          }),
          e
        );
      })()),
      (theme.classes.Header = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.moveYMenu = k(this.moveYMenu, this)),
            (this.sectionListeners = k(this.sectionListeners, this)),
            (this.load = k(this.load, this)),
            (t = this),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              e.searchAndAccount(),
              e.sectionListeners(),
              e.moveYMenu()
            );
          }),
          (e.prototype.sectionListeners = function () {
            var e;
            return (
              (e = this),
              e.root.on("theme:section:load", function () {
                return (
                  theme.partials.FrameworkOffCanvas.unload(),
                  theme.partials.FrameworkOffCanvas.load()
                );
              })
            );
          }),
          (e.prototype.moveYMenu = function () {
            return (
              this,
              $(".mobile-nav--menu").empty(),
              $(".y-menu").appendTo(".mobile-nav--menu")
            );
          }),
          (e.prototype.searchAndAccount = function () {
            return (
              this,
              $(".account-openX").click(function () {
                return (
                  $(this)
                    .closest(".menu")
                    .fadeOut(100, function () {
                      return $(".account-container").fadeIn(200);
                    }),
                  !1
                );
              }),
              $(".account-closeX").click(function () {
                return (
                  $(".account-container").fadeOut(100, function () {
                    return $(".search-account .menu").fadeIn(200);
                  }),
                  !1
                );
              })
            );
          }),
          e
        );
      })()),
      (s = (function () {
        function e() {
          $(".tabs-horizontal.headings").each(function () {
            return $(this)
              .add($(this).next(".tabs.content"))
              .wrapAll("<div class='tabs-wrapper horizontal'/>");
          }),
            $(".tabs-horizontal.headings li").wrapInner(
              '<div class="trigger"></div>'
            ),
            $(".tabs-horizontal.headings li .trigger").append(
              '<div class="bg"></div>'
            ),
            $(".tabs-wrapper.horizontal").each(function () {
              var e, t;
              return (
                (t = $(this).find(".headings > li")),
                (e = $(this).find(".tabs.content > li")),
                e.first().addClass("active"),
                t.first().addClass("active"),
                t.on("click", function () {
                  return (
                    t.removeClass("active"),
                    e.removeClass("active"),
                    $(this).addClass("active"),
                    e.eq($(this).index()).addClass("active")
                  );
                })
              );
            });
        }
        return e;
      })()),
      (l = (function () {
        function e() {
          this.load = k(this.load, this);
          var e;
          (e = this), e.listeners(), e.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            if (
              (this,
              window.matchMedia("only screen and (min-width: " + w + "px)")
                .matches)
            ) {
              if ("large" !== e)
                return $.event.trigger("largeWindow"), (e = "large");
            } else if (
              window.matchMedia("only screen and (min-width: " + b + "px)")
                .matches
            ) {
              if ("medium" !== e)
                return $.event.trigger("mediumWindow"), (e = "medium");
            } else if ("small" !== e)
              return $.event.trigger("smallWindow"), (e = "small");
          }),
          (e.prototype.listeners = function () {
            var e;
            return (e = this), g.on("resize.section-" + e.section_id, e.load);
          }),
          e
        );
      })()),
      (d = (function () {
        function e(e) {
          var t, i, n, r, a, s, l, u, d, p, h, f, m, v, y, w, b, _, k, x, C;
          (this.clazz = e),
            (y = null),
            (w = this.clazz),
            (m = $(".popup-modal-mask")),
            (C = function () {
              var e, t, i, o;
              (e = new Date()),
                (o = 864e5 * popup_config.days_until),
                (t = e.setTime(e.getTime() + o)),
                (i = { expires: t });
              try {
                return (localStorage[popup_config.storage_key] =
                  JSON.stringify(i));
              } catch (e) {
                return e, !1;
              }
            }),
            (k = function () {
              return localStorage.removeItem(popup_config.storage_key), C();
            }),
            (f = function () {
              var e, t, i;
              return (
                (i = JSON.parse(localStorage[popup_config.storage_key])),
                (e = i.expires),
                (t = new Date().getTime()),
                parseFloat(e - t) <= 0 && (k(), !0)
              );
            }),
            (_ = function () {
              var e;
              return (
                (e = !1),
                "undefined" === Storage || popup_config.test_mode
                  ? (e = !0)
                  : void 0 === localStorage[popup_config.storage_key]
                  ? ((e = !0), C())
                  : (e = f()),
                e
              );
            }),
            (v = function () {
              return (
                $(".popup-modal").is(":visible") ||
                ($(".modal-mask").length > 0 && $(".modal-mask").is(":visible"))
              );
            }),
            (x = function () {
              return m.show(), c.addClass("modal-on");
            }),
            (h = function () {
              return m.hide(), c.removeClass("modal-on");
            }),
            (l = function () {
              return !1 === popup_config.show_image_enabled
                ? ""
                : popup_config.image_link.length > 0
                ? $(
                    '<div class="popup-image"><button class="popup-modal-close" aria-label="Close">&#x2715;</button><a href="' +
                      popup_config.image_link +
                      '">' +
                      popup_config.show_image_url +
                      "</a> </div>"
                  )
                : $(
                    '<div class="popup-image"><button class="popup-modal-close" aria-label="Close">&#x2715;</button>'
                  ).append(popup_config.show_image_url);
            }),
            (u = function () {
              window.newsletterHTML =
                $(".popup--root").html() || window.newsletterHTML;
              return !1 === popup_config.newsletter_enabled
                ? ""
                : $("<div id='subscribe_module'></div>").append(
                    $(".popup--root")
                  );
            }),
            (d = function () {
              return !1 === popup_config.social_icons_enabled
                ? ""
                : $(".social-follow").clone();
            }),
            (s = function () {
              var e;
              return (
                (e = ""),
                (e +=
                  !0 === popup_config.show_image_enabled
                    ? " has-image"
                    : " has-no-image"),
                (e +=
                  popup_config.page_content.length > 0
                    ? " has-page-content"
                    : " has-no-page-content"),
                (e += popup_config.newsletter_enabled
                  ? " has-newsletter"
                  : " has-no-newsletter"),
                (e += popup_config.social_icons_enabled
                  ? " has-social-icons"
                  : " has-no-social-icons")
              );
            }),
            (p = function () {
              return (
                '<dialog aria-label="Newsletter popup" aria-describedby="newsletterDialogDesc" aria-modal="true" role="dialog" class="' +
                w +
                " popup-modal" +
                s() +
                '" />'
              );
            }),
            (a = function () {
              var e;
              return (
                $(".popup-modal.size-chart").length < 1 &&
                  ((e = { wrapper: p() }),
                  c.append($(e.wrapper).append($(".size-chart")))),
                b()
              );
            }),
            (r = function () {
              var e, t, i;
              return (
                (e = {
                  wrapper: p(),
                  newsletter: u(),
                  social_icons: d(),
                  image: l(),
                }),
                (t = function () {
                  return popup_config.page_content.length < 1 &&
                    !1 === popup_config.newsletter_enabled &&
                    !1 === popup_config.social_icons_enabled
                    ? ""
                    : $("<div class='inner' />").append(
                        e.body,
                        e.newsletter,
                        e.social_icons
                      );
                }),
                (i = function () {
                  return c.append($(e.wrapper).append(e.image, t())), b();
                }),
                popup_config.page_content.length > 0
                  ? $.getJSON(
                      "/pages/" + popup_config.page_content + ".json",
                      function (t, o) {
                        return (
                          (e.body =
                            "<div class='page-contents'>" +
                            t.page.body_html +
                            "</div>"),
                          i()
                        );
                      }
                    )
                  : i()
              );
            }),
            (t = function () {
              return setTimeout(function () {
                if (y.length > 0 && $(".popup-modal-mask").is(":visible"))
                  return theme.utils.imagesLoaded(y, function () {
                    var e;
                    return (
                      (e = $(
                        'dialog[class*="' + w + '"]:last-of-type'
                      ).outerHeight()),
                      e >= g.height()
                        ? c.addClass("modal-unfix")
                        : c.removeClass("modal-unfix")
                    );
                  });
              }, 0);
            }),
            (b = function () {
              setTimeout(function () {
                document.getElementById("subscribe_email4").focus();
              }, 300);
              return (
                (y = $('dialog[class*="' + w + '"]')),
                n(),
                y.addClass("opened").removeClass("closed"),
                t(),
                x()
              );
            }),
            (n = function () {
              var e;
              return (
                (e = function (e) {
                  return "modal-close" === e.originalEvent.animationName
                    ? "popup" === w
                      ? y.remove()
                      : y.removeClass("closed, completed")
                    : y.addClass("completed").removeClass("opened");
                }),
                o.on("click", ".popup-modal", function (e) {
                  if ((e.stopPropagation(), e.target === this)) return i();
                }),
                $(".popup-modal-close").click(i),
                m.click(i),
                y.on(
                  "animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd",
                  e
                ),
                g.resize(t),
                o.keydown(function (e) {
                  if (y.hasClass("completed") && 27 === e.keyCode) return i();
                }),
                $("dialog.popup-modal #contact_form").on(
                  "submit",
                  function (e) {
                    var t;
                    return (
                      (t = this),
                      (y = $(this).closest(".popup-modal")),
                      y.find(".error, .success").remove(),
                      e.preventDefault(),
                      0 === y.find('input[type="email"]').val().length
                        ? (y
                            .find(".inner")
                            .prepend(
                              '<p class="error">' +
                                theme.translation.newsletter_email_blank +
                                "</p>"
                            ),
                          !1)
                        : (t.submit(), !1)
                    );
                  }
                )
              );
            }),
            (i = function () {
              return (
                y
                  .addClass("closed")
                  .removeClass("completed")
                  .removeClass("opened"),
                h()
              );
            }),
            (window.showPopup = r),
            "popup" !== w
              ? a()
              : popup_config.enabled &&
                _() &&
                (popup_config.page_content.length > 0 ||
                  popup_config.newsletter_enabled ||
                  popup_config.show_image_enabled ||
                  popup_config.social_icons_enabled) &&
                setTimeout(function () {
                  if (!(!0 === v() || $(".popup-modal-mask").length < 1))
                    return r();
                }, 1e3 * popup_config.seconds_until);
        }
        return e;
      })()),
      (theme.classes.ProductGrid = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.hoverImagesLoaded = k(this.hoverImagesLoaded, this)),
            (this.listeners = k(this.listeners, this)),
            (this.matchImageHeights = k(this.matchImageHeights, this)),
            (this.detectOnboarding = k(this.detectOnboarding, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.items = t.root.find(".product--root")),
            (t.onboarding = t.detectOnboarding()),
            (t.in_slider = t.root.data("in-slider")),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            if (
              ((e = this), e.listeners(), e.hoverImagesLoaded(), !e.in_slider)
            )
              return e.matchImageHeights();
          }),
          (e.prototype.detectOnboarding = function () {
            var e;
            return (e = this), !!e.items.first().find(".placeholder").length;
          }),
          (e.prototype.matchImageHeights = function () {
            var e;
            return (
              (e = this),
              theme.utils.matchImageHeights(
                e.root,
                e.items,
                ".product--image-wrapper"
              )
            );
          }),
          (e.prototype.listeners = function () {
            var e;
            if (((e = this), !e.in_slider))
              return $(window).on(
                "resize.ProductGrid",
                theme.utils.debounce(100, function () {
                  return e.matchImageHeights();
                })
              );
          }),
          (e.prototype.hoverImagesLoaded = function () {
            var e;
            return (
              (e = this),
              e.items.filter('[data-hover-image="true"]').each(function () {
                var e;
                return (
                  (e = $(this)),
                  theme.utils.imagesLoaded(e, function () {
                    return e.attr("data-hover-image", "loaded");
                  })
                );
              })
            );
          }),
          e
        );
      })()),
      (p = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.listeners = k(this.listeners, this)),
            (this.afterUpdate = k(this.afterUpdate, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.product_grid = t.root.find(".product-grid--root")),
            (t.product_item = t.root.find(".product--root")),
            t.load(),
            t.listeners();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              e.product_grid.owlCarousel({
                items: 4,
                navigation: !0,
                scrollPerPage: !0,
                slideSpeed: 800,
                lazyLoad: !1,
                pagination: !1,
                navigationText: !1,
                afterUpdate: e.afterUpdate(),
              }),
              e.product_item.show()
            );
          }),
          (e.prototype.afterUpdate = function () {
            return this, $(window).trigger("ProductSlider.afterUpdate");
          }),
          (e.prototype.listeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.ProductGrid",
                theme.utils.debounce(100, function () {
                  return e.loadCarousel;
                })
              )
            );
          }),
          e
        );
      })()),
      (h = (function () {
        function e(e) {
          var t;
          (this.root = e),
            (this.load = k(this.load, this)),
            (t = this),
            (t.promo_bar = t.root),
            (t.close_btn = t.root.find("button")),
            t.load();
        }
        return (
          (e.prototype.load = function () {
            var e;
            return (
              (e = this),
              "undefined" != typeof Storage &&
              null !== Storage &&
              sessionStorage["promo-bar-closed"]
                ? e.promo_bar.hide()
                : (e.promo_bar.show(),
                  e.close_btn.on("click", function () {
                    return e.close();
                  }))
            );
          }),
          (e.prototype.close = function () {
            var e;
            return (
              (e = this),
              "undefined" == typeof Storage ||
                null === Storage ||
                sessionStorage["promo-bar-closed"] ||
                (sessionStorage["promo-bar-closed"] = !0),
              e.promo_bar.addClass("closed")
            );
          }),
          e
        );
      })()),
      (f = (function () {
        function e() {
          $(".tabs-vertical.headings").each(function () {
            return $(this)
              .add($(this).next(".tabs.content"))
              .wrapAll("<div class='tabs-wrapper vertical'/>");
          }),
            $(".tabs-vertical.headings li").wrapInner(
              '<div class="trigger"></div>'
            ),
            $(".tabs-vertical.headings li .trigger").append(
              '<div class="bg"></div>'
            ),
            $(".tabs-wrapper.vertical").each(function () {
              var e, t, i;
              return (
                (i = $(this)),
                (t = $(this).find(".headings > li")),
                (e = $(this).find(".tabs.content > li")),
                e.first().addClass("active"),
                t.first().addClass("active"),
                t.on("click", function () {
                  if (
                    (t.removeClass("active"),
                    e.removeClass("active"),
                    $(this).addClass("active"),
                    e.eq($(this).index()).addClass("active"),
                    general_scroll_to_active_item)
                  )
                    return matchMedia(
                      "only screen and (min-width: " + b + "px)"
                    ).matches
                      ? $("html, body").animate(
                          { scrollTop: i.offset().top - 50 },
                          "slow"
                        )
                      : $("html, body").animate(
                          {
                            scrollTop:
                              i.offset().top +
                              i.find(".headings").outerHeight() -
                              50,
                          },
                          "slow"
                        );
                })
              );
            });
        }
        return e;
      })()),
      (m = (function () {
        function e(e) {
          (this.createIframe = k(this.createIframe, this)),
            (this.extractVideoId = k(this.extractVideoId, this)),
            (this.extractVideoType = k(this.extractVideoType, this)),
            (this.eventListeners = k(this.eventListeners, this)),
            (this.centerPosition = k(this.centerPosition, this)),
            (this.close = k(this.close, this)),
            (this.open = k(this.open, this)),
            (this.opened = !1),
            (this.video = e),
            (this.modal = $(".video.modal")),
            (this.player_button = e.find(".player-button")),
            (this.src_url = e.find(".play-button").attr("href")),
            (this.type = this.extractVideoType()),
            (this.id = this.extractVideoId()),
            (this.iframe = this.createIframe()),
            (this.caption = e.find(".caption"));
        }
        return (
          (e.prototype.open = function () {
            return (
              (this.opened = !0),
              this.modal.find(".flex-video").append(this.iframe),
              this.caption.length > 0
                ? (this.modal.find(".caption").append(this.caption.html()),
                  this.modal.addClass("wide"))
                : (this.modal.find(".player").removeClass("large-8"),
                  this.modal.find(".caption").hide(),
                  this.modal.removeClass("wide")),
              this.player_button.hide(),
              $(".modal-mask").show(),
              this.modal.find(".close").show(),
              this.modal.fadeIn(),
              this.centerPosition(),
              $(".modal").fadeIn(0),
              this.eventListeners()
            );
          }),
          (e.prototype.close = function () {
            if (
              ((this.opened = !1),
              this.modal.find(".flex-video").empty(),
              this.modal.find(".caption").empty(),
              this.modal.hide(),
              $(".modal-mask").fadeOut(),
              0 === this.caption.length)
            )
              return (
                this.modal.find(".player").addClass("large-8"),
                this.modal.find(".caption").show()
              );
          }),
          (e.prototype.centerPosition = function () {
            return g.height() < this.modal.outerHeight()
              ? this.modal.css({
                  position: "absolute",
                  top: "30px",
                  "margin-top": 0,
                  "margin-left": -this.modal.outerWidth() / 2,
                })
              : this.modal.css({
                  position: "fixed",
                  top: "50%",
                  "margin-top": -this.modal.outerHeight() / 2,
                  "margin-left": -this.modal.outerWidth() / 2,
                });
          }),
          (e.prototype.eventListeners = function () {
            var e;
            return (
              (e = this),
              this.modal.find(".close").on("click", function () {
                return e.close();
              }),
              g.resize(function () {
                return e.centerPosition();
              }),
              o.keydown(function (t) {
                if (e.opened && 27 === t.keyCode) return e.close();
              }),
              $(".modal-mask").on("click", function () {
                return e.close();
              }),
              this.player_button.on("click", function () {
                return !1;
              })
            );
          }),
          (e.prototype.extractVideoType = function () {
            var e, t;
            return (
              (t =
                /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i),
              (e = t.exec(this.src_url)),
              e
                ? "youtube"
                : ((t = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/),
                  !!(e = t.exec(this.src_url)) && "vimeo")
            );
          }),
          (e.prototype.extractVideoId = function () {
            var e, t;
            if ("youtube" === this.type) {
              if (
                ((t =
                  /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/),
                (e = this.src_url.match(t)) && 11 === e[2].length)
              )
                return e[2];
            } else if (
              "vimeo" === this.type &&
              ((t = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/),
              (e = this.src_url.match(t)))
            )
              return e[2];
          }),
          (e.prototype.createIframe = function () {
            return "youtube" === this.type
              ? '<iframe  src="//www.youtube.com/embed/' +
                  this.id +
                  '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>'
              : "vimeo" === this.type
              ? '<iframe src="//player.vimeo.com/video/' +
                this.id +
                '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
              : void 0;
          }),
          e
        );
      })()),
      (theme.classes.XMenu = (function (e) {
        function t(e) {
          var i;
          (this.root = e),
            (this.slideDown = k(this.slideDown, this)),
            (this.hideHeader = k(this.hideHeader, this)),
            (this.showHeader = k(this.showHeader, this)),
            (this.headerListeners = k(this.headerListeners, this)),
            (this.isHeaderTransparent = k(this.isHeaderTransparent, this)),
            (i = this),
            (i.header = $(".main-header")),
            (i.header_bg = i.header.find(".header--bg")),
            (i.header_timer = null),
            (i.transparent_header = i.isHeaderTransparent()),
            t.__super__.constructor.apply(this, arguments),
            i.headerListeners();
        }
        return (
          x(t, e),
          (t.prototype.isHeaderTransparent = function () {
            return (
              this,
              "true" === $(".header").attr("data-header--menu-transparent")
            );
          }),
          (t.prototype.headerListeners = function () {
            var e;
            return (
              (e = this),
              e.parents_with_sub_menu.on("mouseenter", function (t) {
                return clearTimeout(e.header_timer);
              }),
              e.header.on("mouseenter touchstart", function (t) {
                return clearTimeout(e.header_timer), e.showHeader();
              }),
              e.header.on("mouseleave", function (t) {
                return (e.header_timer = setTimeout(function () {
                  return e.hideHeader();
                }, 500));
              })
            );
          }),
          (t.prototype.showHeader = function () {
            var e;
            if (((e = this), 0 === parseInt(e.header_bg.css("opacity"))))
              return e.header_bg.velocity(
                { opacity: [0.95] },
                { duration: 400, queue: !1 }
              );
          }),
          (t.prototype.hideHeader = function () {
            var e;
            return (
              (e = this),
              !(
                e.parents_with_sub_menu.filter('[data-main-menu--open="true"]')
                  .length > 0
              ) &&
                (e.header_bg.velocity({ opacity: 0 }, { duration: 400 }),
                e.slideUp())
            );
          }),
          (t.prototype.slideDown = function (e, i) {
            var o;
            return (
              null == i && (i = !1),
              (o = this),
              "complete" !== i &&
                Math.round(100 * parseFloat(o.header_bg.css("opacity"))) < 90 &&
                o.transparent_header &&
                (i = 400),
              t.__super__.slideDown.call(this, e, i)
            );
          }),
          t
        );
      })(theme.classes.FrameworkXMenu)),
      (t = (function () {
        function e() {
          (this.recentCartItemPopUp = k(this.recentCartItemPopUp, this)),
            (this.addToCart = k(this.addToCart, this)),
            (this.validateSize = k(this.validateSize, this)),
            (this.stopResetTimer = k(this.stopResetTimer, this)),
            (this.startTimer = k(this.startTimer, this)),
            (this.fadeOutCartDropdown = k(this.fadeOutCartDropdown, this)),
            (this.openMobileModal = k(this.openMobileModal, this)),
            (this.slideDownCartDropdown = k(this.slideDownCartDropdown, this)),
            (this.listeners = k(this.listeners, this)),
            (this.load = k(this.load, this));
          var e;
          (e = this), (e.cart_dropdown_timer = null), e.listeners();
        }
        return (
          (e.prototype.load = function () {
            return this;
          }),
          (e.prototype.listeners = function () {
            var e;
            return (
              (e = this),
              $(".product-page--cart-form form")
                .off()
                .on("submit", function () {
                  return e.addToCart($(this)), !1;
                }),
              $(".recently-added.mobile .close")
                .off()
                .on("click", function () {
                  return e.fadeOutCartDropdown();
                }),
              $(".recently-added-mask")
                .off()
                .on("click", function () {
                  return e.fadeOutCartDropdown();
                }),
              $(".main-header .recently-added").mouseenter(function () {
                return e.stopResetTimer();
              }),
              $(".main-header .recently-added").mouseleave(function () {
                return e.startTimer();
              })
            );
          }),
          (e.prototype.toggleCartDropdown = function () {
            return $(".main-header .recently-added").slideToggle("fast");
          }),
          (e.prototype.slideDownCartDropdown = function () {
            return (
              $(".main-header .recently-added").slideDown("fast"),
              $("html, body").animate({ scrollTop: 0 })
            );
          }),
          (e.prototype.openMobileModal = function () {
            return (
              $(".main-header .recently-added.mobile").fadeIn(),
              $(".main-header .recently-added-mask").removeClass("hide")
            );
          }),
          (e.prototype.fadeOutCartDropdown = function () {
            var e;
            return (
              (e = this),
              clearTimeout(e.cart_dropdown_timer),
              $(".main-header .recently-added").fadeOut("fast"),
              $(".main-header .recently-added-mask").addClass("hide")
            );
          }),
          (e.prototype.startTimer = function () {
            var e;
            return (
              (e = this),
              (e.cart_dropdown_timer = setTimeout(function () {
                return e.fadeOutCartDropdown();
              }, 4e3))
            );
          }),
          (e.prototype.stopResetTimer = function () {
            var e;
            return (e = this), clearTimeout(e.cart_dropdown_timer);
          }),
          (e.prototype.validateSize = function (e) {
            return (
              !e.find("select option:selected").is(":disabled") ||
              (e
                .find(".dropdown")
                .effect("shake", { times: 2, distance: 5 }, 400),
              !1)
            );
          }),
          (e.prototype.addToCart = function (e) {
            var t, i, o;
            return (
              (t = this),
              (o = function (e) {
                return t.recentCartItemPopUp();
              }),
              (i = function (e, i) {
                return (
                  $(".recently-added .error").show(),
                  $(".recently-added table").hide(),
                  $(".recently-added div.row").hide(),
                  t.slideDownCartDropdown(),
                  t.startTimer()
                );
              }),
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: e.serialize(),
                success: o,
                error: i,
              })
            );
          }),
          (e.prototype.recentCartItemPopUp = function () {
            var e, t, i;
            return (
              (e = this),
              (t = {}),
              (i = {}),
              $.getJSON("/cart.js", function (o, n) {
                var r, a, s;
                return (
                  (t.image_url = Shopify.resizeImage(o.items[0].image, "160x")),
                  (t.url = o.items[0].url),
                  (t.title = o.items[0].title),
                  (t.price = Shopify.formatMoney(
                    o.items[0].price,
                    shop_money_format
                  )),
                  (i.price = Shopify.formatMoney(
                    o.total_price,
                    shop_money_format
                  )),
                  (i.quantity = o.item_count),
                  $(
                    ".cart-link .number, .header--mobile--cart-link .number"
                  ).html(i.quantity),
                  $(
                    ".cart-link .number-wrapper, .header--mobile--cart-link .number-wrapper"
                  ).removeClass("hide"),
                  (a = "<tr>"),
                  (a += '<td class="cart-item">'),
                  (a += '<a href="' + t.url + '">'),
                  (a +=
                    '<img src="' + t.image_url + '" alt="' + t.title + '">'),
                  (a += "</a>"),
                  (a += "</td>"),
                  (a += '<td class="cart-detail">'),
                  (a += '<h2><a href="' + t.url + '">' + t.title + "</a></h2>"),
                  (a += "</td>"),
                  (a +=
                    '<td class="cart-price"><span class="money">' +
                    t.price +
                    "</span></td>"),
                  (a += "</tr>"),
                  (s = '<a href="' + t.url + '">'),
                  (s +=
                    '<img src="' + t.image_url + '" alt="' + t.title + '">'),
                  (s += "</a>"),
                  $(".recently-added tbody").html(a),
                  $(".recently-added .mobile-item").html(s),
                  (r =
                    i.quantity > 1
                      ? theme.translations.cart_items
                      : theme.translations.cart_item),
                  $(".recently-added .items-count").html(
                    '<a href="/cart"> <span class="number">' +
                      i.quantity +
                      "</span> " +
                      r +
                      "</a>"
                  ),
                  $(".recently-added .total-price").html(i.price),
                  currency_switcher_enabled &&
                    ($.each(
                      $(".recently-added .total-price").get(0).attributes,
                      function (e, t) {
                        if (t.name.match("^data-currency"))
                          return $(".recently-added .total-price").attr(
                            t.name,
                            ""
                          );
                      }
                    ),
                    Currency.convertAll(
                      shopCurrency,
                      jQuery("[name=currencies]").val()
                    )),
                  $(".recently-added .error").hide(),
                  $(".recently-added table, .recently-added div.row").show(),
                  "small" === theme.utils.mqs.current_window
                    ? e.openMobileModal()
                    : e.slideDownCartDropdown(),
                  e.startTimer()
                );
              })
            );
          }),
          e
        );
      })()),
      (i = (function () {
        function e() {
          o.on("change", ".tags-listbox", function () {
            var e, t, i;
            return (
              (t = []),
              (e = $(this)),
              e.each(function (e, i) {
                if ($(this).val()) return t.push($(this).val());
              }),
              t.length
                ? ((i = t.join("+")),
                  (window.location.href = $(theme.collection.tag)
                    .attr("href")
                    .replace("tag", i)))
                : theme.collection.handle
                ? (window.location.href =
                    "/collections/" + theme.collection.handle)
                : theme.collection.products.first_type ===
                  theme.collection.title
                ? (window.location.href = theme.collection.url_for_type)
                : theme.collection.products.first_vendor ===
                  theme.collection.title
                ? (window.location.href = theme.collection.url_for_vendor)
                : void 0
            );
          });
        }
        return e;
      })()),
      (u = (function () {
        function e() {
          (this.listeners = k(this.listeners, this)),
            (this.load = k(this.load, this));
          var e;
          (e = this), e.listeners(), e.load();
        }
        return (
          (e.prototype.load = function () {
            if ((this, $(".login-form .errors").size()))
              return $(".login-link").click();
          }),
          (e.prototype.listeners = function () {
            return (
              this,
              o.on("click", ".login-link", function () {
                return (
                  $(this).css("visibility", "hidden"),
                  $(".wrapper").hide(),
                  $(".login-form")
                    .css("visibility", "visible")
                    .find($("[name=password]").focus()),
                  !1
                );
              }),
              o.on("click", ".login-form .cancel", function () {
                return (
                  $(".login-link").css("visibility", "visible"),
                  $(".wrapper").fadeIn(),
                  $(".login-form").css("visibility", "hidden"),
                  !1
                );
              })
            );
          }),
          e
        );
      })()),
      (theme.classes.ProductPage = (function () {
        function i(e) {
          var t;
          (this.root = e),
            (this.cssGridFallback = k(this.cssGridFallback, this)),
            (this.modalCloseListener = k(this.modalCloseListener, this)),
            (this.resizeListeners = k(this.resizeListeners, this)),
            (this.imageZoom = k(this.imageZoom, this)),
            (this.getActiveImageId = k(this.getActiveImageId, this)),
            (this.updateVariantImage = k(this.updateVariantImage, this)),
            (this.thumbListener = k(this.thumbListener, this)),
            (this.variantSelected = k(this.variantSelected, this)),
            (this.sizeChart = k(this.sizeChart, this)),
            (this.updateLowInStock = k(this.updateLowInStock, this)),
            (this.getVariantQuantity = k(this.getVariantQuantity, this)),
            (this.getLowInStockAmount = k(this.getLowInStockAmount, this)),
            (this.getLowInStockMessage = k(this.getLowInStockMessage, this)),
            (this.mobileModalHandler = k(this.mobileModalHandler, this)),
            (this.load = k(this.load, this)),
            (t = this),
            (t.thumbs = t.root.find(".product-page--thumb")),
            (t.main_images = t.root.find(".product-page--image")),
            (t.zoom_images = t.root.find(".product-page--zoom-image")),
            (t.image_container = t.root.find(
              ".product-page--images-container"
            )),
            (t.magnify = parseFloat(t.root.data("magnify"))),
            (t.size_chart_enabled = t.root.data("size-chart-enabled")),
            (t.size_chart_option = t.root
              .data("size-chart-option")
              .toLowerCase()),
            t.load();
        }
        return (
          (i.prototype.load = function () {
            var i, n;
            if (
              ((i = this),
              i.cssGridFallback(),
              i.thumbListener(),
              i.imageZoom(),
              i.resizeListeners(),
              i.modalCloseListener(),
              i.mobileModalHandler(),
              i.root.on("theme:section:load", function () {
                return (
                  new t(),
                  new e(),
                  new s(),
                  new f(),
                  new Shopify.OptionSelectors("variant-listbox", {
                    product: product_json,
                    onVariantSelected: i.variantSelected,
                    enableHistoryState: !0,
                  })
                );
              }),
              (n = $("article .photos")),
              o.on("click", ".size-chart-trigger", function (e) {
                return e.preventDefault(), new d("size-chart-container");
              }),
              n.on("click", function () {
                return !1;
              }),
              $("article .custom.dropdown").hide(),
              1 === product_options_size && "Title" !== product_options_first)
            )
              return $(".selector-wrapper:eq(0)").prepend(
                "<label>" + product_options_first + "</label>"
              );
          }),
          (i.prototype.mobileModalHandler = function () {
            var e, t;
            return (
              (e = this),
              (t = e.image_container.find(".modal--link")),
              t.on("click", function (e) {
                if ("small" === theme.utils.mqs.current_window)
                  return e.stopImmediatePropagation();
              })
            );
          }),
          (i.prototype.getLowInStockMessage = function (e) {
            var t;
            return (
              this,
              (t =
                1 === e
                  ? theme.products.low_in_stock.one
                  : theme.products.low_in_stock.other),
              e > 1 && (t = t.replace(/\d+/, e)),
              t
            );
          }),
          (i.prototype.getLowInStockAmount = function () {
            var e;
            return (e = this), e.root.data("product-low-in-stock-amount");
          }),
          (i.prototype.getVariantQuantity = function (e) {
            var t;
            return (
              (t = $("#variant-listbox").find('[value="' + e.id + '"]')),
              t.length > 0
                ? parseInt(t.data("inventory-quantity"))
                : "not available"
            );
          }),
          (i.prototype.updateLowInStock = function (e) {
            var t, i, n;
            return (
              (t = this),
              (i = t.getVariantQuantity(e)),
              "undefined" !== (n = t.getLowInStockAmount()) &&
                (i > 0 && i <= n
                  ? $(".product-low-in-stock")
                      .html("<p>" + t.getLowInStockMessage(i) + "</p>")
                      .show()
                  : $(".product-low-in-stock").hide(),
                o.on(
                  ".shopify-section section--products shopify:section:select",
                  function () {
                    return t.updateLowInStock(e);
                  }
                ))
            );
          }),
          (i.prototype.sizeChart = function (e) {
            var t;
            if (((t = this), t.size_chart_enabled))
              return $(".selector-wrapper").each(function (i, o) {
                if (
                  e[i].toLowerCase() === t.size_chart_option &&
                  0 === $(o).find(".size-chart-trigger").length
                )
                  return $(o).append(
                    '<a class="size-chart-trigger" href="#">' +
                      theme.products.size_chart.label +
                      "</a>"
                  );
              });
          }),
          (i.prototype.variantSelected = function (e, t, i) {
            var o, n, r, a;
            (o = this),
              $(".compare-price").html(""),
              $('.product-unavailable [type="submit"]').prop("disabled", !0),
              e && e.available
                ? ($(
                    ".quanity-cart-row, .product-page--smart-payment-buttons"
                  ).show(),
                  $(".product-unavailable").hide())
                : ($(
                    ".quanity-cart-row, .product-page--smart-payment-buttons"
                  ).hide(),
                  $(".product-unavailable").show(),
                  $(".product-low-in-stock").hide(),
                  $('.product-unavailable [type="submit"]').prop(
                    "disabled",
                    !1
                  ),
                  product_variant_size > 1 &&
                    e &&
                    $(".product-unavailable form .email-body").attr(
                      "value",
                      "Please notify me when this is back in stock: " +
                        product_title +
                        " - " +
                        e.title
                    )),
              e &&
                ((n = Shopify.formatMoney(e.price, shop_money_format)),
                $(".actual-price").replaceWith(
                  '<span class="actual-price money"' +
                    e.price / 100 +
                    '">' +
                    n +
                    "</span>"
                ),
                e.compare_at_price > e.price &&
                  ((r = Shopify.formatMoney(
                    e.compare_at_price,
                    shop_money_format
                  )),
                  $(".compare-price").html(
                    product_language_was +
                      ' <span class="money">' +
                      r +
                      "</span>"
                  )),
                currency_switcher_enabled &&
                  Currency.convertAll(
                    shopCurrency,
                    $("[name=currencies]").val()
                  ),
                e.featured_image && o.updateVariantImage(e.featured_image.id)),
              (a = !1 !== o.getLowInStockAmount()),
              !0 === a && o.updateLowInStock(e),
              o.sizeChart(t.product.options);
          }),
          (i.prototype.thumbListener = function () {
            var e;
            return (
              (e = this),
              e.thumbs.on("keypress click", function (t) {
                var i;
                return (
                  theme.utils.a11yClick(t) &&
                    ((i = $(this).data("id")), e.updateVariantImage(i)),
                  e.imageZoom()
                );
              })
            );
          }),
          (i.prototype.updateVariantImage = function (e) {
            var t, i, o;
            return (
              (t = this),
              t.main_images.attr("data-active", "false"),
              (i = t.main_images.filter('[data-id="' + e + '"]')),
              i.attr("data-active", "true"),
              t.thumbs.attr("data-active", "false"),
              (o = t.thumbs.filter('[data-id="' + e + '"]')),
              o.attr("data-active", "true"),
              t.imageZoom()
            );
          }),
          (i.prototype.getActiveImageId = function () {
            var e, t;
            return (
              (e = this),
              (t = e.main_images.filter('[data-active="true"]')),
              t.data("id")
            );
          }),
          (i.prototype.imageZoom = function () {
            var e, t, i, o, n, r, a, s;
            if (((e = this), !1 !== e.root.data("zoom-enabled")))
              return (
                e.image_container.off("click"),
                e.image_container.off("mouseleave.ProductPage.imageZoom"),
                e.zoom_images.css("display", "none"),
                (t = e.zoom_images.filter(
                  '[data-id="' + e.getActiveImageId() + '"]'
                )),
                t.data("aspect-ratio"),
                (r = e.image_container.width()),
                (n = e.image_container.height()),
                t.find(".image--root").css("width", r * e.magnify),
                (o = e.image_container.offset().top),
                (i = e.image_container.offset().left),
                (a = (r * e.magnify - r) / r),
                (s = (n * e.magnify - n) / n),
                e.image_container.on("click", function () {
                  return t.css("display", "block");
                }),
                e.image_container.on(
                  "mouseleave.ProductPage.imageZoom",
                  function () {
                    return t.css("display", "none");
                  }
                ),
                e.image_container.on("mousemove", function (e) {
                  var n, r;
                  return (
                    (n = e.pageX - i),
                    (r = e.pageY - o),
                    t.css({ left: n * -a, top: r * -s })
                  );
                })
              );
          }),
          (i.prototype.resizeListeners = function () {
            var e;
            return (
              (e = this),
              $(window).on(
                "resize.ProductPage",
                theme.utils.debounce(100, function () {
                  return e.imageZoom();
                })
              )
            );
          }),
          (i.prototype.modalCloseListener = function () {
            var e;
            return (
              (e = this),
              $(window).on("FrameworkModal.afterClose", function () {
                return e.imageZoom();
              })
            );
          }),
          (i.prototype.cssGridFallback = function () {
            if ((this, !Modernizr.cssgrid))
              return (
                $(
                  ".product-page--title-n-vendor, .product-page--cart-form-block, .product-page--description"
                ).wrapAll(
                  '<div class="product-page--no-grid--left-column"></div>'
                ),
                $(".product-page--images").wrapAll(
                  '<div class="product-page--no-grid--right-column"></div>'
                )
              );
          }),
          i
        );
      })()),
      (theme.classes.Utils = (function (e) {
        function t() {
          var e;
          (e = this),
            (e.sections = new theme.classes.Sections()),
            (e.mqs = new theme.classes.FrameworkMediaQueries());
        }
        return (
          x(t, e),
          (t.prototype.transparentMenuIsEnabled = function () {
            return c.find("[data-header--menu-transparent=true]").length > 0;
          }),
          (t.prototype.loadJsClasses = function () {
            return $("[data-js-class]").each(function () {
              var e, t;
              if (
                ((e = $(this).attr("data-js-class")),
                "true" !== $(this).attr("data-js-loaded") &&
                  void 0 !== (t = theme.classes[e]))
              )
                return (
                  (theme.partials[e] = new t($(this))),
                  $(this).attr("data-js-loaded", "true")
                );
            });
          }),
          (t.prototype.addSymbol = function (e) {
            return (
              '<svg class="fw--icon fw--icon--' +
              e +
              '"> <use xlink:href="#fw--icon--' +
              e +
              '" /> </svg>'
            );
          }),
          (t.prototype.isIE11 = function () {
            return !(!window.MSInputMethodContext || !document.documentMode);
          }),
          t
        );
      })(theme.classes.FrameworkUtils)),
      (c = null),
      (o = null),
      (g = null),
      (a = null),
      (_ = null),
      (b = null),
      (w = null),
      (y = null),
      (v = ""),
      jQuery(function (m) {
        var k, x, C, S;
        return (
          (c = m("body")),
          (o = m(document)),
          (g = m(window)),
          (a = m(".main-header")),
          (_ = Modernizr.touchevents),
          (b = 768),
          (w = 1280),
          (y = 1440),
          (theme.utils = new theme.classes.Utils()),
          general_external_links_enabled &&
            m('a[href^="http"]')
              .not('a[href^="' + shop_url + '"]')
              .attr("target", "_blank"),
          (window.popup = d),
          new d("popup"),
          new n(m(".footer")),
          new e(),
          new s(),
          new f(),
          (theme.partials.cart = new t()),
          new h(m(".promo-bar")),
          c.hasClass("template-page") &&
            ((C = m(".page-content .rte-content")),
            (C.find(".left-side-column").length ||
              C.find(".right-side-column").length) &&
              (C.find(".left-side-column").length &&
              C.find(".right-side-column").length
                ? (C.wrapInner(
                    "<div class='main-column with-2-sidebars'></div>"
                  ),
                  m(".left-side-column").addClass("with-2-sidebars"),
                  m(".right-side-column").addClass("with-2-sidebars"))
                : C.wrapInner("<div class='main-column'></div>"),
              m(".left-side-column").prependTo(C),
              m(".right-side-column").appendTo(C))),
          c.hasClass("template-index") &&
            (m(".slider").each(function () {
              return new r(m(this).find(".slides"));
            }),
            m(".product-slider").each(function () {
              return new p(m(this));
            })),
          c.hasClass("template-collection") && new i(),
          c.hasClass("template-article") &&
            ((S = m(".social-share .pinterest")),
            (k = m(".article img").first().attr("src")),
            S.attr("href", S.attr("href") + "&media=" + k)),
          m(".section--password").length > 0 && new u(),
          (x = "undefined" != typeof InstallTrigger),
          x && m("img").addClass("image-scale-hack"),
          _ && m("form.custom .hidden-field").removeClass("hidden-field"),
          (v = ""),
          new l(),
          m(".hide-until-js").show(),
          o.on("shopify:section:load", function (e) {
            var t;
            return (
              (t = m(e.target).closest(".shopify-section")),
              t.css("min-height", "2000px"),
              t.hasClass("section--slideshow")
                ? new r(m(e.target).find(".slides"))
                : t.hasClass("section--featured-collection")
                ? new p(m(e.target).find(".product-slider"))
                : t.hasClass("section--header")
                ? (setTimeout(function () {
                    if (m(".slider").length > 0)
                      return o.trigger("header.transparentMenuIsUpdated");
                  }, 0),
                  new h(m(".promo-bar")))
                : t.hasClass("section--products") &&
                  o.trigger("set-option-selectors"),
              t.css("min-height", "auto")
            );
          }),
          o.on("shopify:section:unload", function (e) {
            var t, i;
            if (
              ((i = m(e.target).closest(".shopify-section")),
              i.hasClass("section--featured-collection"))
            )
              return setTimeout(function () {
                if (0 === m(".section--featured-collection").length)
                  return g.off("resize.ProductSlider");
              }, 0);
            if (i.hasClass("section--products")) {
              if (
                ((t = m(".popup-modal-mask")),
                m(".size-chart").remove(),
                t.is(":visible"))
              )
                return t.trigger("click");
            } else if (i.hasClass("section--slideshow"))
              return setTimeout(function () {
                if (0 === m(".slider").length)
                  return o.off("header.transparentMenuIsUpdated");
              }, 0);
          }),
          o.on("shopify:block:select", function (e) {
            var t, i;
            if (
              ((t = m(e.target).closest(".shopify-section")),
              t.hasClass("section--slideshow"))
            )
              return (
                (i = t.find(".slide").index(e.target)),
                m(e.target)
                  .closest(".owl-carousel")
                  .trigger("owl.jumpTo", i)
                  .trigger("owl.stop")
              );
          }),
          o.on("shopify:section:deselect", function (e) {
            var t, i;
            if (
              ((t = m(e.target).closest(".shopify-section")),
              t.hasClass("section--slideshow") &&
                !0 === t.find(".slider").data("autoplay"))
            )
              return (
                (i = t.find(".slides")),
                i.trigger("owl.play", t.find(".slider").data("rotateFrequency"))
              );
          }),
          theme.utils.loadJsClasses(),
          !1
        );
      });
  }.call(this);
